/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateAdministratorInput = {
  id?: string | null,
  username: string,
  status: AdministratorStatusType,
  role: AdministratorRoleType,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  _version?: number | null,
};

export enum AdministratorStatusType {
  Active = "Active",
  InActive = "InActive",
}


export enum AdministratorRoleType {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
}


export type ModelAdministratorConditionInput = {
  username?: ModelStringInput | null,
  status?: ModelAdministratorStatusTypeInput | null,
  role?: ModelAdministratorRoleTypeInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  address?: ModelStringInput | null,
  and?: Array< ModelAdministratorConditionInput | null > | null,
  or?: Array< ModelAdministratorConditionInput | null > | null,
  not?: ModelAdministratorConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelAdministratorStatusTypeInput = {
  eq?: AdministratorStatusType | null,
  ne?: AdministratorStatusType | null,
};

export type ModelAdministratorRoleTypeInput = {
  eq?: AdministratorRoleType | null,
  ne?: AdministratorRoleType | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Administrator = {
  __typename: "Administrator",
  id: string,
  username: string,
  status: AdministratorStatusType,
  role: AdministratorRoleType,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAdministratorInput = {
  id: string,
  username?: string | null,
  status?: AdministratorStatusType | null,
  role?: AdministratorRoleType | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  address?: string | null,
  _version?: number | null,
};

export type DeleteAdministratorInput = {
  id: string,
  _version?: number | null,
};

export type CreateAdministratorApproversInput = {
  id?: string | null,
  userID: string,
  editor: string,
  _version?: number | null,
};

export type ModelAdministratorApproversConditionInput = {
  userID?: ModelStringInput | null,
  editor?: ModelStringInput | null,
  and?: Array< ModelAdministratorApproversConditionInput | null > | null,
  or?: Array< ModelAdministratorApproversConditionInput | null > | null,
  not?: ModelAdministratorApproversConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AdministratorApprovers = {
  __typename: "AdministratorApprovers",
  id: string,
  userID: string,
  editor: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAdministratorApproversInput = {
  id: string,
  userID?: string | null,
  editor?: string | null,
  _version?: number | null,
};

export type DeleteAdministratorApproversInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliateInput = {
  id?: string | null,
  firstName: string,
  middleName?: string | null,
  lastName: string,
  email?: string | null,
  phone?: string | null,
  company?: string | null,
  address?: string | null,
  notes?: string | null,
  code?: string | null,
  status: AffiliateStatusType,
  _version?: number | null,
};

export enum AffiliateStatusType {
  Active = "Active",
  InActive = "InActive",
}


export type ModelAffiliateConditionInput = {
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  company?: ModelStringInput | null,
  address?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  code?: ModelStringInput | null,
  status?: ModelAffiliateStatusTypeInput | null,
  and?: Array< ModelAffiliateConditionInput | null > | null,
  or?: Array< ModelAffiliateConditionInput | null > | null,
  not?: ModelAffiliateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAffiliateStatusTypeInput = {
  eq?: AffiliateStatusType | null,
  ne?: AffiliateStatusType | null,
};

export type Affiliate = {
  __typename: "Affiliate",
  id: string,
  firstName: string,
  middleName?: string | null,
  lastName: string,
  email?: string | null,
  phone?: string | null,
  company?: string | null,
  address?: string | null,
  notes?: string | null,
  code?: string | null,
  status: AffiliateStatusType,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliateInput = {
  id: string,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  company?: string | null,
  address?: string | null,
  notes?: string | null,
  code?: string | null,
  status?: AffiliateStatusType | null,
  _version?: number | null,
};

export type DeleteAffiliateInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliateEarningInput = {
  id?: string | null,
  affiliateID: string,
  linkID: string,
  milestoneKey: string,
  amountCents: number,
  status: AffiliateEarningStatus,
  payoutID?: string | null,
  idempotencyKey: string,
  occurredAt: string,
  _version?: number | null,
};

export enum AffiliateEarningStatus {
  Pending = "Pending",
  Included = "Included",
  Paid = "Paid",
  Void = "Void",
}


export type ModelAffiliateEarningConditionInput = {
  affiliateID?: ModelStringInput | null,
  linkID?: ModelStringInput | null,
  milestoneKey?: ModelStringInput | null,
  amountCents?: ModelIntInput | null,
  status?: ModelAffiliateEarningStatusInput | null,
  payoutID?: ModelStringInput | null,
  idempotencyKey?: ModelStringInput | null,
  occurredAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateEarningConditionInput | null > | null,
  or?: Array< ModelAffiliateEarningConditionInput | null > | null,
  not?: ModelAffiliateEarningConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelAffiliateEarningStatusInput = {
  eq?: AffiliateEarningStatus | null,
  ne?: AffiliateEarningStatus | null,
};

export type AffiliateEarning = {
  __typename: "AffiliateEarning",
  id: string,
  affiliateID: string,
  linkID: string,
  milestoneKey: string,
  amountCents: number,
  status: AffiliateEarningStatus,
  payoutID?: string | null,
  idempotencyKey: string,
  occurredAt: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliateEarningInput = {
  id: string,
  affiliateID?: string | null,
  linkID?: string | null,
  milestoneKey?: string | null,
  amountCents?: number | null,
  status?: AffiliateEarningStatus | null,
  payoutID?: string | null,
  idempotencyKey?: string | null,
  occurredAt?: string | null,
  _version?: number | null,
};

export type DeleteAffiliateEarningInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliateLinkInput = {
  id?: string | null,
  ownerID: string,
  ownerType: OwnerType,
  affiliateID: string,
  affiliateCode: string,
  attributedAt: string,
  migratedToOrganizationID?: string | null,
  createdByUserID?: string | null,
  milestones?: string | null,
  unitCount?: number | null,
  _version?: number | null,
};

export enum OwnerType {
  User = "User",
  Organization = "Organization",
}


export type ModelAffiliateLinkConditionInput = {
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  affiliateID?: ModelStringInput | null,
  affiliateCode?: ModelStringInput | null,
  attributedAt?: ModelStringInput | null,
  migratedToOrganizationID?: ModelStringInput | null,
  createdByUserID?: ModelStringInput | null,
  milestones?: ModelStringInput | null,
  unitCount?: ModelIntInput | null,
  and?: Array< ModelAffiliateLinkConditionInput | null > | null,
  or?: Array< ModelAffiliateLinkConditionInput | null > | null,
  not?: ModelAffiliateLinkConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOwnerTypeInput = {
  eq?: OwnerType | null,
  ne?: OwnerType | null,
};

export type AffiliateLink = {
  __typename: "AffiliateLink",
  id: string,
  ownerID: string,
  ownerType: OwnerType,
  affiliateID: string,
  affiliateCode: string,
  attributedAt: string,
  migratedToOrganizationID?: string | null,
  createdByUserID?: string | null,
  milestones?: string | null,
  unitCount?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliateLinkInput = {
  id: string,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  affiliateID?: string | null,
  affiliateCode?: string | null,
  attributedAt?: string | null,
  migratedToOrganizationID?: string | null,
  createdByUserID?: string | null,
  milestones?: string | null,
  unitCount?: number | null,
  _version?: number | null,
};

export type DeleteAffiliateLinkInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliateMilestoneRateInput = {
  id?: string | null,
  milestoneKey: string,
  amountCents: number,
  affiliateID?: string | null,
  currency?: string | null,
  effectiveFrom?: string | null,
  effectiveTo?: string | null,
  isActive: boolean,
  _version?: number | null,
};

export type ModelAffiliateMilestoneRateConditionInput = {
  milestoneKey?: ModelStringInput | null,
  amountCents?: ModelIntInput | null,
  affiliateID?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  effectiveFrom?: ModelStringInput | null,
  effectiveTo?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  and?: Array< ModelAffiliateMilestoneRateConditionInput | null > | null,
  or?: Array< ModelAffiliateMilestoneRateConditionInput | null > | null,
  not?: ModelAffiliateMilestoneRateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AffiliateMilestoneRate = {
  __typename: "AffiliateMilestoneRate",
  id: string,
  milestoneKey: string,
  amountCents: number,
  affiliateID?: string | null,
  currency?: string | null,
  effectiveFrom?: string | null,
  effectiveTo?: string | null,
  isActive: boolean,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliateMilestoneRateInput = {
  id: string,
  milestoneKey?: string | null,
  amountCents?: number | null,
  affiliateID?: string | null,
  currency?: string | null,
  effectiveFrom?: string | null,
  effectiveTo?: string | null,
  isActive?: boolean | null,
  _version?: number | null,
};

export type DeleteAffiliateMilestoneRateInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliatePayoutInput = {
  id?: string | null,
  affiliateID: string,
  status: AffiliatePayoutStatus,
  grossCents: number,
  generatedAt: string,
  paidAt?: string | null,
  paymentRef?: string | null,
  notes?: string | null,
  _version?: number | null,
};

export enum AffiliatePayoutStatus {
  Draft = "Draft",
  Approved = "Approved",
  Paid = "Paid",
  Canceled = "Canceled",
}


export type ModelAffiliatePayoutConditionInput = {
  affiliateID?: ModelStringInput | null,
  status?: ModelAffiliatePayoutStatusInput | null,
  grossCents?: ModelIntInput | null,
  generatedAt?: ModelStringInput | null,
  paidAt?: ModelStringInput | null,
  paymentRef?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  and?: Array< ModelAffiliatePayoutConditionInput | null > | null,
  or?: Array< ModelAffiliatePayoutConditionInput | null > | null,
  not?: ModelAffiliatePayoutConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAffiliatePayoutStatusInput = {
  eq?: AffiliatePayoutStatus | null,
  ne?: AffiliatePayoutStatus | null,
};

export type AffiliatePayout = {
  __typename: "AffiliatePayout",
  id: string,
  affiliateID: string,
  status: AffiliatePayoutStatus,
  grossCents: number,
  generatedAt: string,
  paidAt?: string | null,
  paymentRef?: string | null,
  notes?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliatePayoutInput = {
  id: string,
  affiliateID?: string | null,
  status?: AffiliatePayoutStatus | null,
  grossCents?: number | null,
  generatedAt?: string | null,
  paidAt?: string | null,
  paymentRef?: string | null,
  notes?: string | null,
  _version?: number | null,
};

export type DeleteAffiliatePayoutInput = {
  id: string,
  _version?: number | null,
};

export type CreateAffiliateVisitInput = {
  id?: string | null,
  affiliateID: string,
  affiliateCode: string,
  visitedAt: string,
  path?: string | null,
  userAgent?: string | null,
  _version?: number | null,
};

export type ModelAffiliateVisitConditionInput = {
  affiliateID?: ModelStringInput | null,
  affiliateCode?: ModelStringInput | null,
  visitedAt?: ModelStringInput | null,
  path?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  and?: Array< ModelAffiliateVisitConditionInput | null > | null,
  or?: Array< ModelAffiliateVisitConditionInput | null > | null,
  not?: ModelAffiliateVisitConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AffiliateVisit = {
  __typename: "AffiliateVisit",
  id: string,
  affiliateID: string,
  affiliateCode: string,
  visitedAt: string,
  path?: string | null,
  userAgent?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAffiliateVisitInput = {
  id: string,
  affiliateID?: string | null,
  affiliateCode?: string | null,
  visitedAt?: string | null,
  path?: string | null,
  userAgent?: string | null,
  _version?: number | null,
};

export type DeleteAffiliateVisitInput = {
  id: string,
  _version?: number | null,
};

export type CreateAmenityInput = {
  id?: string | null,
  propertyID: string,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  reservationRule: ReservationRuleInput,
  description?: string | null,
  rules?: string | null,
  availability?: Array< string | null > | null,
  geolocation?: string | null,
  locationDescription?: string | null,
  buildingID?: string | null,
  images?: Array< string | null > | null,
  lockUnixTTL?: number | null,
  _version?: number | null,
};

export type ReservationRuleInput = {
  policy: AmenityReservationPolicyOptions,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  requiresApproval?: boolean | null,
  maxDuration?: string | null,
  minDuration?: string | null,
  furthestTime?: string | null,
  closestTime?: string | null,
  maxPartySize?: number | null,
  maxRequests?: number | null,
};

export enum AmenityReservationPolicyOptions {
  NotAllowed = "NotAllowed",
  Optional = "Optional",
  Required = "Required",
}


export type ModelAmenityConditionInput = {
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  rules?: ModelStringInput | null,
  availability?: ModelStringInput | null,
  geolocation?: ModelStringInput | null,
  locationDescription?: ModelStringInput | null,
  buildingID?: ModelStringInput | null,
  images?: ModelStringInput | null,
  lockUnixTTL?: ModelIntInput | null,
  and?: Array< ModelAmenityConditionInput | null > | null,
  or?: Array< ModelAmenityConditionInput | null > | null,
  not?: ModelAmenityConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Amenity = {
  __typename: "Amenity",
  id: string,
  propertyID: string,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  reservationRule: ReservationRule,
  description?: string | null,
  rules?: string | null,
  availability?: Array< string | null > | null,
  geolocation?: string | null,
  locationDescription?: string | null,
  buildingID?: string | null,
  images?: Array< string | null > | null,
  lockUnixTTL?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ReservationRule = {
  __typename: "ReservationRule",
  policy: AmenityReservationPolicyOptions,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  requiresApproval?: boolean | null,
  maxDuration?: string | null,
  minDuration?: string | null,
  furthestTime?: string | null,
  closestTime?: string | null,
  maxPartySize?: number | null,
  maxRequests?: number | null,
};

export type UpdateAmenityInput = {
  id: string,
  propertyID?: string | null,
  name?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  reservationRule?: ReservationRuleInput | null,
  description?: string | null,
  rules?: string | null,
  availability?: Array< string | null > | null,
  geolocation?: string | null,
  locationDescription?: string | null,
  buildingID?: string | null,
  images?: Array< string | null > | null,
  lockUnixTTL?: number | null,
  _version?: number | null,
};

export type DeleteAmenityInput = {
  id: string,
  _version?: number | null,
};

export type CreateAmenityReservationInput = {
  id?: string | null,
  amenityID: string,
  tenantID: string,
  startDate: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  details?: string | null,
  status?: AmenityReservationStatus | null,
  statusReason?: string | null,
  endDate: string,
  reviewer?: string | null,
  partySize?: number | null,
  _version?: number | null,
};

export enum AmenityReservationStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Canceled = "Canceled",
}


export type ModelAmenityReservationConditionInput = {
  amenityID?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  details?: ModelStringInput | null,
  status?: ModelAmenityReservationStatusInput | null,
  statusReason?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  reviewer?: ModelStringInput | null,
  partySize?: ModelIntInput | null,
  and?: Array< ModelAmenityReservationConditionInput | null > | null,
  or?: Array< ModelAmenityReservationConditionInput | null > | null,
  not?: ModelAmenityReservationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAmenityReservationStatusInput = {
  eq?: AmenityReservationStatus | null,
  ne?: AmenityReservationStatus | null,
};

export type AmenityReservation = {
  __typename: "AmenityReservation",
  id: string,
  amenityID: string,
  tenantID: string,
  startDate: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  details?: string | null,
  status?: AmenityReservationStatus | null,
  statusReason?: string | null,
  endDate: string,
  reviewer?: string | null,
  partySize?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAmenityReservationInput = {
  id: string,
  amenityID?: string | null,
  tenantID?: string | null,
  startDate?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  details?: string | null,
  status?: AmenityReservationStatus | null,
  statusReason?: string | null,
  endDate?: string | null,
  reviewer?: string | null,
  partySize?: number | null,
  _version?: number | null,
};

export type DeleteAmenityReservationInput = {
  id: string,
  _version?: number | null,
};

export type CreateApplicationInput = {
  id?: string | null,
  status: ApplicationStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  moveInDatePreference?: string | null,
  rentPaymentPreference?: RentPaymentMethodType | null,
  _version?: number | null,
};

export enum ApplicationStatusType {
  Submitted = "Submitted",
  UnderReview = "UnderReview",
  Rejected = "Rejected",
  Approved = "Approved",
}


export enum RentPaymentMethodType {
  BankTransfer = "BankTransfer",
  Card = "Card",
  Check = "Check",
}


export type ModelApplicationConditionInput = {
  status?: ModelApplicationStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  moveInDatePreference?: ModelStringInput | null,
  rentPaymentPreference?: ModelRentPaymentMethodTypeInput | null,
  and?: Array< ModelApplicationConditionInput | null > | null,
  or?: Array< ModelApplicationConditionInput | null > | null,
  not?: ModelApplicationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelApplicationStatusTypeInput = {
  eq?: ApplicationStatusType | null,
  ne?: ApplicationStatusType | null,
};

export type ModelRentPaymentMethodTypeInput = {
  eq?: RentPaymentMethodType | null,
  ne?: RentPaymentMethodType | null,
};

export type Application = {
  __typename: "Application",
  id: string,
  status: ApplicationStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  moveInDatePreference?: string | null,
  rentPaymentPreference?: RentPaymentMethodType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateApplicationInput = {
  id: string,
  status?: ApplicationStatusType | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  moveInDatePreference?: string | null,
  rentPaymentPreference?: RentPaymentMethodType | null,
  _version?: number | null,
};

export type DeleteApplicationInput = {
  id: string,
  _version?: number | null,
};

export type CreateBackgroundCheckInput = {
  id?: string | null,
  status: BackgroundCheckStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  _version?: number | null,
};

export enum BackgroundCheckStatusType {
  Pending = "Pending",
  InProgress = "InProgress",
  Approved = "Approved",
  Rejected = "Rejected",
}


export type ModelBackgroundCheckConditionInput = {
  status?: ModelBackgroundCheckStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  and?: Array< ModelBackgroundCheckConditionInput | null > | null,
  or?: Array< ModelBackgroundCheckConditionInput | null > | null,
  not?: ModelBackgroundCheckConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBackgroundCheckStatusTypeInput = {
  eq?: BackgroundCheckStatusType | null,
  ne?: BackgroundCheckStatusType | null,
};

export type BackgroundCheck = {
  __typename: "BackgroundCheck",
  id: string,
  status: BackgroundCheckStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBackgroundCheckInput = {
  id: string,
  status?: BackgroundCheckStatusType | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  _version?: number | null,
};

export type DeleteBackgroundCheckInput = {
  id: string,
  _version?: number | null,
};

export type CreateBuildingInput = {
  id?: string | null,
  status: BuildingStatusType,
  propertyID: string,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  rent?: number | null,
  price?: number | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  actualRentPaymentDate?: string | null,
  size?: string | null,
  street?: string | null,
  type?: BuildingType | null,
  contact?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export enum BuildingStatusType {
  Occupied = "Occupied",
  Vacant = "Vacant",
  Renovation = "Renovation",
  None = "None",
}


export enum BuildingType {
  Single = "Single",
  Multiple = "Multiple",
}


export type ModelBuildingConditionInput = {
  status?: ModelBuildingStatusTypeInput | null,
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  actualRentPaymentDate?: ModelStringInput | null,
  size?: ModelStringInput | null,
  street?: ModelStringInput | null,
  type?: ModelBuildingTypeInput | null,
  contact?: ModelStringInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  and?: Array< ModelBuildingConditionInput | null > | null,
  or?: Array< ModelBuildingConditionInput | null > | null,
  not?: ModelBuildingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBuildingStatusTypeInput = {
  eq?: BuildingStatusType | null,
  ne?: BuildingStatusType | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBuildingTypeInput = {
  eq?: BuildingType | null,
  ne?: BuildingType | null,
};

export type Building = {
  __typename: "Building",
  id: string,
  status: BuildingStatusType,
  propertyID: string,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  rent?: number | null,
  price?: number | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  actualRentPaymentDate?: string | null,
  size?: string | null,
  street?: string | null,
  type?: BuildingType | null,
  contact?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBuildingInput = {
  id: string,
  status?: BuildingStatusType | null,
  propertyID?: string | null,
  name?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  rent?: number | null,
  price?: number | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  actualRentPaymentDate?: string | null,
  size?: string | null,
  street?: string | null,
  type?: BuildingType | null,
  contact?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export type DeleteBuildingInput = {
  id: string,
  _version?: number | null,
};

export type CreateChargesInput = {
  id?: string | null,
  type: ChargesTypes,
  isRevenue: boolean,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  _version?: number | null,
};

export enum ChargesTypes {
  Fees = "Fees",
  LostRent = "LostRent",
  Reservation = "Reservation",
}


export type ModelChargesConditionInput = {
  type?: ModelChargesTypesInput | null,
  isRevenue?: ModelBooleanInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelChargesConditionInput | null > | null,
  or?: Array< ModelChargesConditionInput | null > | null,
  not?: ModelChargesConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelChargesTypesInput = {
  eq?: ChargesTypes | null,
  ne?: ChargesTypes | null,
};

export type Charges = {
  __typename: "Charges",
  id: string,
  type: ChargesTypes,
  isRevenue: boolean,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateChargesInput = {
  id: string,
  type?: ChargesTypes | null,
  isRevenue?: boolean | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  _version?: number | null,
};

export type DeleteChargesInput = {
  id: string,
  _version?: number | null,
};

export type CreateCommentsInput = {
  id?: string | null,
  commenter: string,
  text: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdDate?: string | null,
  parentID?: string | null,
  type?: string | null,
  _version?: number | null,
};

export type ModelCommentsConditionInput = {
  commenter?: ModelStringInput | null,
  text?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdDate?: ModelStringInput | null,
  parentID?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelCommentsConditionInput | null > | null,
  or?: Array< ModelCommentsConditionInput | null > | null,
  not?: ModelCommentsConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Comments = {
  __typename: "Comments",
  id: string,
  commenter: string,
  text: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdDate?: string | null,
  parentID?: string | null,
  type?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCommentsInput = {
  id: string,
  commenter?: string | null,
  text?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdDate?: string | null,
  parentID?: string | null,
  type?: string | null,
  _version?: number | null,
};

export type DeleteCommentsInput = {
  id: string,
  _version?: number | null,
};

export type CreateEntityFieldInput = {
  id?: string | null,
  entityID: string,
  entityType: string,
  name: string,
  type: EntityFieldType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  value?: string | null,
  date?: string | null,
  _version?: number | null,
};

export enum EntityFieldType {
  File = "File",
  Image = "Image",
}


export type ModelEntityFieldConditionInput = {
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  name?: ModelStringInput | null,
  type?: ModelEntityFieldTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  value?: ModelStringInput | null,
  date?: ModelStringInput | null,
  and?: Array< ModelEntityFieldConditionInput | null > | null,
  or?: Array< ModelEntityFieldConditionInput | null > | null,
  not?: ModelEntityFieldConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEntityFieldTypeInput = {
  eq?: EntityFieldType | null,
  ne?: EntityFieldType | null,
};

export type EntityField = {
  __typename: "EntityField",
  id: string,
  entityID: string,
  entityType: string,
  name: string,
  type: EntityFieldType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  value?: string | null,
  date?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateEntityFieldInput = {
  id: string,
  entityID?: string | null,
  entityType?: string | null,
  name?: string | null,
  type?: EntityFieldType | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  value?: string | null,
  date?: string | null,
  _version?: number | null,
};

export type DeleteEntityFieldInput = {
  id: string,
  _version?: number | null,
};

export type CreateEventInput = {
  id?: string | null,
  entityType: EntityType,
  entityID: string,
  ownerID: string,
  ownerType: OwnerType,
  name: string,
  date?: string | null,
  type?: string | null,
  comment?: string | null,
  _version?: number | null,
};

export enum EntityType {
  Property = "Property",
  Unit = "Unit",
  UnitPlan = "UnitPlan",
  Building = "Building",
  User = "User",
  Tenant = "Tenant",
  ServiceRequest = "ServiceRequest",
  Amenity = "Amenity",
  Transaction = "Transaction",
  Report = "Report",
  Lease = "Lease",
  Parcel = "Parcel",
  Stay = "Stay",
  SaleListing = "SaleListing",
}


export type ModelEventConditionInput = {
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  name?: ModelStringInput | null,
  date?: ModelStringInput | null,
  type?: ModelStringInput | null,
  comment?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEntityTypeInput = {
  eq?: EntityType | null,
  ne?: EntityType | null,
};

export type Event = {
  __typename: "Event",
  id: string,
  entityType: EntityType,
  entityID: string,
  ownerID: string,
  ownerType: OwnerType,
  name: string,
  date?: string | null,
  type?: string | null,
  comment?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateEventInput = {
  id: string,
  entityType?: EntityType | null,
  entityID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  name?: string | null,
  date?: string | null,
  type?: string | null,
  comment?: string | null,
  _version?: number | null,
};

export type DeleteEventInput = {
  id: string,
  _version?: number | null,
};

export type CreateFavoriteInput = {
  id?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  favType?: string | null,
  favID?: string | null,
  image?: string | null,
  name?: string | null,
  _version?: number | null,
};

export type ModelFavoriteConditionInput = {
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  favType?: ModelStringInput | null,
  favID?: ModelStringInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelFavoriteConditionInput | null > | null,
  or?: Array< ModelFavoriteConditionInput | null > | null,
  not?: ModelFavoriteConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Favorite = {
  __typename: "Favorite",
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  favType?: string | null,
  favID?: string | null,
  image?: string | null,
  name?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateFavoriteInput = {
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  favType?: string | null,
  favID?: string | null,
  image?: string | null,
  name?: string | null,
  _version?: number | null,
};

export type DeleteFavoriteInput = {
  id: string,
  _version?: number | null,
};

export type CreateFinanceLockInput = {
  id?: string | null,
  scope: string,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: EntityType | null,
  year: number,
  month?: number | null,
  lockUnixTTL?: number | null,
  _version?: number | null,
};

export type ModelFinanceLockConditionInput = {
  scope?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelEntityTypeInput | null,
  year?: ModelIntInput | null,
  month?: ModelIntInput | null,
  lockUnixTTL?: ModelIntInput | null,
  and?: Array< ModelFinanceLockConditionInput | null > | null,
  or?: Array< ModelFinanceLockConditionInput | null > | null,
  not?: ModelFinanceLockConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type FinanceLock = {
  __typename: "FinanceLock",
  id: string,
  scope: string,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: EntityType | null,
  year: number,
  month?: number | null,
  lockUnixTTL?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateFinanceLockInput = {
  id: string,
  scope?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: EntityType | null,
  year?: number | null,
  month?: number | null,
  lockUnixTTL?: number | null,
  _version?: number | null,
};

export type DeleteFinanceLockInput = {
  id: string,
  _version?: number | null,
};

export type CreateJoinOrganizationRequestInput = {
  id?: string | null,
  userID: string,
  requestStatus: JoinOrganizationRequestStatus,
  organizationID?: string | null,
  requestPropertyTransfer?: boolean | null,
  _version?: number | null,
};

export enum JoinOrganizationRequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Canceled = "Canceled",
}


export type ModelJoinOrganizationRequestConditionInput = {
  userID?: ModelStringInput | null,
  requestStatus?: ModelJoinOrganizationRequestStatusInput | null,
  organizationID?: ModelStringInput | null,
  requestPropertyTransfer?: ModelBooleanInput | null,
  and?: Array< ModelJoinOrganizationRequestConditionInput | null > | null,
  or?: Array< ModelJoinOrganizationRequestConditionInput | null > | null,
  not?: ModelJoinOrganizationRequestConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelJoinOrganizationRequestStatusInput = {
  eq?: JoinOrganizationRequestStatus | null,
  ne?: JoinOrganizationRequestStatus | null,
};

export type JoinOrganizationRequest = {
  __typename: "JoinOrganizationRequest",
  id: string,
  userID: string,
  requestStatus: JoinOrganizationRequestStatus,
  organizationID?: string | null,
  requestPropertyTransfer?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateJoinOrganizationRequestInput = {
  id: string,
  userID?: string | null,
  requestStatus?: JoinOrganizationRequestStatus | null,
  organizationID?: string | null,
  requestPropertyTransfer?: boolean | null,
  _version?: number | null,
};

export type DeleteJoinOrganizationRequestInput = {
  id: string,
  _version?: number | null,
};

export type CreateLeaseInput = {
  id?: string | null,
  entityType: EntityType,
  entityID: string,
  type: LeaseTypeOptions,
  status: LeaseStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  tenantID?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  markedDate?: string | null,
  extraOccupants?: Array< string | null > | null,
  applicationID?: string | null,
  backgroundCheckID?: string | null,
  offerID?: string | null,
  moveInID?: string | null,
  moveOutID?: string | null,
  nextLeaseID?: string | null,
  prevLeaseID?: string | null,
  _version?: number | null,
};

export enum LeaseTypeOptions {
  ThreeYears = "ThreeYears",
  TwoYears = "TwoYears",
  OneYear = "OneYear",
  SixMonths = "SixMonths",
  ThreeMonths = "ThreeMonths",
  Monthly = "Monthly",
}


export enum LeaseStatusType {
  UnderReview = "UnderReview",
  Rejected = "Rejected",
  Active = "Active",
  Expired = "Expired",
  Created = "Created",
  Terminating = "Terminating",
  Terminated = "Terminated",
}


export type ModelLeaseConditionInput = {
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  type?: ModelLeaseTypeOptionsInput | null,
  status?: ModelLeaseStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  tenantID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  markedDate?: ModelStringInput | null,
  extraOccupants?: ModelStringInput | null,
  applicationID?: ModelStringInput | null,
  backgroundCheckID?: ModelStringInput | null,
  offerID?: ModelStringInput | null,
  moveInID?: ModelStringInput | null,
  moveOutID?: ModelStringInput | null,
  nextLeaseID?: ModelStringInput | null,
  prevLeaseID?: ModelStringInput | null,
  and?: Array< ModelLeaseConditionInput | null > | null,
  or?: Array< ModelLeaseConditionInput | null > | null,
  not?: ModelLeaseConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLeaseTypeOptionsInput = {
  eq?: LeaseTypeOptions | null,
  ne?: LeaseTypeOptions | null,
};

export type ModelLeaseStatusTypeInput = {
  eq?: LeaseStatusType | null,
  ne?: LeaseStatusType | null,
};

export type Lease = {
  __typename: "Lease",
  id: string,
  entityType: EntityType,
  entityID: string,
  type: LeaseTypeOptions,
  status: LeaseStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  tenantID?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  markedDate?: string | null,
  extraOccupants?: Array< string | null > | null,
  applicationID?: string | null,
  backgroundCheckID?: string | null,
  offerID?: string | null,
  moveInID?: string | null,
  moveOutID?: string | null,
  nextLeaseID?: string | null,
  prevLeaseID?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateLeaseInput = {
  id: string,
  entityType?: EntityType | null,
  entityID?: string | null,
  type?: LeaseTypeOptions | null,
  status?: LeaseStatusType | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  tenantID?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  markedDate?: string | null,
  extraOccupants?: Array< string | null > | null,
  applicationID?: string | null,
  backgroundCheckID?: string | null,
  offerID?: string | null,
  moveInID?: string | null,
  moveOutID?: string | null,
  nextLeaseID?: string | null,
  prevLeaseID?: string | null,
  _version?: number | null,
};

export type DeleteLeaseInput = {
  id: string,
  _version?: number | null,
};

export type CreateMessageInput = {
  id?: string | null,
  title: string,
  content: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  senderID?: string | null,
  senderName?: string | null,
  receiverID?: string | null,
  receiverName?: string | null,
  messageTitle?: string | null,
  type?: string | null,
  _version?: number | null,
};

export type ModelMessageConditionInput = {
  title?: ModelStringInput | null,
  content?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  senderID?: ModelStringInput | null,
  senderName?: ModelStringInput | null,
  receiverID?: ModelStringInput | null,
  receiverName?: ModelStringInput | null,
  messageTitle?: ModelStringInput | null,
  type?: ModelStringInput | null,
  and?: Array< ModelMessageConditionInput | null > | null,
  or?: Array< ModelMessageConditionInput | null > | null,
  not?: ModelMessageConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Message = {
  __typename: "Message",
  id: string,
  title: string,
  content: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  senderID?: string | null,
  senderName?: string | null,
  receiverID?: string | null,
  receiverName?: string | null,
  messageTitle?: string | null,
  type?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMessageInput = {
  id: string,
  title?: string | null,
  content?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  senderID?: string | null,
  senderName?: string | null,
  receiverID?: string | null,
  receiverName?: string | null,
  messageTitle?: string | null,
  type?: string | null,
  _version?: number | null,
};

export type DeleteMessageInput = {
  id: string,
  _version?: number | null,
};

export type CreateMonthlyFinanceReportInput = {
  id?: string | null,
  yearlyReportId: string,
  month: number,
  year: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatementInput | null,
  _version?: number | null,
};

export type IncomeStatementInput = {
  rentRevenue: number,
  stayRevenue?: number | null,
  feeRevenue: number,
  otherRevenue: number,
  totalRevenue: number,
  repairExpenses: number,
  lostRentExpenses: number,
  renovationExpenses: number,
  totalExpenses: number,
  net: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
};

export type ModelMonthlyFinanceReportConditionInput = {
  yearlyReportId?: ModelStringInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  and?: Array< ModelMonthlyFinanceReportConditionInput | null > | null,
  or?: Array< ModelMonthlyFinanceReportConditionInput | null > | null,
  not?: ModelMonthlyFinanceReportConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type MonthlyFinanceReport = {
  __typename: "MonthlyFinanceReport",
  id: string,
  yearlyReportId: string,
  month: number,
  year: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatement | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type IncomeStatement = {
  __typename: "IncomeStatement",
  rentRevenue: number,
  stayRevenue?: number | null,
  feeRevenue: number,
  otherRevenue: number,
  totalRevenue: number,
  repairExpenses: number,
  lostRentExpenses: number,
  renovationExpenses: number,
  totalExpenses: number,
  net: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
};

export type UpdateMonthlyFinanceReportInput = {
  id: string,
  yearlyReportId?: string | null,
  month?: number | null,
  year?: number | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatementInput | null,
  _version?: number | null,
};

export type DeleteMonthlyFinanceReportInput = {
  id: string,
  _version?: number | null,
};

export type CreateMonthlyStatusReportInput = {
  id?: string | null,
  entityID?: string | null,
  entityType?: string | null,
  month: number,
  year: number,
  numOccupied: number,
  numVacant: number,
  numRenovation: number,
  numUnits: number,
  numBuildings: number,
  numProperties: number,
  numServiceRequests: number,
  numAmenities: number,
  numAmenityReservations: number,
  expectedRent: number,
  expectedStayRevenue?: number | null,
  aggregateIncome: IncomeStatementInput,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type ModelMonthlyStatusReportConditionInput = {
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  numOccupied?: ModelIntInput | null,
  numVacant?: ModelIntInput | null,
  numRenovation?: ModelIntInput | null,
  numUnits?: ModelIntInput | null,
  numBuildings?: ModelIntInput | null,
  numProperties?: ModelIntInput | null,
  numServiceRequests?: ModelIntInput | null,
  numAmenities?: ModelIntInput | null,
  numAmenityReservations?: ModelIntInput | null,
  expectedRent?: ModelIntInput | null,
  expectedStayRevenue?: ModelIntInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  and?: Array< ModelMonthlyStatusReportConditionInput | null > | null,
  or?: Array< ModelMonthlyStatusReportConditionInput | null > | null,
  not?: ModelMonthlyStatusReportConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type MonthlyStatusReport = {
  __typename: "MonthlyStatusReport",
  id: string,
  entityID?: string | null,
  entityType?: string | null,
  month: number,
  year: number,
  numOccupied: number,
  numVacant: number,
  numRenovation: number,
  numUnits: number,
  numBuildings: number,
  numProperties: number,
  numServiceRequests: number,
  numAmenities: number,
  numAmenityReservations: number,
  expectedRent: number,
  expectedStayRevenue?: number | null,
  aggregateIncome: IncomeStatement,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMonthlyStatusReportInput = {
  id: string,
  entityID?: string | null,
  entityType?: string | null,
  month?: number | null,
  year?: number | null,
  numOccupied?: number | null,
  numVacant?: number | null,
  numRenovation?: number | null,
  numUnits?: number | null,
  numBuildings?: number | null,
  numProperties?: number | null,
  numServiceRequests?: number | null,
  numAmenities?: number | null,
  numAmenityReservations?: number | null,
  expectedRent?: number | null,
  expectedStayRevenue?: number | null,
  aggregateIncome?: IncomeStatementInput | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type DeleteMonthlyStatusReportInput = {
  id: string,
  _version?: number | null,
};

export type CreateMoveExamInput = {
  id?: string | null,
  type: MoveExamType,
  status: MoveExamStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  _version?: number | null,
};

export enum MoveExamType {
  IN = "IN",
  OUT = "OUT",
}


export enum MoveExamStatusType {
  Pending = "Pending",
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
}


export type ModelMoveExamConditionInput = {
  type?: ModelMoveExamTypeInput | null,
  status?: ModelMoveExamStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  and?: Array< ModelMoveExamConditionInput | null > | null,
  or?: Array< ModelMoveExamConditionInput | null > | null,
  not?: ModelMoveExamConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelMoveExamTypeInput = {
  eq?: MoveExamType | null,
  ne?: MoveExamType | null,
};

export type ModelMoveExamStatusTypeInput = {
  eq?: MoveExamStatusType | null,
  ne?: MoveExamStatusType | null,
};

export type MoveExam = {
  __typename: "MoveExam",
  id: string,
  type: MoveExamType,
  status: MoveExamStatusType,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMoveExamInput = {
  id: string,
  type?: MoveExamType | null,
  status?: MoveExamStatusType | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  endDate?: string | null,
  _version?: number | null,
};

export type DeleteMoveExamInput = {
  id: string,
  _version?: number | null,
};

export type CreateOfferInput = {
  id?: string | null,
  status: OfferStatusType,
  rent: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  tenantSignDate?: string | null,
  landlordSignDate?: string | null,
  endDate?: string | null,
  rentCycle?: RentCycle | null,
  normalizedAt?: string | null,
  _version?: number | null,
};

export enum OfferStatusType {
  Pending = "Pending",
  InProgress = "InProgress",
  TenantComplete = "TenantComplete",
  LandlordComplete = "LandlordComplete",
  Completed = "Completed",
  Rejected = "Rejected",
  Canceled = "Canceled",
}


export enum RentCycle {
  Anniversary = "Anniversary",
  Calendar = "Calendar",
}


export type ModelOfferConditionInput = {
  status?: ModelOfferStatusTypeInput | null,
  rent?: ModelFloatInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  tenantSignDate?: ModelStringInput | null,
  landlordSignDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  rentCycle?: ModelRentCycleInput | null,
  normalizedAt?: ModelStringInput | null,
  and?: Array< ModelOfferConditionInput | null > | null,
  or?: Array< ModelOfferConditionInput | null > | null,
  not?: ModelOfferConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOfferStatusTypeInput = {
  eq?: OfferStatusType | null,
  ne?: OfferStatusType | null,
};

export type ModelRentCycleInput = {
  eq?: RentCycle | null,
  ne?: RentCycle | null,
};

export type Offer = {
  __typename: "Offer",
  id: string,
  status: OfferStatusType,
  rent: number,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  tenantSignDate?: string | null,
  landlordSignDate?: string | null,
  endDate?: string | null,
  rentCycle?: RentCycle | null,
  normalizedAt?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateOfferInput = {
  id: string,
  status?: OfferStatusType | null,
  rent?: number | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  startDate?: string | null,
  tenantSignDate?: string | null,
  landlordSignDate?: string | null,
  endDate?: string | null,
  rentCycle?: RentCycle | null,
  normalizedAt?: string | null,
  _version?: number | null,
};

export type DeleteOfferInput = {
  id: string,
  _version?: number | null,
};

export type CreateOrganizationInput = {
  id?: string | null,
  name: string,
  _version?: number | null,
};

export type ModelOrganizationConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelOrganizationConditionInput | null > | null,
  or?: Array< ModelOrganizationConditionInput | null > | null,
  not?: ModelOrganizationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Organization = {
  __typename: "Organization",
  id: string,
  name: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateOrganizationInput = {
  id: string,
  name?: string | null,
  _version?: number | null,
};

export type DeleteOrganizationInput = {
  id: string,
  _version?: number | null,
};

export type CreateParcelInput = {
  id?: string | null,
  propertyID: string,
  status: ParcelStatusType,
  name: string,
  description?: string | null,
  areaSize?: string | null,
  boundaryNote?: string | null,
  rent?: number | null,
  price?: number | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export enum ParcelStatusType {
  Occupied = "Occupied",
  Vacant = "Vacant",
  Renovation = "Renovation",
  None = "None",
}


export type ModelParcelConditionInput = {
  propertyID?: ModelStringInput | null,
  status?: ModelParcelStatusTypeInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  areaSize?: ModelStringInput | null,
  boundaryNote?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  and?: Array< ModelParcelConditionInput | null > | null,
  or?: Array< ModelParcelConditionInput | null > | null,
  not?: ModelParcelConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelParcelStatusTypeInput = {
  eq?: ParcelStatusType | null,
  ne?: ParcelStatusType | null,
};

export type Parcel = {
  __typename: "Parcel",
  id: string,
  propertyID: string,
  status: ParcelStatusType,
  name: string,
  description?: string | null,
  areaSize?: string | null,
  boundaryNote?: string | null,
  rent?: number | null,
  price?: number | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateParcelInput = {
  id: string,
  propertyID?: string | null,
  status?: ParcelStatusType | null,
  name?: string | null,
  description?: string | null,
  areaSize?: string | null,
  boundaryNote?: string | null,
  rent?: number | null,
  price?: number | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export type DeleteParcelInput = {
  id: string,
  _version?: number | null,
};

export type CreatePaymentReceiptInput = {
  id?: string | null,
  transactionID: string,
  status: PaymentReceiptStatus,
  failureReason?: string | null,
  s3Key?: string | null,
  s3Keys?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  signedByUserID?: string | null,
  signedByUserName?: string | null,
  generatedAt?: string | null,
  _version?: number | null,
};

export enum PaymentReceiptStatus {
  Pending = "Pending",
  Ready = "Ready",
  Failed = "Failed",
  Error = "Error",
}


export type ModelPaymentReceiptConditionInput = {
  transactionID?: ModelIDInput | null,
  status?: ModelPaymentReceiptStatusInput | null,
  failureReason?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  s3Keys?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  signedByUserID?: ModelStringInput | null,
  signedByUserName?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  and?: Array< ModelPaymentReceiptConditionInput | null > | null,
  or?: Array< ModelPaymentReceiptConditionInput | null > | null,
  not?: ModelPaymentReceiptConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelPaymentReceiptStatusInput = {
  eq?: PaymentReceiptStatus | null,
  ne?: PaymentReceiptStatus | null,
};

export type PaymentReceipt = {
  __typename: "PaymentReceipt",
  id: string,
  transactionID: string,
  status: PaymentReceiptStatus,
  failureReason?: string | null,
  s3Key?: string | null,
  s3Keys?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  signedByUserID?: string | null,
  signedByUserName?: string | null,
  generatedAt?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePaymentReceiptInput = {
  id: string,
  transactionID?: string | null,
  status?: PaymentReceiptStatus | null,
  failureReason?: string | null,
  s3Key?: string | null,
  s3Keys?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  signedByUserID?: string | null,
  signedByUserName?: string | null,
  generatedAt?: string | null,
  _version?: number | null,
};

export type DeletePaymentReceiptInput = {
  id: string,
  _version?: number | null,
};

export type CreatePropertyInput = {
  id?: string | null,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  areaSize?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  zipCode?: string | null,
  contact?: string | null,
  expectedRentPaymentDate?: string | null,
  poBox?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export type ModelPropertyConditionInput = {
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  areaSize?: ModelStringInput | null,
  street?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  country?: ModelStringInput | null,
  zipCode?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  expectedRentPaymentDate?: ModelStringInput | null,
  poBox?: ModelStringInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  and?: Array< ModelPropertyConditionInput | null > | null,
  or?: Array< ModelPropertyConditionInput | null > | null,
  not?: ModelPropertyConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Property = {
  __typename: "Property",
  id: string,
  name: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  areaSize?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  zipCode?: string | null,
  contact?: string | null,
  expectedRentPaymentDate?: string | null,
  poBox?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePropertyInput = {
  id: string,
  name?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  areaSize?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
  zipCode?: string | null,
  contact?: string | null,
  expectedRentPaymentDate?: string | null,
  poBox?: string | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export type DeletePropertyInput = {
  id: string,
  _version?: number | null,
};

export type CreateResourceLifeAccessRightInput = {
  id?: string | null,
  resourceType: EntityType,
  createAccessStatus: ResourceAccessRightStatus,
  createAccessApproverID?: string | null,
  createAccessApprovalDate?: string | null,
  deleteAccessStatus: ResourceAccessRightStatus,
  deleteAccessApproverID?: string | null,
  deleteAccessApprovalDate?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export enum ResourceAccessRightStatus {
  NotGranted = "NotGranted",
  Requested = "Requested",
  Granted = "Granted",
  Revoked = "Revoked",
}


export type ModelResourceLifeAccessRightConditionInput = {
  resourceType?: ModelEntityTypeInput | null,
  createAccessStatus?: ModelResourceAccessRightStatusInput | null,
  createAccessApproverID?: ModelStringInput | null,
  createAccessApprovalDate?: ModelStringInput | null,
  deleteAccessStatus?: ModelResourceAccessRightStatusInput | null,
  deleteAccessApproverID?: ModelStringInput | null,
  deleteAccessApprovalDate?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  and?: Array< ModelResourceLifeAccessRightConditionInput | null > | null,
  or?: Array< ModelResourceLifeAccessRightConditionInput | null > | null,
  not?: ModelResourceLifeAccessRightConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelResourceAccessRightStatusInput = {
  eq?: ResourceAccessRightStatus | null,
  ne?: ResourceAccessRightStatus | null,
};

export type ResourceLifeAccessRight = {
  __typename: "ResourceLifeAccessRight",
  id: string,
  resourceType: EntityType,
  createAccessStatus: ResourceAccessRightStatus,
  createAccessApproverID?: string | null,
  createAccessApprovalDate?: string | null,
  deleteAccessStatus: ResourceAccessRightStatus,
  deleteAccessApproverID?: string | null,
  deleteAccessApprovalDate?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateResourceLifeAccessRightInput = {
  id: string,
  resourceType?: EntityType | null,
  createAccessStatus?: ResourceAccessRightStatus | null,
  createAccessApproverID?: string | null,
  createAccessApprovalDate?: string | null,
  deleteAccessStatus?: ResourceAccessRightStatus | null,
  deleteAccessApproverID?: string | null,
  deleteAccessApprovalDate?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type DeleteResourceLifeAccessRightInput = {
  id: string,
  _version?: number | null,
};

export type CreateResourceUpdateAccessRightInput = {
  id?: string | null,
  resourceType: EntityType,
  resourceID: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  readAccessStatus: ResourceAccessRightStatus,
  readAccessApproverID?: string | null,
  readAccessApprovalDate?: string | null,
  writeAccessStatus: ResourceAccessRightStatus,
  writeAccessApproverID?: string | null,
  writeAccessApprovalDate?: string | null,
  _version?: number | null,
};

export type ModelResourceUpdateAccessRightConditionInput = {
  resourceType?: ModelEntityTypeInput | null,
  resourceID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  readAccessStatus?: ModelResourceAccessRightStatusInput | null,
  readAccessApproverID?: ModelStringInput | null,
  readAccessApprovalDate?: ModelStringInput | null,
  writeAccessStatus?: ModelResourceAccessRightStatusInput | null,
  writeAccessApproverID?: ModelStringInput | null,
  writeAccessApprovalDate?: ModelStringInput | null,
  and?: Array< ModelResourceUpdateAccessRightConditionInput | null > | null,
  or?: Array< ModelResourceUpdateAccessRightConditionInput | null > | null,
  not?: ModelResourceUpdateAccessRightConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ResourceUpdateAccessRight = {
  __typename: "ResourceUpdateAccessRight",
  id: string,
  resourceType: EntityType,
  resourceID: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  readAccessStatus: ResourceAccessRightStatus,
  readAccessApproverID?: string | null,
  readAccessApprovalDate?: string | null,
  writeAccessStatus: ResourceAccessRightStatus,
  writeAccessApproverID?: string | null,
  writeAccessApprovalDate?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateResourceUpdateAccessRightInput = {
  id: string,
  resourceType?: EntityType | null,
  resourceID?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  readAccessStatus?: ResourceAccessRightStatus | null,
  readAccessApproverID?: string | null,
  readAccessApprovalDate?: string | null,
  writeAccessStatus?: ResourceAccessRightStatus | null,
  writeAccessApproverID?: string | null,
  writeAccessApprovalDate?: string | null,
  _version?: number | null,
};

export type DeleteResourceUpdateAccessRightInput = {
  id: string,
  _version?: number | null,
};

export type CreateServiceRequestInput = {
  id?: string | null,
  entityID: string,
  entityType: string,
  creatorID: string,
  description: string,
  title: string,
  type: ServiceRequestType,
  isUpgrade: boolean,
  status: ServiceRequestStatusType,
  emergency: boolean,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  creatorName?: string | null,
  handlerID?: string | null,
  handlerName?: string | null,
  watcherID?: string | null,
  watcherName?: string | null,
  tenantID?: string | null,
  tenantName?: string | null,
  contractor?: string | null,
  dateCreated?: string | null,
  dateUpdated?: string | null,
  estimatedCost?: number | null,
  finalCost?: number | null,
  images?: Array< string | null > | null,
  _version?: number | null,
};

export enum ServiceRequestType {
  Plumbing = "Plumbing",
  Electrical = "Electrical",
  HeatingCooling = "HeatingCooling",
  ApplianceError = "ApplianceError",
  Toilet = "Toilet",
  DoorWindow = "DoorWindow",
  PestControl = "PestControl",
  RoofCeiling = "RoofCeiling",
  GeneralCleaning = "GeneralCleaning",
  ExteriorLawn = "ExteriorLawn",
  Other = "Other",
}


export enum ServiceRequestStatusType {
  Running = "Running",
  Canceled = "Canceled",
  Approved = "Approved",
  Rejected = "Rejected",
  Upvoted = "Upvoted",
}


export type ModelServiceRequestConditionInput = {
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  creatorID?: ModelStringInput | null,
  description?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelServiceRequestTypeInput | null,
  isUpgrade?: ModelBooleanInput | null,
  status?: ModelServiceRequestStatusTypeInput | null,
  emergency?: ModelBooleanInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  creatorName?: ModelStringInput | null,
  handlerID?: ModelStringInput | null,
  handlerName?: ModelStringInput | null,
  watcherID?: ModelStringInput | null,
  watcherName?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  tenantName?: ModelStringInput | null,
  contractor?: ModelStringInput | null,
  dateCreated?: ModelStringInput | null,
  dateUpdated?: ModelStringInput | null,
  estimatedCost?: ModelFloatInput | null,
  finalCost?: ModelFloatInput | null,
  images?: ModelStringInput | null,
  and?: Array< ModelServiceRequestConditionInput | null > | null,
  or?: Array< ModelServiceRequestConditionInput | null > | null,
  not?: ModelServiceRequestConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelServiceRequestTypeInput = {
  eq?: ServiceRequestType | null,
  ne?: ServiceRequestType | null,
};

export type ModelServiceRequestStatusTypeInput = {
  eq?: ServiceRequestStatusType | null,
  ne?: ServiceRequestStatusType | null,
};

export type ServiceRequest = {
  __typename: "ServiceRequest",
  id: string,
  entityID: string,
  entityType: string,
  creatorID: string,
  description: string,
  title: string,
  type: ServiceRequestType,
  isUpgrade: boolean,
  status: ServiceRequestStatusType,
  emergency: boolean,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  creatorName?: string | null,
  handlerID?: string | null,
  handlerName?: string | null,
  watcherID?: string | null,
  watcherName?: string | null,
  tenantID?: string | null,
  tenantName?: string | null,
  contractor?: string | null,
  dateCreated?: string | null,
  dateUpdated?: string | null,
  estimatedCost?: number | null,
  finalCost?: number | null,
  images?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateServiceRequestInput = {
  id: string,
  entityID?: string | null,
  entityType?: string | null,
  creatorID?: string | null,
  description?: string | null,
  title?: string | null,
  type?: ServiceRequestType | null,
  isUpgrade?: boolean | null,
  status?: ServiceRequestStatusType | null,
  emergency?: boolean | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  creatorName?: string | null,
  handlerID?: string | null,
  handlerName?: string | null,
  watcherID?: string | null,
  watcherName?: string | null,
  tenantID?: string | null,
  tenantName?: string | null,
  contractor?: string | null,
  dateCreated?: string | null,
  dateUpdated?: string | null,
  estimatedCost?: number | null,
  finalCost?: number | null,
  images?: Array< string | null > | null,
  _version?: number | null,
};

export type DeleteServiceRequestInput = {
  id: string,
  _version?: number | null,
};

export type CreateStayInput = {
  id?: string | null,
  entityType: EntityType,
  entityID: string,
  checkIn: string,
  checkOut: string,
  status: StayStatusType,
  tenantID: string,
  nightlyRate?: number | null,
  totalAmount?: number | null,
  currency?: string | null,
  notes?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export enum StayStatusType {
  Inquiry = "Inquiry",
  Pending = "Pending",
  Confirmed = "Confirmed",
  CheckedIn = "CheckedIn",
  Completed = "Completed",
  Cancelled = "Cancelled",
  Rejected = "Rejected",
}


export type ModelStayConditionInput = {
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  checkIn?: ModelStringInput | null,
  checkOut?: ModelStringInput | null,
  status?: ModelStayStatusTypeInput | null,
  tenantID?: ModelStringInput | null,
  nightlyRate?: ModelFloatInput | null,
  totalAmount?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  and?: Array< ModelStayConditionInput | null > | null,
  or?: Array< ModelStayConditionInput | null > | null,
  not?: ModelStayConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStayStatusTypeInput = {
  eq?: StayStatusType | null,
  ne?: StayStatusType | null,
};

export type Stay = {
  __typename: "Stay",
  id: string,
  entityType: EntityType,
  entityID: string,
  checkIn: string,
  checkOut: string,
  status: StayStatusType,
  tenantID: string,
  nightlyRate?: number | null,
  totalAmount?: number | null,
  currency?: string | null,
  notes?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateStayInput = {
  id: string,
  entityType?: EntityType | null,
  entityID?: string | null,
  checkIn?: string | null,
  checkOut?: string | null,
  status?: StayStatusType | null,
  tenantID?: string | null,
  nightlyRate?: number | null,
  totalAmount?: number | null,
  currency?: string | null,
  notes?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type DeleteStayInput = {
  id: string,
  _version?: number | null,
};

export type CreateStayRateInput = {
  id?: string | null,
  entityType: EntityType,
  entityID: string,
  nightlyRate: number,
  weeklyRate?: number | null,
  minNights?: number | null,
  maxNights?: number | null,
  cleaningFee?: number | null,
  currency?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type ModelStayRateConditionInput = {
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  nightlyRate?: ModelFloatInput | null,
  weeklyRate?: ModelFloatInput | null,
  minNights?: ModelIntInput | null,
  maxNights?: ModelIntInput | null,
  cleaningFee?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  and?: Array< ModelStayRateConditionInput | null > | null,
  or?: Array< ModelStayRateConditionInput | null > | null,
  not?: ModelStayRateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type StayRate = {
  __typename: "StayRate",
  id: string,
  entityType: EntityType,
  entityID: string,
  nightlyRate: number,
  weeklyRate?: number | null,
  minNights?: number | null,
  maxNights?: number | null,
  cleaningFee?: number | null,
  currency?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateStayRateInput = {
  id: string,
  entityType?: EntityType | null,
  entityID?: string | null,
  nightlyRate?: number | null,
  weeklyRate?: number | null,
  minNights?: number | null,
  maxNights?: number | null,
  cleaningFee?: number | null,
  currency?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type DeleteStayRateInput = {
  id: string,
  _version?: number | null,
};

export type CreateStayAvailabilityInput = {
  id?: string | null,
  entityType: EntityType,
  entityID: string,
  start: string,
  end: string,
  reason?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type ModelStayAvailabilityConditionInput = {
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  reason?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  and?: Array< ModelStayAvailabilityConditionInput | null > | null,
  or?: Array< ModelStayAvailabilityConditionInput | null > | null,
  not?: ModelStayAvailabilityConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type StayAvailability = {
  __typename: "StayAvailability",
  id: string,
  entityType: EntityType,
  entityID: string,
  start: string,
  end: string,
  reason?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateStayAvailabilityInput = {
  id: string,
  entityType?: EntityType | null,
  entityID?: string | null,
  start?: string | null,
  end?: string | null,
  reason?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  _version?: number | null,
};

export type DeleteStayAvailabilityInput = {
  id: string,
  _version?: number | null,
};

export type CreateSubscriptionDiscountInput = {
  id?: string | null,
  planID: string,
  startDate: string,
  endDate: string,
  percentage: number,
  isActive: boolean,
  codeID?: string | null,
  _version?: number | null,
};

export type ModelSubscriptionDiscountConditionInput = {
  planID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  percentage?: ModelFloatInput | null,
  isActive?: ModelBooleanInput | null,
  codeID?: ModelStringInput | null,
  and?: Array< ModelSubscriptionDiscountConditionInput | null > | null,
  or?: Array< ModelSubscriptionDiscountConditionInput | null > | null,
  not?: ModelSubscriptionDiscountConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SubscriptionDiscount = {
  __typename: "SubscriptionDiscount",
  id: string,
  planID: string,
  startDate: string,
  endDate: string,
  percentage: number,
  isActive: boolean,
  codeID?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSubscriptionDiscountInput = {
  id: string,
  planID?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  percentage?: number | null,
  isActive?: boolean | null,
  codeID?: string | null,
  _version?: number | null,
};

export type DeleteSubscriptionDiscountInput = {
  id: string,
  _version?: number | null,
};

export type CreateSubscriptionDiscountCodeInput = {
  id?: string | null,
  code: string,
  userID?: string | null,
  usageCount?: number | null,
  _version?: number | null,
};

export type ModelSubscriptionDiscountCodeConditionInput = {
  code?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  usageCount?: ModelIntInput | null,
  and?: Array< ModelSubscriptionDiscountCodeConditionInput | null > | null,
  or?: Array< ModelSubscriptionDiscountCodeConditionInput | null > | null,
  not?: ModelSubscriptionDiscountCodeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SubscriptionDiscountCode = {
  __typename: "SubscriptionDiscountCode",
  id: string,
  code: string,
  userID?: string | null,
  usageCount?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSubscriptionDiscountCodeInput = {
  id: string,
  code?: string | null,
  userID?: string | null,
  usageCount?: number | null,
  _version?: number | null,
};

export type DeleteSubscriptionDiscountCodeInput = {
  id: string,
  _version?: number | null,
};

export type CreateSubscriptionLinkInput = {
  id?: string | null,
  userID: string,
  planID: string,
  startDate: string,
  endDate: string,
  renewalType: SubscriptionRenewalType,
  autoRenewal: boolean,
  nextPaymentAmount: number,
  _version?: number | null,
};

export enum SubscriptionRenewalType {
  Monthly = "Monthly",
  Yearly = "Yearly",
  None = "None",
}


export type ModelSubscriptionLinkConditionInput = {
  userID?: ModelStringInput | null,
  planID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  renewalType?: ModelSubscriptionRenewalTypeInput | null,
  autoRenewal?: ModelBooleanInput | null,
  nextPaymentAmount?: ModelFloatInput | null,
  and?: Array< ModelSubscriptionLinkConditionInput | null > | null,
  or?: Array< ModelSubscriptionLinkConditionInput | null > | null,
  not?: ModelSubscriptionLinkConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSubscriptionRenewalTypeInput = {
  eq?: SubscriptionRenewalType | null,
  ne?: SubscriptionRenewalType | null,
};

export type SubscriptionLink = {
  __typename: "SubscriptionLink",
  id: string,
  userID: string,
  planID: string,
  startDate: string,
  endDate: string,
  renewalType: SubscriptionRenewalType,
  autoRenewal: boolean,
  nextPaymentAmount: number,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSubscriptionLinkInput = {
  id: string,
  userID?: string | null,
  planID?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  renewalType?: SubscriptionRenewalType | null,
  autoRenewal?: boolean | null,
  nextPaymentAmount?: number | null,
  _version?: number | null,
};

export type DeleteSubscriptionLinkInput = {
  id: string,
  _version?: number | null,
};

export type CreateSubscriptionPlanInput = {
  id?: string | null,
  name: string,
  description: string,
  price: number,
  isActive: boolean,
  features: Array< SubscriptionPlanFeature | null >,
  _version?: number | null,
};

export enum SubscriptionPlanFeature {
  UnitManagement = "UnitManagement",
  UnitPublishing = "UnitPublishing",
  RequestManagement = "RequestManagement",
  FinanceReporting = "FinanceReporting",
}


export type ModelSubscriptionPlanConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  isActive?: ModelBooleanInput | null,
  features?: ModelSubscriptionPlanFeatureInput | null,
  and?: Array< ModelSubscriptionPlanConditionInput | null > | null,
  or?: Array< ModelSubscriptionPlanConditionInput | null > | null,
  not?: ModelSubscriptionPlanConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSubscriptionPlanFeatureInput = {
  eq?: SubscriptionPlanFeature | null,
  ne?: SubscriptionPlanFeature | null,
};

export type SubscriptionPlan = {
  __typename: "SubscriptionPlan",
  id: string,
  name: string,
  description: string,
  price: number,
  isActive: boolean,
  features: Array< SubscriptionPlanFeature | null >,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSubscriptionPlanInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  price?: number | null,
  isActive?: boolean | null,
  features?: Array< SubscriptionPlanFeature | null > | null,
  _version?: number | null,
};

export type DeleteSubscriptionPlanInput = {
  id: string,
  _version?: number | null,
};

export type CreateTenantInput = {
  id?: string | null,
  authUID?: string | null,
  username?: string | null,
  firstName: string,
  middleName?: string | null,
  lastName: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  status?: TenantStatusType | null,
  type?: TenantType | null,
  phoneNumber?: string | null,
  jobTitle?: string | null,
  jobPhone?: string | null,
  jobEmail?: string | null,
  jobContactName?: string | null,
  income?: string | null,
  cimesCommitted?: string | null,
  jailTime?: string | null,
  lastArrest?: string | null,
  lastUpdated?: string | null,
  totalCredit?: string | null,
  employer?: string | null,
  email?: string | null,
  _version?: number | null,
};

export enum TenantStatusType {
  Active = "Active",
  InActive = "InActive",
}


export enum TenantType {
  ShadowTenant = "ShadowTenant",
  AuthenticatedTenant = "AuthenticatedTenant",
}


export type ModelTenantConditionInput = {
  authUID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  status?: ModelTenantStatusTypeInput | null,
  type?: ModelTenantTypeInput | null,
  phoneNumber?: ModelStringInput | null,
  jobTitle?: ModelStringInput | null,
  jobPhone?: ModelStringInput | null,
  jobEmail?: ModelStringInput | null,
  jobContactName?: ModelStringInput | null,
  income?: ModelStringInput | null,
  cimesCommitted?: ModelStringInput | null,
  jailTime?: ModelStringInput | null,
  lastArrest?: ModelStringInput | null,
  lastUpdated?: ModelStringInput | null,
  totalCredit?: ModelStringInput | null,
  employer?: ModelStringInput | null,
  email?: ModelStringInput | null,
  and?: Array< ModelTenantConditionInput | null > | null,
  or?: Array< ModelTenantConditionInput | null > | null,
  not?: ModelTenantConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTenantStatusTypeInput = {
  eq?: TenantStatusType | null,
  ne?: TenantStatusType | null,
};

export type ModelTenantTypeInput = {
  eq?: TenantType | null,
  ne?: TenantType | null,
};

export type Tenant = {
  __typename: "Tenant",
  id: string,
  authUID?: string | null,
  username?: string | null,
  firstName: string,
  middleName?: string | null,
  lastName: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  status?: TenantStatusType | null,
  type?: TenantType | null,
  phoneNumber?: string | null,
  jobTitle?: string | null,
  jobPhone?: string | null,
  jobEmail?: string | null,
  jobContactName?: string | null,
  income?: string | null,
  cimesCommitted?: string | null,
  jailTime?: string | null,
  lastArrest?: string | null,
  lastUpdated?: string | null,
  totalCredit?: string | null,
  employer?: string | null,
  email?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTenantInput = {
  id: string,
  authUID?: string | null,
  username?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  status?: TenantStatusType | null,
  type?: TenantType | null,
  phoneNumber?: string | null,
  jobTitle?: string | null,
  jobPhone?: string | null,
  jobEmail?: string | null,
  jobContactName?: string | null,
  income?: string | null,
  cimesCommitted?: string | null,
  jailTime?: string | null,
  lastArrest?: string | null,
  lastUpdated?: string | null,
  totalCredit?: string | null,
  employer?: string | null,
  email?: string | null,
  _version?: number | null,
};

export type DeleteTenantInput = {
  id: string,
  _version?: number | null,
};

export type CreateTransactionInput = {
  id?: string | null,
  amount: number,
  reason: TransactionReason,
  currency?: string | null,
  entityID: string,
  entityType: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  month: number,
  year: number,
  periodStart?: string | null,
  periodEnd?: string | null,
  tenantID: string,
  managerID: string,
  status: PaymentStatusType,
  dateSent?: string | null,
  dateReceived?: string | null,
  paymentMethod?: RentPaymentMethodType | null,
  _version?: number | null,
};

export enum TransactionReason {
  Rent = "Rent",
  Deposit = "Deposit",
  Fee = "Fee",
  UtilityWater = "UtilityWater",
  UtilityElectricity = "UtilityElectricity",
  UtilityGas = "UtilityGas",
  UtilityInternet = "UtilityInternet",
  UtilityCable = "UtilityCable",
  UtilityPhone = "UtilityPhone",
  UtilityOther = "UtilityOther",
  OtherPayment = "OtherPayment",
  DepositRefund = "DepositRefund",
  OtherRefund = "OtherRefund",
  Stay = "Stay",
}


export enum PaymentStatusType {
  Pending = "Pending",
  Processing = "Processing",
  Complete = "Complete",
  Failed = "Failed",
}


export type ModelTransactionConditionInput = {
  amount?: ModelFloatInput | null,
  reason?: ModelTransactionReasonInput | null,
  currency?: ModelStringInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  periodStart?: ModelStringInput | null,
  periodEnd?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  managerID?: ModelStringInput | null,
  status?: ModelPaymentStatusTypeInput | null,
  dateSent?: ModelStringInput | null,
  dateReceived?: ModelStringInput | null,
  paymentMethod?: ModelRentPaymentMethodTypeInput | null,
  and?: Array< ModelTransactionConditionInput | null > | null,
  or?: Array< ModelTransactionConditionInput | null > | null,
  not?: ModelTransactionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTransactionReasonInput = {
  eq?: TransactionReason | null,
  ne?: TransactionReason | null,
};

export type ModelPaymentStatusTypeInput = {
  eq?: PaymentStatusType | null,
  ne?: PaymentStatusType | null,
};

export type Transaction = {
  __typename: "Transaction",
  id: string,
  amount: number,
  reason: TransactionReason,
  currency?: string | null,
  entityID: string,
  entityType: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  month: number,
  year: number,
  periodStart?: string | null,
  periodEnd?: string | null,
  tenantID: string,
  managerID: string,
  status: PaymentStatusType,
  dateSent?: string | null,
  dateReceived?: string | null,
  paymentMethod?: RentPaymentMethodType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTransactionInput = {
  id: string,
  amount?: number | null,
  reason?: TransactionReason | null,
  currency?: string | null,
  entityID?: string | null,
  entityType?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  month?: number | null,
  year?: number | null,
  periodStart?: string | null,
  periodEnd?: string | null,
  tenantID?: string | null,
  managerID?: string | null,
  status?: PaymentStatusType | null,
  dateSent?: string | null,
  dateReceived?: string | null,
  paymentMethod?: RentPaymentMethodType | null,
  _version?: number | null,
};

export type DeleteTransactionInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitPlanInput = {
  id?: string | null,
  propertyID: string,
  name: string,
  description?: string | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  size?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  _version?: number | null,
};

export type ModelUnitPlanConditionInput = {
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  size?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  inUnitLaundry?: ModelBooleanInput | null,
  dishwasher?: ModelBooleanInput | null,
  airConditioning?: ModelBooleanInput | null,
  furnished?: ModelBooleanInput | null,
  balcony?: ModelBooleanInput | null,
  petFriendly?: ModelBooleanInput | null,
  and?: Array< ModelUnitPlanConditionInput | null > | null,
  or?: Array< ModelUnitPlanConditionInput | null > | null,
  not?: ModelUnitPlanConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UnitPlan = {
  __typename: "UnitPlan",
  id: string,
  propertyID: string,
  name: string,
  description?: string | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  size?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUnitPlanInput = {
  id: string,
  propertyID?: string | null,
  name?: string | null,
  description?: string | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  size?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  _version?: number | null,
};

export type DeleteUnitPlanInput = {
  id: string,
  _version?: number | null,
};

export type CreateUnitInput = {
  id?: string | null,
  status: UnitStatusType,
  name: string,
  rent: number,
  price?: number | null,
  numBedroom: string,
  numBathroom: string,
  buildingID: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  availabilityDate?: string | null,
  actualRentPaymentDate?: string | null,
  activeLeaseID?: string | null,
  type?: string | null,
  unitPlanID?: string | null,
  size?: string | null,
  street?: string | null,
  deposit?: number | null,
  additionalFees?: number | null,
  feesDescription?: string | null,
  tenantID?: string | null,
  contact?: string | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export enum UnitStatusType {
  Occupied = "Occupied",
  Vacant = "Vacant",
  Renovation = "Renovation",
  None = "None",
}


export type ModelUnitConditionInput = {
  status?: ModelUnitStatusTypeInput | null,
  name?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  buildingID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  availabilityDate?: ModelStringInput | null,
  actualRentPaymentDate?: ModelStringInput | null,
  activeLeaseID?: ModelStringInput | null,
  type?: ModelStringInput | null,
  unitPlanID?: ModelStringInput | null,
  size?: ModelStringInput | null,
  street?: ModelStringInput | null,
  deposit?: ModelFloatInput | null,
  additionalFees?: ModelFloatInput | null,
  feesDescription?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  inUnitLaundry?: ModelBooleanInput | null,
  dishwasher?: ModelBooleanInput | null,
  airConditioning?: ModelBooleanInput | null,
  furnished?: ModelBooleanInput | null,
  balcony?: ModelBooleanInput | null,
  petFriendly?: ModelBooleanInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  and?: Array< ModelUnitConditionInput | null > | null,
  or?: Array< ModelUnitConditionInput | null > | null,
  not?: ModelUnitConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelUnitStatusTypeInput = {
  eq?: UnitStatusType | null,
  ne?: UnitStatusType | null,
};

export type Unit = {
  __typename: "Unit",
  id: string,
  status: UnitStatusType,
  name: string,
  rent: number,
  price?: number | null,
  numBedroom: string,
  numBathroom: string,
  buildingID: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  availabilityDate?: string | null,
  actualRentPaymentDate?: string | null,
  activeLeaseID?: string | null,
  type?: string | null,
  unitPlanID?: string | null,
  size?: string | null,
  street?: string | null,
  deposit?: number | null,
  additionalFees?: number | null,
  feesDescription?: string | null,
  tenantID?: string | null,
  contact?: string | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUnitInput = {
  id: string,
  status?: UnitStatusType | null,
  name?: string | null,
  rent?: number | null,
  price?: number | null,
  numBedroom?: string | null,
  numBathroom?: string | null,
  buildingID?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  description?: string | null,
  availabilityDate?: string | null,
  actualRentPaymentDate?: string | null,
  activeLeaseID?: string | null,
  type?: string | null,
  unitPlanID?: string | null,
  size?: string | null,
  street?: string | null,
  deposit?: number | null,
  additionalFees?: number | null,
  feesDescription?: string | null,
  tenantID?: string | null,
  contact?: string | null,
  inUnitLaundry?: boolean | null,
  dishwasher?: boolean | null,
  airConditioning?: boolean | null,
  furnished?: boolean | null,
  balcony?: boolean | null,
  petFriendly?: boolean | null,
  shortTermStayEnabled?: boolean | null,
  forSaleEnabled?: boolean | null,
  stayRequireApproval?: boolean | null,
  _version?: number | null,
};

export type DeleteUnitInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserInput = {
  id?: string | null,
  authUID?: string | null,
  username?: string | null,
  title?: string | null,
  type?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  salary?: string | null,
  companyName?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  officeAddress?: string | null,
  workingHours?: Array< string | null > | null,
  roles?: ManagerRolesType | null,
  organizationID?: string | null,
  _version?: number | null,
};

export enum ManagerRolesType {
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  Manager = "Manager",
  Accountant = "Accountant",
  MaintenanceStaff = "MaintenanceStaff",
}


export type ModelUserConditionInput = {
  authUID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  salary?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  email?: ModelStringInput | null,
  officeAddress?: ModelStringInput | null,
  workingHours?: ModelStringInput | null,
  roles?: ModelManagerRolesTypeInput | null,
  organizationID?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelManagerRolesTypeInput = {
  eq?: ManagerRolesType | null,
  ne?: ManagerRolesType | null,
};

export type User = {
  __typename: "User",
  id: string,
  authUID?: string | null,
  username?: string | null,
  title?: string | null,
  type?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  salary?: string | null,
  companyName?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  officeAddress?: string | null,
  workingHours?: Array< string | null > | null,
  roles?: ManagerRolesType | null,
  organizationID?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserInput = {
  id: string,
  authUID?: string | null,
  username?: string | null,
  title?: string | null,
  type?: string | null,
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  salary?: string | null,
  companyName?: string | null,
  phoneNumber?: string | null,
  email?: string | null,
  officeAddress?: string | null,
  workingHours?: Array< string | null > | null,
  roles?: ManagerRolesType | null,
  organizationID?: string | null,
  _version?: number | null,
};

export type DeleteUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserOrganizationConnectionInput = {
  id?: string | null,
  userID?: string | null,
  username?: string | null,
  creatorID?: string | null,
  creatorName?: string | null,
  organizationID?: string | null,
  managerID?: string | null,
  managerName?: string | null,
  title?: string | null,
  salary?: string | null,
  ownershipType?: string | null,
  clearanceLevel?: string | null,
  joinedDate?: string | null,
  _version?: number | null,
};

export type ModelUserOrganizationConnectionConditionInput = {
  userID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  creatorID?: ModelStringInput | null,
  creatorName?: ModelStringInput | null,
  organizationID?: ModelStringInput | null,
  managerID?: ModelStringInput | null,
  managerName?: ModelStringInput | null,
  title?: ModelStringInput | null,
  salary?: ModelStringInput | null,
  ownershipType?: ModelStringInput | null,
  clearanceLevel?: ModelStringInput | null,
  joinedDate?: ModelStringInput | null,
  and?: Array< ModelUserOrganizationConnectionConditionInput | null > | null,
  or?: Array< ModelUserOrganizationConnectionConditionInput | null > | null,
  not?: ModelUserOrganizationConnectionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UserOrganizationConnection = {
  __typename: "UserOrganizationConnection",
  id: string,
  userID?: string | null,
  username?: string | null,
  creatorID?: string | null,
  creatorName?: string | null,
  organizationID?: string | null,
  managerID?: string | null,
  managerName?: string | null,
  title?: string | null,
  salary?: string | null,
  ownershipType?: string | null,
  clearanceLevel?: string | null,
  joinedDate?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserOrganizationConnectionInput = {
  id: string,
  userID?: string | null,
  username?: string | null,
  creatorID?: string | null,
  creatorName?: string | null,
  organizationID?: string | null,
  managerID?: string | null,
  managerName?: string | null,
  title?: string | null,
  salary?: string | null,
  ownershipType?: string | null,
  clearanceLevel?: string | null,
  joinedDate?: string | null,
  _version?: number | null,
};

export type DeleteUserOrganizationConnectionInput = {
  id: string,
  _version?: number | null,
};

export type CreateYearlyReportSummaryInput = {
  id?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  year: number,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatementInput | null,
  _version?: number | null,
};

export type ModelYearlyReportSummaryConditionInput = {
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  year?: ModelIntInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  and?: Array< ModelYearlyReportSummaryConditionInput | null > | null,
  or?: Array< ModelYearlyReportSummaryConditionInput | null > | null,
  not?: ModelYearlyReportSummaryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type YearlyReportSummary = {
  __typename: "YearlyReportSummary",
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  year: number,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatement | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateYearlyReportSummaryInput = {
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  year?: number | null,
  entityID?: string | null,
  entityType?: string | null,
  income?: IncomeStatementInput | null,
  _version?: number | null,
};

export type DeleteYearlyReportSummaryInput = {
  id: string,
  _version?: number | null,
};

export type CreateYearlyStatusSummaryInput = {
  id?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  year: number,
  numOccupied: number,
  numVacant: number,
  numRenovation: number,
  numUnits: number,
  numBuildings: number,
  numProperties: number,
  numServiceRequests: number,
  numAmenities: number,
  numAmenityReservations: number,
  expectedRent: number,
  expectedStayRevenue?: number | null,
  aggregateIncome: IncomeStatementInput,
  _version?: number | null,
};

export type ModelYearlyStatusSummaryConditionInput = {
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  year?: ModelIntInput | null,
  numOccupied?: ModelIntInput | null,
  numVacant?: ModelIntInput | null,
  numRenovation?: ModelIntInput | null,
  numUnits?: ModelIntInput | null,
  numBuildings?: ModelIntInput | null,
  numProperties?: ModelIntInput | null,
  numServiceRequests?: ModelIntInput | null,
  numAmenities?: ModelIntInput | null,
  numAmenityReservations?: ModelIntInput | null,
  expectedRent?: ModelIntInput | null,
  expectedStayRevenue?: ModelIntInput | null,
  and?: Array< ModelYearlyStatusSummaryConditionInput | null > | null,
  or?: Array< ModelYearlyStatusSummaryConditionInput | null > | null,
  not?: ModelYearlyStatusSummaryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type YearlyStatusSummary = {
  __typename: "YearlyStatusSummary",
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  year: number,
  numOccupied: number,
  numVacant: number,
  numRenovation: number,
  numUnits: number,
  numBuildings: number,
  numProperties: number,
  numServiceRequests: number,
  numAmenities: number,
  numAmenityReservations: number,
  expectedRent: number,
  expectedStayRevenue?: number | null,
  aggregateIncome: IncomeStatement,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateYearlyStatusSummaryInput = {
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  entityID?: string | null,
  entityType?: string | null,
  year?: number | null,
  numOccupied?: number | null,
  numVacant?: number | null,
  numRenovation?: number | null,
  numUnits?: number | null,
  numBuildings?: number | null,
  numProperties?: number | null,
  numServiceRequests?: number | null,
  numAmenities?: number | null,
  numAmenityReservations?: number | null,
  expectedRent?: number | null,
  expectedStayRevenue?: number | null,
  aggregateIncome?: IncomeStatementInput | null,
  _version?: number | null,
};

export type DeleteYearlyStatusSummaryInput = {
  id: string,
  _version?: number | null,
};

export type CreateYearRecordsInput = {
  id?: string | null,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  years?: Array< number | null > | null,
  _version?: number | null,
};

export type ModelYearRecordsConditionInput = {
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  years?: ModelIntInput | null,
  and?: Array< ModelYearRecordsConditionInput | null > | null,
  or?: Array< ModelYearRecordsConditionInput | null > | null,
  not?: ModelYearRecordsConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type YearRecords = {
  __typename: "YearRecords",
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  years?: Array< number | null > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateYearRecordsInput = {
  id: string,
  userID?: string | null,
  ownerID?: string | null,
  ownerType?: OwnerType | null,
  years?: Array< number | null > | null,
  _version?: number | null,
};

export type DeleteYearRecordsInput = {
  id: string,
  _version?: number | null,
};

export type ModelAdministratorFilterInput = {
  id?: ModelIDInput | null,
  username?: ModelStringInput | null,
  status?: ModelAdministratorStatusTypeInput | null,
  role?: ModelAdministratorRoleTypeInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  address?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAdministratorFilterInput | null > | null,
  or?: Array< ModelAdministratorFilterInput | null > | null,
  not?: ModelAdministratorFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdministratorConnection = {
  __typename: "ModelAdministratorConnection",
  items:  Array<Administrator | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAdministratorApproversFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  editor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAdministratorApproversFilterInput | null > | null,
  or?: Array< ModelAdministratorApproversFilterInput | null > | null,
  not?: ModelAdministratorApproversFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdministratorApproversConnection = {
  __typename: "ModelAdministratorApproversConnection",
  items:  Array<AdministratorApprovers | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliateFilterInput = {
  id?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  company?: ModelStringInput | null,
  address?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  code?: ModelStringInput | null,
  status?: ModelAffiliateStatusTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateFilterInput | null > | null,
  or?: Array< ModelAffiliateFilterInput | null > | null,
  not?: ModelAffiliateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliateConnection = {
  __typename: "ModelAffiliateConnection",
  items:  Array<Affiliate | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliateEarningFilterInput = {
  id?: ModelIDInput | null,
  affiliateID?: ModelStringInput | null,
  linkID?: ModelStringInput | null,
  milestoneKey?: ModelStringInput | null,
  amountCents?: ModelIntInput | null,
  status?: ModelAffiliateEarningStatusInput | null,
  payoutID?: ModelStringInput | null,
  idempotencyKey?: ModelStringInput | null,
  occurredAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateEarningFilterInput | null > | null,
  or?: Array< ModelAffiliateEarningFilterInput | null > | null,
  not?: ModelAffiliateEarningFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliateEarningConnection = {
  __typename: "ModelAffiliateEarningConnection",
  items:  Array<AffiliateEarning | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliateLinkFilterInput = {
  id?: ModelIDInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  affiliateID?: ModelStringInput | null,
  affiliateCode?: ModelStringInput | null,
  attributedAt?: ModelStringInput | null,
  migratedToOrganizationID?: ModelStringInput | null,
  createdByUserID?: ModelStringInput | null,
  milestones?: ModelStringInput | null,
  unitCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateLinkFilterInput | null > | null,
  or?: Array< ModelAffiliateLinkFilterInput | null > | null,
  not?: ModelAffiliateLinkFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliateLinkConnection = {
  __typename: "ModelAffiliateLinkConnection",
  items:  Array<AffiliateLink | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliateMilestoneRateFilterInput = {
  id?: ModelIDInput | null,
  milestoneKey?: ModelStringInput | null,
  amountCents?: ModelIntInput | null,
  affiliateID?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  effectiveFrom?: ModelStringInput | null,
  effectiveTo?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateMilestoneRateFilterInput | null > | null,
  or?: Array< ModelAffiliateMilestoneRateFilterInput | null > | null,
  not?: ModelAffiliateMilestoneRateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliateMilestoneRateConnection = {
  __typename: "ModelAffiliateMilestoneRateConnection",
  items:  Array<AffiliateMilestoneRate | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliatePayoutFilterInput = {
  id?: ModelIDInput | null,
  affiliateID?: ModelStringInput | null,
  status?: ModelAffiliatePayoutStatusInput | null,
  grossCents?: ModelIntInput | null,
  generatedAt?: ModelStringInput | null,
  paidAt?: ModelStringInput | null,
  paymentRef?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliatePayoutFilterInput | null > | null,
  or?: Array< ModelAffiliatePayoutFilterInput | null > | null,
  not?: ModelAffiliatePayoutFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliatePayoutConnection = {
  __typename: "ModelAffiliatePayoutConnection",
  items:  Array<AffiliatePayout | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAffiliateVisitFilterInput = {
  id?: ModelIDInput | null,
  affiliateID?: ModelStringInput | null,
  affiliateCode?: ModelStringInput | null,
  visitedAt?: ModelStringInput | null,
  path?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAffiliateVisitFilterInput | null > | null,
  or?: Array< ModelAffiliateVisitFilterInput | null > | null,
  not?: ModelAffiliateVisitFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAffiliateVisitConnection = {
  __typename: "ModelAffiliateVisitConnection",
  items:  Array<AffiliateVisit | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAmenityFilterInput = {
  id?: ModelIDInput | null,
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  rules?: ModelStringInput | null,
  availability?: ModelStringInput | null,
  geolocation?: ModelStringInput | null,
  locationDescription?: ModelStringInput | null,
  buildingID?: ModelStringInput | null,
  images?: ModelStringInput | null,
  lockUnixTTL?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAmenityFilterInput | null > | null,
  or?: Array< ModelAmenityFilterInput | null > | null,
  not?: ModelAmenityFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAmenityConnection = {
  __typename: "ModelAmenityConnection",
  items:  Array<Amenity | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAmenityReservationFilterInput = {
  id?: ModelIDInput | null,
  amenityID?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  details?: ModelStringInput | null,
  status?: ModelAmenityReservationStatusInput | null,
  statusReason?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  reviewer?: ModelStringInput | null,
  partySize?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAmenityReservationFilterInput | null > | null,
  or?: Array< ModelAmenityReservationFilterInput | null > | null,
  not?: ModelAmenityReservationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAmenityReservationConnection = {
  __typename: "ModelAmenityReservationConnection",
  items:  Array<AmenityReservation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelApplicationFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelApplicationStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  moveInDatePreference?: ModelStringInput | null,
  rentPaymentPreference?: ModelRentPaymentMethodTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelApplicationFilterInput | null > | null,
  or?: Array< ModelApplicationFilterInput | null > | null,
  not?: ModelApplicationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelApplicationConnection = {
  __typename: "ModelApplicationConnection",
  items:  Array<Application | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBackgroundCheckFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBackgroundCheckStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBackgroundCheckFilterInput | null > | null,
  or?: Array< ModelBackgroundCheckFilterInput | null > | null,
  not?: ModelBackgroundCheckFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBackgroundCheckConnection = {
  __typename: "ModelBackgroundCheckConnection",
  items:  Array<BackgroundCheck | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBuildingFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBuildingStatusTypeInput | null,
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  actualRentPaymentDate?: ModelStringInput | null,
  size?: ModelStringInput | null,
  street?: ModelStringInput | null,
  type?: ModelBuildingTypeInput | null,
  contact?: ModelStringInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBuildingFilterInput | null > | null,
  or?: Array< ModelBuildingFilterInput | null > | null,
  not?: ModelBuildingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBuildingConnection = {
  __typename: "ModelBuildingConnection",
  items:  Array<Building | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelChargesFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelChargesTypesInput | null,
  isRevenue?: ModelBooleanInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChargesFilterInput | null > | null,
  or?: Array< ModelChargesFilterInput | null > | null,
  not?: ModelChargesFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelChargesConnection = {
  __typename: "ModelChargesConnection",
  items:  Array<Charges | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCommentsFilterInput = {
  id?: ModelIDInput | null,
  commenter?: ModelStringInput | null,
  text?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdDate?: ModelStringInput | null,
  parentID?: ModelStringInput | null,
  type?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCommentsFilterInput | null > | null,
  or?: Array< ModelCommentsFilterInput | null > | null,
  not?: ModelCommentsFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCommentsConnection = {
  __typename: "ModelCommentsConnection",
  items:  Array<Comments | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelEntityFieldFilterInput = {
  id?: ModelIDInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  name?: ModelStringInput | null,
  type?: ModelEntityFieldTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  value?: ModelStringInput | null,
  date?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEntityFieldFilterInput | null > | null,
  or?: Array< ModelEntityFieldFilterInput | null > | null,
  not?: ModelEntityFieldFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelEntityFieldConnection = {
  __typename: "ModelEntityFieldConnection",
  items:  Array<EntityField | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  name?: ModelStringInput | null,
  date?: ModelStringInput | null,
  type?: ModelStringInput | null,
  comment?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items:  Array<Event | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelFavoriteFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  favType?: ModelStringInput | null,
  favID?: ModelStringInput | null,
  image?: ModelStringInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFavoriteFilterInput | null > | null,
  or?: Array< ModelFavoriteFilterInput | null > | null,
  not?: ModelFavoriteFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFavoriteConnection = {
  __typename: "ModelFavoriteConnection",
  items:  Array<Favorite | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelFinanceLockFilterInput = {
  id?: ModelIDInput | null,
  scope?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelEntityTypeInput | null,
  year?: ModelIntInput | null,
  month?: ModelIntInput | null,
  lockUnixTTL?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFinanceLockFilterInput | null > | null,
  or?: Array< ModelFinanceLockFilterInput | null > | null,
  not?: ModelFinanceLockFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFinanceLockConnection = {
  __typename: "ModelFinanceLockConnection",
  items:  Array<FinanceLock | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelJoinOrganizationRequestFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  requestStatus?: ModelJoinOrganizationRequestStatusInput | null,
  organizationID?: ModelStringInput | null,
  requestPropertyTransfer?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelJoinOrganizationRequestFilterInput | null > | null,
  or?: Array< ModelJoinOrganizationRequestFilterInput | null > | null,
  not?: ModelJoinOrganizationRequestFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelJoinOrganizationRequestConnection = {
  __typename: "ModelJoinOrganizationRequestConnection",
  items:  Array<JoinOrganizationRequest | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLeaseFilterInput = {
  id?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  type?: ModelLeaseTypeOptionsInput | null,
  status?: ModelLeaseStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  tenantID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  markedDate?: ModelStringInput | null,
  extraOccupants?: ModelStringInput | null,
  applicationID?: ModelStringInput | null,
  backgroundCheckID?: ModelStringInput | null,
  offerID?: ModelStringInput | null,
  moveInID?: ModelStringInput | null,
  moveOutID?: ModelStringInput | null,
  nextLeaseID?: ModelStringInput | null,
  prevLeaseID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLeaseFilterInput | null > | null,
  or?: Array< ModelLeaseFilterInput | null > | null,
  not?: ModelLeaseFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLeaseConnection = {
  __typename: "ModelLeaseConnection",
  items:  Array<Lease | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelMessageFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  content?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  senderID?: ModelStringInput | null,
  senderName?: ModelStringInput | null,
  receiverID?: ModelStringInput | null,
  receiverName?: ModelStringInput | null,
  messageTitle?: ModelStringInput | null,
  type?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMessageFilterInput | null > | null,
  or?: Array< ModelMessageFilterInput | null > | null,
  not?: ModelMessageFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMessageConnection = {
  __typename: "ModelMessageConnection",
  items:  Array<Message | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelMonthlyFinanceReportFilterInput = {
  id?: ModelIDInput | null,
  yearlyReportId?: ModelStringInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMonthlyFinanceReportFilterInput | null > | null,
  or?: Array< ModelMonthlyFinanceReportFilterInput | null > | null,
  not?: ModelMonthlyFinanceReportFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMonthlyFinanceReportConnection = {
  __typename: "ModelMonthlyFinanceReportConnection",
  items:  Array<MonthlyFinanceReport | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelMonthlyStatusReportFilterInput = {
  id?: ModelIDInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  numOccupied?: ModelIntInput | null,
  numVacant?: ModelIntInput | null,
  numRenovation?: ModelIntInput | null,
  numUnits?: ModelIntInput | null,
  numBuildings?: ModelIntInput | null,
  numProperties?: ModelIntInput | null,
  numServiceRequests?: ModelIntInput | null,
  numAmenities?: ModelIntInput | null,
  numAmenityReservations?: ModelIntInput | null,
  expectedRent?: ModelIntInput | null,
  expectedStayRevenue?: ModelIntInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMonthlyStatusReportFilterInput | null > | null,
  or?: Array< ModelMonthlyStatusReportFilterInput | null > | null,
  not?: ModelMonthlyStatusReportFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMonthlyStatusReportConnection = {
  __typename: "ModelMonthlyStatusReportConnection",
  items:  Array<MonthlyStatusReport | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelMoveExamFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelMoveExamTypeInput | null,
  status?: ModelMoveExamStatusTypeInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMoveExamFilterInput | null > | null,
  or?: Array< ModelMoveExamFilterInput | null > | null,
  not?: ModelMoveExamFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMoveExamConnection = {
  __typename: "ModelMoveExamConnection",
  items:  Array<MoveExam | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelOfferFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelOfferStatusTypeInput | null,
  rent?: ModelFloatInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  startDate?: ModelStringInput | null,
  tenantSignDate?: ModelStringInput | null,
  landlordSignDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  rentCycle?: ModelRentCycleInput | null,
  normalizedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOfferFilterInput | null > | null,
  or?: Array< ModelOfferFilterInput | null > | null,
  not?: ModelOfferFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelOfferConnection = {
  __typename: "ModelOfferConnection",
  items:  Array<Offer | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelOrganizationFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrganizationFilterInput | null > | null,
  or?: Array< ModelOrganizationFilterInput | null > | null,
  not?: ModelOrganizationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelOrganizationConnection = {
  __typename: "ModelOrganizationConnection",
  items:  Array<Organization | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelParcelFilterInput = {
  id?: ModelIDInput | null,
  propertyID?: ModelStringInput | null,
  status?: ModelParcelStatusTypeInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  areaSize?: ModelStringInput | null,
  boundaryNote?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelParcelFilterInput | null > | null,
  or?: Array< ModelParcelFilterInput | null > | null,
  not?: ModelParcelFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelParcelConnection = {
  __typename: "ModelParcelConnection",
  items:  Array<Parcel | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPaymentReceiptFilterInput = {
  id?: ModelIDInput | null,
  transactionID?: ModelIDInput | null,
  status?: ModelPaymentReceiptStatusInput | null,
  failureReason?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  s3Keys?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  signedByUserID?: ModelStringInput | null,
  signedByUserName?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPaymentReceiptFilterInput | null > | null,
  or?: Array< ModelPaymentReceiptFilterInput | null > | null,
  not?: ModelPaymentReceiptFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPaymentReceiptConnection = {
  __typename: "ModelPaymentReceiptConnection",
  items:  Array<PaymentReceipt | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPropertyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  areaSize?: ModelStringInput | null,
  street?: ModelStringInput | null,
  city?: ModelStringInput | null,
  state?: ModelStringInput | null,
  country?: ModelStringInput | null,
  zipCode?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  expectedRentPaymentDate?: ModelStringInput | null,
  poBox?: ModelStringInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPropertyFilterInput | null > | null,
  or?: Array< ModelPropertyFilterInput | null > | null,
  not?: ModelPropertyFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPropertyConnection = {
  __typename: "ModelPropertyConnection",
  items:  Array<Property | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelResourceLifeAccessRightFilterInput = {
  id?: ModelIDInput | null,
  resourceType?: ModelEntityTypeInput | null,
  createAccessStatus?: ModelResourceAccessRightStatusInput | null,
  createAccessApproverID?: ModelStringInput | null,
  createAccessApprovalDate?: ModelStringInput | null,
  deleteAccessStatus?: ModelResourceAccessRightStatusInput | null,
  deleteAccessApproverID?: ModelStringInput | null,
  deleteAccessApprovalDate?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelResourceLifeAccessRightFilterInput | null > | null,
  or?: Array< ModelResourceLifeAccessRightFilterInput | null > | null,
  not?: ModelResourceLifeAccessRightFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelResourceLifeAccessRightConnection = {
  __typename: "ModelResourceLifeAccessRightConnection",
  items:  Array<ResourceLifeAccessRight | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelResourceUpdateAccessRightFilterInput = {
  id?: ModelIDInput | null,
  resourceType?: ModelEntityTypeInput | null,
  resourceID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  readAccessStatus?: ModelResourceAccessRightStatusInput | null,
  readAccessApproverID?: ModelStringInput | null,
  readAccessApprovalDate?: ModelStringInput | null,
  writeAccessStatus?: ModelResourceAccessRightStatusInput | null,
  writeAccessApproverID?: ModelStringInput | null,
  writeAccessApprovalDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelResourceUpdateAccessRightFilterInput | null > | null,
  or?: Array< ModelResourceUpdateAccessRightFilterInput | null > | null,
  not?: ModelResourceUpdateAccessRightFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelResourceUpdateAccessRightConnection = {
  __typename: "ModelResourceUpdateAccessRightConnection",
  items:  Array<ResourceUpdateAccessRight | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelServiceRequestFilterInput = {
  id?: ModelIDInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  creatorID?: ModelStringInput | null,
  description?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelServiceRequestTypeInput | null,
  isUpgrade?: ModelBooleanInput | null,
  status?: ModelServiceRequestStatusTypeInput | null,
  emergency?: ModelBooleanInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  creatorName?: ModelStringInput | null,
  handlerID?: ModelStringInput | null,
  handlerName?: ModelStringInput | null,
  watcherID?: ModelStringInput | null,
  watcherName?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  tenantName?: ModelStringInput | null,
  contractor?: ModelStringInput | null,
  dateCreated?: ModelStringInput | null,
  dateUpdated?: ModelStringInput | null,
  estimatedCost?: ModelFloatInput | null,
  finalCost?: ModelFloatInput | null,
  images?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelServiceRequestFilterInput | null > | null,
  or?: Array< ModelServiceRequestFilterInput | null > | null,
  not?: ModelServiceRequestFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelServiceRequestConnection = {
  __typename: "ModelServiceRequestConnection",
  items:  Array<ServiceRequest | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStayFilterInput = {
  id?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  checkIn?: ModelStringInput | null,
  checkOut?: ModelStringInput | null,
  status?: ModelStayStatusTypeInput | null,
  tenantID?: ModelStringInput | null,
  nightlyRate?: ModelFloatInput | null,
  totalAmount?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStayFilterInput | null > | null,
  or?: Array< ModelStayFilterInput | null > | null,
  not?: ModelStayFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStayConnection = {
  __typename: "ModelStayConnection",
  items:  Array<Stay | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStayRateFilterInput = {
  id?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  nightlyRate?: ModelFloatInput | null,
  weeklyRate?: ModelFloatInput | null,
  minNights?: ModelIntInput | null,
  maxNights?: ModelIntInput | null,
  cleaningFee?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStayRateFilterInput | null > | null,
  or?: Array< ModelStayRateFilterInput | null > | null,
  not?: ModelStayRateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStayRateConnection = {
  __typename: "ModelStayRateConnection",
  items:  Array<StayRate | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStayAvailabilityFilterInput = {
  id?: ModelIDInput | null,
  entityType?: ModelEntityTypeInput | null,
  entityID?: ModelStringInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  reason?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStayAvailabilityFilterInput | null > | null,
  or?: Array< ModelStayAvailabilityFilterInput | null > | null,
  not?: ModelStayAvailabilityFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStayAvailabilityConnection = {
  __typename: "ModelStayAvailabilityConnection",
  items:  Array<StayAvailability | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionDiscountFilterInput = {
  id?: ModelIDInput | null,
  planID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  percentage?: ModelFloatInput | null,
  isActive?: ModelBooleanInput | null,
  codeID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionDiscountFilterInput | null > | null,
  or?: Array< ModelSubscriptionDiscountFilterInput | null > | null,
  not?: ModelSubscriptionDiscountFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDiscountConnection = {
  __typename: "ModelSubscriptionDiscountConnection",
  items:  Array<SubscriptionDiscount | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionDiscountCodeFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  usageCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionDiscountCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionDiscountCodeFilterInput | null > | null,
  not?: ModelSubscriptionDiscountCodeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDiscountCodeConnection = {
  __typename: "ModelSubscriptionDiscountCodeConnection",
  items:  Array<SubscriptionDiscountCode | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionLinkFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  planID?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  renewalType?: ModelSubscriptionRenewalTypeInput | null,
  autoRenewal?: ModelBooleanInput | null,
  nextPaymentAmount?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionLinkFilterInput | null > | null,
  or?: Array< ModelSubscriptionLinkFilterInput | null > | null,
  not?: ModelSubscriptionLinkFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLinkConnection = {
  __typename: "ModelSubscriptionLinkConnection",
  items:  Array<SubscriptionLink | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionPlanFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  isActive?: ModelBooleanInput | null,
  features?: ModelSubscriptionPlanFeatureInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  not?: ModelSubscriptionPlanFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPlanConnection = {
  __typename: "ModelSubscriptionPlanConnection",
  items:  Array<SubscriptionPlan | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTenantFilterInput = {
  id?: ModelIDInput | null,
  authUID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  status?: ModelTenantStatusTypeInput | null,
  type?: ModelTenantTypeInput | null,
  phoneNumber?: ModelStringInput | null,
  jobTitle?: ModelStringInput | null,
  jobPhone?: ModelStringInput | null,
  jobEmail?: ModelStringInput | null,
  jobContactName?: ModelStringInput | null,
  income?: ModelStringInput | null,
  cimesCommitted?: ModelStringInput | null,
  jailTime?: ModelStringInput | null,
  lastArrest?: ModelStringInput | null,
  lastUpdated?: ModelStringInput | null,
  totalCredit?: ModelStringInput | null,
  employer?: ModelStringInput | null,
  email?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTenantFilterInput | null > | null,
  or?: Array< ModelTenantFilterInput | null > | null,
  not?: ModelTenantFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTenantConnection = {
  __typename: "ModelTenantConnection",
  items:  Array<Tenant | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTransactionFilterInput = {
  id?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  reason?: ModelTransactionReasonInput | null,
  currency?: ModelStringInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  month?: ModelIntInput | null,
  year?: ModelIntInput | null,
  periodStart?: ModelStringInput | null,
  periodEnd?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  managerID?: ModelStringInput | null,
  status?: ModelPaymentStatusTypeInput | null,
  dateSent?: ModelStringInput | null,
  dateReceived?: ModelStringInput | null,
  paymentMethod?: ModelRentPaymentMethodTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTransactionConnection = {
  __typename: "ModelTransactionConnection",
  items:  Array<Transaction | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUnitPlanFilterInput = {
  id?: ModelIDInput | null,
  propertyID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  size?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  inUnitLaundry?: ModelBooleanInput | null,
  dishwasher?: ModelBooleanInput | null,
  airConditioning?: ModelBooleanInput | null,
  furnished?: ModelBooleanInput | null,
  balcony?: ModelBooleanInput | null,
  petFriendly?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUnitPlanFilterInput | null > | null,
  or?: Array< ModelUnitPlanFilterInput | null > | null,
  not?: ModelUnitPlanFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitPlanConnection = {
  __typename: "ModelUnitPlanConnection",
  items:  Array<UnitPlan | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUnitFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelUnitStatusTypeInput | null,
  name?: ModelStringInput | null,
  rent?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  numBedroom?: ModelStringInput | null,
  numBathroom?: ModelStringInput | null,
  buildingID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  description?: ModelStringInput | null,
  availabilityDate?: ModelStringInput | null,
  actualRentPaymentDate?: ModelStringInput | null,
  activeLeaseID?: ModelStringInput | null,
  type?: ModelStringInput | null,
  unitPlanID?: ModelStringInput | null,
  size?: ModelStringInput | null,
  street?: ModelStringInput | null,
  deposit?: ModelFloatInput | null,
  additionalFees?: ModelFloatInput | null,
  feesDescription?: ModelStringInput | null,
  tenantID?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  inUnitLaundry?: ModelBooleanInput | null,
  dishwasher?: ModelBooleanInput | null,
  airConditioning?: ModelBooleanInput | null,
  furnished?: ModelBooleanInput | null,
  balcony?: ModelBooleanInput | null,
  petFriendly?: ModelBooleanInput | null,
  shortTermStayEnabled?: ModelBooleanInput | null,
  forSaleEnabled?: ModelBooleanInput | null,
  stayRequireApproval?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUnitFilterInput | null > | null,
  or?: Array< ModelUnitFilterInput | null > | null,
  not?: ModelUnitFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUnitConnection = {
  __typename: "ModelUnitConnection",
  items:  Array<Unit | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  authUID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  middleName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  salary?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  email?: ModelStringInput | null,
  officeAddress?: ModelStringInput | null,
  workingHours?: ModelStringInput | null,
  roles?: ModelManagerRolesTypeInput | null,
  organizationID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserOrganizationConnectionFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  creatorID?: ModelStringInput | null,
  creatorName?: ModelStringInput | null,
  organizationID?: ModelStringInput | null,
  managerID?: ModelStringInput | null,
  managerName?: ModelStringInput | null,
  title?: ModelStringInput | null,
  salary?: ModelStringInput | null,
  ownershipType?: ModelStringInput | null,
  clearanceLevel?: ModelStringInput | null,
  joinedDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserOrganizationConnectionFilterInput | null > | null,
  or?: Array< ModelUserOrganizationConnectionFilterInput | null > | null,
  not?: ModelUserOrganizationConnectionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserOrganizationConnectionConnection = {
  __typename: "ModelUserOrganizationConnectionConnection",
  items:  Array<UserOrganizationConnection | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelYearlyReportSummaryFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  year?: ModelIntInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelYearlyReportSummaryFilterInput | null > | null,
  or?: Array< ModelYearlyReportSummaryFilterInput | null > | null,
  not?: ModelYearlyReportSummaryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelYearlyReportSummaryConnection = {
  __typename: "ModelYearlyReportSummaryConnection",
  items:  Array<YearlyReportSummary | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelYearlyStatusSummaryFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  entityID?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  year?: ModelIntInput | null,
  numOccupied?: ModelIntInput | null,
  numVacant?: ModelIntInput | null,
  numRenovation?: ModelIntInput | null,
  numUnits?: ModelIntInput | null,
  numBuildings?: ModelIntInput | null,
  numProperties?: ModelIntInput | null,
  numServiceRequests?: ModelIntInput | null,
  numAmenities?: ModelIntInput | null,
  numAmenityReservations?: ModelIntInput | null,
  expectedRent?: ModelIntInput | null,
  expectedStayRevenue?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelYearlyStatusSummaryFilterInput | null > | null,
  or?: Array< ModelYearlyStatusSummaryFilterInput | null > | null,
  not?: ModelYearlyStatusSummaryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelYearlyStatusSummaryConnection = {
  __typename: "ModelYearlyStatusSummaryConnection",
  items:  Array<YearlyStatusSummary | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelYearRecordsFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  ownerID?: ModelStringInput | null,
  ownerType?: ModelOwnerTypeInput | null,
  years?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelYearRecordsFilterInput | null > | null,
  or?: Array< ModelYearRecordsFilterInput | null > | null,
  not?: ModelYearRecordsFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelYearRecordsConnection = {
  __typename: "ModelYearRecordsConnection",
  items:  Array<YearRecords | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelSubscriptionAdministratorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  username?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  middleName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdministratorFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdministratorFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionAdministratorApproversFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  editor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdministratorApproversFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdministratorApproversFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAffiliateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  middleName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  company?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliateFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAffiliateEarningFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  affiliateID?: ModelSubscriptionStringInput | null,
  linkID?: ModelSubscriptionStringInput | null,
  milestoneKey?: ModelSubscriptionStringInput | null,
  amountCents?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  payoutID?: ModelSubscriptionStringInput | null,
  idempotencyKey?: ModelSubscriptionStringInput | null,
  occurredAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliateEarningFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliateEarningFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAffiliateLinkFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  affiliateID?: ModelSubscriptionStringInput | null,
  affiliateCode?: ModelSubscriptionStringInput | null,
  attributedAt?: ModelSubscriptionStringInput | null,
  migratedToOrganizationID?: ModelSubscriptionStringInput | null,
  createdByUserID?: ModelSubscriptionStringInput | null,
  milestones?: ModelSubscriptionStringInput | null,
  unitCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliateLinkFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliateLinkFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAffiliateMilestoneRateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  milestoneKey?: ModelSubscriptionStringInput | null,
  amountCents?: ModelSubscriptionIntInput | null,
  affiliateID?: ModelSubscriptionStringInput | null,
  currency?: ModelSubscriptionStringInput | null,
  effectiveFrom?: ModelSubscriptionStringInput | null,
  effectiveTo?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliateMilestoneRateFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliateMilestoneRateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionAffiliatePayoutFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  affiliateID?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  grossCents?: ModelSubscriptionIntInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  paidAt?: ModelSubscriptionStringInput | null,
  paymentRef?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliatePayoutFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliatePayoutFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAffiliateVisitFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  affiliateID?: ModelSubscriptionStringInput | null,
  affiliateCode?: ModelSubscriptionStringInput | null,
  visitedAt?: ModelSubscriptionStringInput | null,
  path?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAffiliateVisitFilterInput | null > | null,
  or?: Array< ModelSubscriptionAffiliateVisitFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAmenityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  rules?: ModelSubscriptionStringInput | null,
  availability?: ModelSubscriptionStringInput | null,
  geolocation?: ModelSubscriptionStringInput | null,
  locationDescription?: ModelSubscriptionStringInput | null,
  buildingID?: ModelSubscriptionStringInput | null,
  images?: ModelSubscriptionStringInput | null,
  lockUnixTTL?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAmenityFilterInput | null > | null,
  or?: Array< ModelSubscriptionAmenityFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAmenityReservationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  amenityID?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  statusReason?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  reviewer?: ModelSubscriptionStringInput | null,
  partySize?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAmenityReservationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAmenityReservationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionApplicationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  moveInDatePreference?: ModelSubscriptionStringInput | null,
  rentPaymentPreference?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionApplicationFilterInput | null > | null,
  or?: Array< ModelSubscriptionApplicationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBackgroundCheckFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBackgroundCheckFilterInput | null > | null,
  or?: Array< ModelSubscriptionBackgroundCheckFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBuildingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  propertyID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  rent?: ModelSubscriptionFloatInput | null,
  price?: ModelSubscriptionFloatInput | null,
  numBedroom?: ModelSubscriptionStringInput | null,
  numBathroom?: ModelSubscriptionStringInput | null,
  actualRentPaymentDate?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionStringInput | null,
  street?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  contact?: ModelSubscriptionStringInput | null,
  shortTermStayEnabled?: ModelSubscriptionBooleanInput | null,
  forSaleEnabled?: ModelSubscriptionBooleanInput | null,
  stayRequireApproval?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBuildingFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuildingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionChargesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  isRevenue?: ModelSubscriptionBooleanInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionChargesFilterInput | null > | null,
  or?: Array< ModelSubscriptionChargesFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCommentsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  commenter?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdDate?: ModelSubscriptionStringInput | null,
  parentID?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCommentsFilterInput | null > | null,
  or?: Array< ModelSubscriptionCommentsFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionEntityFieldFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEntityFieldFilterInput | null > | null,
  or?: Array< ModelSubscriptionEntityFieldFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  comment?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFavoriteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  favType?: ModelSubscriptionStringInput | null,
  favID?: ModelSubscriptionStringInput | null,
  image?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFavoriteFilterInput | null > | null,
  or?: Array< ModelSubscriptionFavoriteFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFinanceLockFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scope?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  year?: ModelSubscriptionIntInput | null,
  month?: ModelSubscriptionIntInput | null,
  lockUnixTTL?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFinanceLockFilterInput | null > | null,
  or?: Array< ModelSubscriptionFinanceLockFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionJoinOrganizationRequestFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  requestStatus?: ModelSubscriptionStringInput | null,
  organizationID?: ModelSubscriptionStringInput | null,
  requestPropertyTransfer?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionJoinOrganizationRequestFilterInput | null > | null,
  or?: Array< ModelSubscriptionJoinOrganizationRequestFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLeaseFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  markedDate?: ModelSubscriptionStringInput | null,
  extraOccupants?: ModelSubscriptionStringInput | null,
  applicationID?: ModelSubscriptionStringInput | null,
  backgroundCheckID?: ModelSubscriptionStringInput | null,
  offerID?: ModelSubscriptionStringInput | null,
  moveInID?: ModelSubscriptionStringInput | null,
  moveOutID?: ModelSubscriptionStringInput | null,
  nextLeaseID?: ModelSubscriptionStringInput | null,
  prevLeaseID?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLeaseFilterInput | null > | null,
  or?: Array< ModelSubscriptionLeaseFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMessageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  content?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  senderID?: ModelSubscriptionStringInput | null,
  senderName?: ModelSubscriptionStringInput | null,
  receiverID?: ModelSubscriptionStringInput | null,
  receiverName?: ModelSubscriptionStringInput | null,
  messageTitle?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMessageFilterInput | null > | null,
  or?: Array< ModelSubscriptionMessageFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMonthlyFinanceReportFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  yearlyReportId?: ModelSubscriptionStringInput | null,
  month?: ModelSubscriptionIntInput | null,
  year?: ModelSubscriptionIntInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMonthlyFinanceReportFilterInput | null > | null,
  or?: Array< ModelSubscriptionMonthlyFinanceReportFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMonthlyStatusReportFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  month?: ModelSubscriptionIntInput | null,
  year?: ModelSubscriptionIntInput | null,
  numOccupied?: ModelSubscriptionIntInput | null,
  numVacant?: ModelSubscriptionIntInput | null,
  numRenovation?: ModelSubscriptionIntInput | null,
  numUnits?: ModelSubscriptionIntInput | null,
  numBuildings?: ModelSubscriptionIntInput | null,
  numProperties?: ModelSubscriptionIntInput | null,
  numServiceRequests?: ModelSubscriptionIntInput | null,
  numAmenities?: ModelSubscriptionIntInput | null,
  numAmenityReservations?: ModelSubscriptionIntInput | null,
  expectedRent?: ModelSubscriptionIntInput | null,
  expectedStayRevenue?: ModelSubscriptionIntInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMonthlyStatusReportFilterInput | null > | null,
  or?: Array< ModelSubscriptionMonthlyStatusReportFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMoveExamFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMoveExamFilterInput | null > | null,
  or?: Array< ModelSubscriptionMoveExamFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionOfferFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  rent?: ModelSubscriptionFloatInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  tenantSignDate?: ModelSubscriptionStringInput | null,
  landlordSignDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  rentCycle?: ModelSubscriptionStringInput | null,
  normalizedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOfferFilterInput | null > | null,
  or?: Array< ModelSubscriptionOfferFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionOrganizationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrganizationFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrganizationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionParcelFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyID?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  areaSize?: ModelSubscriptionStringInput | null,
  boundaryNote?: ModelSubscriptionStringInput | null,
  rent?: ModelSubscriptionFloatInput | null,
  price?: ModelSubscriptionFloatInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  shortTermStayEnabled?: ModelSubscriptionBooleanInput | null,
  forSaleEnabled?: ModelSubscriptionBooleanInput | null,
  stayRequireApproval?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionParcelFilterInput | null > | null,
  or?: Array< ModelSubscriptionParcelFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPaymentReceiptFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  transactionID?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  failureReason?: ModelSubscriptionStringInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  s3Keys?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  signedByUserID?: ModelSubscriptionStringInput | null,
  signedByUserName?: ModelSubscriptionStringInput | null,
  generatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPaymentReceiptFilterInput | null > | null,
  or?: Array< ModelSubscriptionPaymentReceiptFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPropertyFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  areaSize?: ModelSubscriptionStringInput | null,
  street?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  state?: ModelSubscriptionStringInput | null,
  country?: ModelSubscriptionStringInput | null,
  zipCode?: ModelSubscriptionStringInput | null,
  contact?: ModelSubscriptionStringInput | null,
  expectedRentPaymentDate?: ModelSubscriptionStringInput | null,
  poBox?: ModelSubscriptionStringInput | null,
  shortTermStayEnabled?: ModelSubscriptionBooleanInput | null,
  forSaleEnabled?: ModelSubscriptionBooleanInput | null,
  stayRequireApproval?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPropertyFilterInput | null > | null,
  or?: Array< ModelSubscriptionPropertyFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionResourceLifeAccessRightFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  createAccessStatus?: ModelSubscriptionStringInput | null,
  createAccessApproverID?: ModelSubscriptionStringInput | null,
  createAccessApprovalDate?: ModelSubscriptionStringInput | null,
  deleteAccessStatus?: ModelSubscriptionStringInput | null,
  deleteAccessApproverID?: ModelSubscriptionStringInput | null,
  deleteAccessApprovalDate?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionResourceLifeAccessRightFilterInput | null > | null,
  or?: Array< ModelSubscriptionResourceLifeAccessRightFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionResourceUpdateAccessRightFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  resourceID?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  readAccessStatus?: ModelSubscriptionStringInput | null,
  readAccessApproverID?: ModelSubscriptionStringInput | null,
  readAccessApprovalDate?: ModelSubscriptionStringInput | null,
  writeAccessStatus?: ModelSubscriptionStringInput | null,
  writeAccessApproverID?: ModelSubscriptionStringInput | null,
  writeAccessApprovalDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionResourceUpdateAccessRightFilterInput | null > | null,
  or?: Array< ModelSubscriptionResourceUpdateAccessRightFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionServiceRequestFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  creatorID?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  isUpgrade?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  emergency?: ModelSubscriptionBooleanInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  creatorName?: ModelSubscriptionStringInput | null,
  handlerID?: ModelSubscriptionStringInput | null,
  handlerName?: ModelSubscriptionStringInput | null,
  watcherID?: ModelSubscriptionStringInput | null,
  watcherName?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  tenantName?: ModelSubscriptionStringInput | null,
  contractor?: ModelSubscriptionStringInput | null,
  dateCreated?: ModelSubscriptionStringInput | null,
  dateUpdated?: ModelSubscriptionStringInput | null,
  estimatedCost?: ModelSubscriptionFloatInput | null,
  finalCost?: ModelSubscriptionFloatInput | null,
  images?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionServiceRequestFilterInput | null > | null,
  or?: Array< ModelSubscriptionServiceRequestFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionStayFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  checkIn?: ModelSubscriptionStringInput | null,
  checkOut?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  nightlyRate?: ModelSubscriptionFloatInput | null,
  totalAmount?: ModelSubscriptionFloatInput | null,
  currency?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStayFilterInput | null > | null,
  or?: Array< ModelSubscriptionStayFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionStayRateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  nightlyRate?: ModelSubscriptionFloatInput | null,
  weeklyRate?: ModelSubscriptionFloatInput | null,
  minNights?: ModelSubscriptionIntInput | null,
  maxNights?: ModelSubscriptionIntInput | null,
  cleaningFee?: ModelSubscriptionFloatInput | null,
  currency?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStayRateFilterInput | null > | null,
  or?: Array< ModelSubscriptionStayRateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionStayAvailabilityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  start?: ModelSubscriptionStringInput | null,
  end?: ModelSubscriptionStringInput | null,
  reason?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionStayAvailabilityFilterInput | null > | null,
  or?: Array< ModelSubscriptionStayAvailabilityFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSubscriptionDiscountFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  planID?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  percentage?: ModelSubscriptionFloatInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  codeID?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionDiscountFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionDiscountFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSubscriptionDiscountCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  usageCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionDiscountCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionDiscountCodeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSubscriptionLinkFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  planID?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  renewalType?: ModelSubscriptionStringInput | null,
  autoRenewal?: ModelSubscriptionBooleanInput | null,
  nextPaymentAmount?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionLinkFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionLinkFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSubscriptionPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  features?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSubscriptionPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionSubscriptionPlanFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTenantFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  authUID?: ModelSubscriptionStringInput | null,
  username?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  middleName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  jobTitle?: ModelSubscriptionStringInput | null,
  jobPhone?: ModelSubscriptionStringInput | null,
  jobEmail?: ModelSubscriptionStringInput | null,
  jobContactName?: ModelSubscriptionStringInput | null,
  income?: ModelSubscriptionStringInput | null,
  cimesCommitted?: ModelSubscriptionStringInput | null,
  jailTime?: ModelSubscriptionStringInput | null,
  lastArrest?: ModelSubscriptionStringInput | null,
  lastUpdated?: ModelSubscriptionStringInput | null,
  totalCredit?: ModelSubscriptionStringInput | null,
  employer?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTenantFilterInput | null > | null,
  or?: Array< ModelSubscriptionTenantFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTransactionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  reason?: ModelSubscriptionStringInput | null,
  currency?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  month?: ModelSubscriptionIntInput | null,
  year?: ModelSubscriptionIntInput | null,
  periodStart?: ModelSubscriptionStringInput | null,
  periodEnd?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  managerID?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  dateSent?: ModelSubscriptionStringInput | null,
  dateReceived?: ModelSubscriptionStringInput | null,
  paymentMethod?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  numBedroom?: ModelSubscriptionStringInput | null,
  numBathroom?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  inUnitLaundry?: ModelSubscriptionBooleanInput | null,
  dishwasher?: ModelSubscriptionBooleanInput | null,
  airConditioning?: ModelSubscriptionBooleanInput | null,
  furnished?: ModelSubscriptionBooleanInput | null,
  balcony?: ModelSubscriptionBooleanInput | null,
  petFriendly?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUnitPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitPlanFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUnitFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  rent?: ModelSubscriptionFloatInput | null,
  price?: ModelSubscriptionFloatInput | null,
  numBedroom?: ModelSubscriptionStringInput | null,
  numBathroom?: ModelSubscriptionStringInput | null,
  buildingID?: ModelSubscriptionStringInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  availabilityDate?: ModelSubscriptionStringInput | null,
  actualRentPaymentDate?: ModelSubscriptionStringInput | null,
  activeLeaseID?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  unitPlanID?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionStringInput | null,
  street?: ModelSubscriptionStringInput | null,
  deposit?: ModelSubscriptionFloatInput | null,
  additionalFees?: ModelSubscriptionFloatInput | null,
  feesDescription?: ModelSubscriptionStringInput | null,
  tenantID?: ModelSubscriptionStringInput | null,
  contact?: ModelSubscriptionStringInput | null,
  inUnitLaundry?: ModelSubscriptionBooleanInput | null,
  dishwasher?: ModelSubscriptionBooleanInput | null,
  airConditioning?: ModelSubscriptionBooleanInput | null,
  furnished?: ModelSubscriptionBooleanInput | null,
  balcony?: ModelSubscriptionBooleanInput | null,
  petFriendly?: ModelSubscriptionBooleanInput | null,
  shortTermStayEnabled?: ModelSubscriptionBooleanInput | null,
  forSaleEnabled?: ModelSubscriptionBooleanInput | null,
  stayRequireApproval?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUnitFilterInput | null > | null,
  or?: Array< ModelSubscriptionUnitFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  authUID?: ModelSubscriptionStringInput | null,
  username?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  middleName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  salary?: ModelSubscriptionStringInput | null,
  companyName?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  officeAddress?: ModelSubscriptionStringInput | null,
  workingHours?: ModelSubscriptionStringInput | null,
  roles?: ModelSubscriptionStringInput | null,
  organizationID?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserOrganizationConnectionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  username?: ModelSubscriptionStringInput | null,
  creatorID?: ModelSubscriptionStringInput | null,
  creatorName?: ModelSubscriptionStringInput | null,
  organizationID?: ModelSubscriptionStringInput | null,
  managerID?: ModelSubscriptionStringInput | null,
  managerName?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  salary?: ModelSubscriptionStringInput | null,
  ownershipType?: ModelSubscriptionStringInput | null,
  clearanceLevel?: ModelSubscriptionStringInput | null,
  joinedDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserOrganizationConnectionFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserOrganizationConnectionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionYearlyReportSummaryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  year?: ModelSubscriptionIntInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionYearlyReportSummaryFilterInput | null > | null,
  or?: Array< ModelSubscriptionYearlyReportSummaryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionYearlyStatusSummaryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  year?: ModelSubscriptionIntInput | null,
  numOccupied?: ModelSubscriptionIntInput | null,
  numVacant?: ModelSubscriptionIntInput | null,
  numRenovation?: ModelSubscriptionIntInput | null,
  numUnits?: ModelSubscriptionIntInput | null,
  numBuildings?: ModelSubscriptionIntInput | null,
  numProperties?: ModelSubscriptionIntInput | null,
  numServiceRequests?: ModelSubscriptionIntInput | null,
  numAmenities?: ModelSubscriptionIntInput | null,
  numAmenityReservations?: ModelSubscriptionIntInput | null,
  expectedRent?: ModelSubscriptionIntInput | null,
  expectedStayRevenue?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionYearlyStatusSummaryFilterInput | null > | null,
  or?: Array< ModelSubscriptionYearlyStatusSummaryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionYearRecordsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  ownerID?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  years?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionYearRecordsFilterInput | null > | null,
  or?: Array< ModelSubscriptionYearRecordsFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type CreateAdministratorMutationVariables = {
  input: CreateAdministratorInput,
  condition?: ModelAdministratorConditionInput | null,
};

export type CreateAdministratorMutation = {
  createAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdministratorMutationVariables = {
  input: UpdateAdministratorInput,
  condition?: ModelAdministratorConditionInput | null,
};

export type UpdateAdministratorMutation = {
  updateAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdministratorMutationVariables = {
  input: DeleteAdministratorInput,
  condition?: ModelAdministratorConditionInput | null,
};

export type DeleteAdministratorMutation = {
  deleteAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAdministratorApproversMutationVariables = {
  input: CreateAdministratorApproversInput,
  condition?: ModelAdministratorApproversConditionInput | null,
};

export type CreateAdministratorApproversMutation = {
  createAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdministratorApproversMutationVariables = {
  input: UpdateAdministratorApproversInput,
  condition?: ModelAdministratorApproversConditionInput | null,
};

export type UpdateAdministratorApproversMutation = {
  updateAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdministratorApproversMutationVariables = {
  input: DeleteAdministratorApproversInput,
  condition?: ModelAdministratorApproversConditionInput | null,
};

export type DeleteAdministratorApproversMutation = {
  deleteAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliateMutationVariables = {
  input: CreateAffiliateInput,
  condition?: ModelAffiliateConditionInput | null,
};

export type CreateAffiliateMutation = {
  createAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliateMutationVariables = {
  input: UpdateAffiliateInput,
  condition?: ModelAffiliateConditionInput | null,
};

export type UpdateAffiliateMutation = {
  updateAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliateMutationVariables = {
  input: DeleteAffiliateInput,
  condition?: ModelAffiliateConditionInput | null,
};

export type DeleteAffiliateMutation = {
  deleteAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliateEarningMutationVariables = {
  input: CreateAffiliateEarningInput,
  condition?: ModelAffiliateEarningConditionInput | null,
};

export type CreateAffiliateEarningMutation = {
  createAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliateEarningMutationVariables = {
  input: UpdateAffiliateEarningInput,
  condition?: ModelAffiliateEarningConditionInput | null,
};

export type UpdateAffiliateEarningMutation = {
  updateAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliateEarningMutationVariables = {
  input: DeleteAffiliateEarningInput,
  condition?: ModelAffiliateEarningConditionInput | null,
};

export type DeleteAffiliateEarningMutation = {
  deleteAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliateLinkMutationVariables = {
  input: CreateAffiliateLinkInput,
  condition?: ModelAffiliateLinkConditionInput | null,
};

export type CreateAffiliateLinkMutation = {
  createAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliateLinkMutationVariables = {
  input: UpdateAffiliateLinkInput,
  condition?: ModelAffiliateLinkConditionInput | null,
};

export type UpdateAffiliateLinkMutation = {
  updateAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliateLinkMutationVariables = {
  input: DeleteAffiliateLinkInput,
  condition?: ModelAffiliateLinkConditionInput | null,
};

export type DeleteAffiliateLinkMutation = {
  deleteAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliateMilestoneRateMutationVariables = {
  input: CreateAffiliateMilestoneRateInput,
  condition?: ModelAffiliateMilestoneRateConditionInput | null,
};

export type CreateAffiliateMilestoneRateMutation = {
  createAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliateMilestoneRateMutationVariables = {
  input: UpdateAffiliateMilestoneRateInput,
  condition?: ModelAffiliateMilestoneRateConditionInput | null,
};

export type UpdateAffiliateMilestoneRateMutation = {
  updateAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliateMilestoneRateMutationVariables = {
  input: DeleteAffiliateMilestoneRateInput,
  condition?: ModelAffiliateMilestoneRateConditionInput | null,
};

export type DeleteAffiliateMilestoneRateMutation = {
  deleteAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliatePayoutMutationVariables = {
  input: CreateAffiliatePayoutInput,
  condition?: ModelAffiliatePayoutConditionInput | null,
};

export type CreateAffiliatePayoutMutation = {
  createAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliatePayoutMutationVariables = {
  input: UpdateAffiliatePayoutInput,
  condition?: ModelAffiliatePayoutConditionInput | null,
};

export type UpdateAffiliatePayoutMutation = {
  updateAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliatePayoutMutationVariables = {
  input: DeleteAffiliatePayoutInput,
  condition?: ModelAffiliatePayoutConditionInput | null,
};

export type DeleteAffiliatePayoutMutation = {
  deleteAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAffiliateVisitMutationVariables = {
  input: CreateAffiliateVisitInput,
  condition?: ModelAffiliateVisitConditionInput | null,
};

export type CreateAffiliateVisitMutation = {
  createAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAffiliateVisitMutationVariables = {
  input: UpdateAffiliateVisitInput,
  condition?: ModelAffiliateVisitConditionInput | null,
};

export type UpdateAffiliateVisitMutation = {
  updateAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAffiliateVisitMutationVariables = {
  input: DeleteAffiliateVisitInput,
  condition?: ModelAffiliateVisitConditionInput | null,
};

export type DeleteAffiliateVisitMutation = {
  deleteAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAmenityMutationVariables = {
  input: CreateAmenityInput,
  condition?: ModelAmenityConditionInput | null,
};

export type CreateAmenityMutation = {
  createAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAmenityMutationVariables = {
  input: UpdateAmenityInput,
  condition?: ModelAmenityConditionInput | null,
};

export type UpdateAmenityMutation = {
  updateAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAmenityMutationVariables = {
  input: DeleteAmenityInput,
  condition?: ModelAmenityConditionInput | null,
};

export type DeleteAmenityMutation = {
  deleteAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAmenityReservationMutationVariables = {
  input: CreateAmenityReservationInput,
  condition?: ModelAmenityReservationConditionInput | null,
};

export type CreateAmenityReservationMutation = {
  createAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAmenityReservationMutationVariables = {
  input: UpdateAmenityReservationInput,
  condition?: ModelAmenityReservationConditionInput | null,
};

export type UpdateAmenityReservationMutation = {
  updateAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAmenityReservationMutationVariables = {
  input: DeleteAmenityReservationInput,
  condition?: ModelAmenityReservationConditionInput | null,
};

export type DeleteAmenityReservationMutation = {
  deleteAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateApplicationMutationVariables = {
  input: CreateApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type CreateApplicationMutation = {
  createApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateApplicationMutationVariables = {
  input: UpdateApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type UpdateApplicationMutation = {
  updateApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteApplicationMutationVariables = {
  input: DeleteApplicationInput,
  condition?: ModelApplicationConditionInput | null,
};

export type DeleteApplicationMutation = {
  deleteApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBackgroundCheckMutationVariables = {
  input: CreateBackgroundCheckInput,
  condition?: ModelBackgroundCheckConditionInput | null,
};

export type CreateBackgroundCheckMutation = {
  createBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBackgroundCheckMutationVariables = {
  input: UpdateBackgroundCheckInput,
  condition?: ModelBackgroundCheckConditionInput | null,
};

export type UpdateBackgroundCheckMutation = {
  updateBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBackgroundCheckMutationVariables = {
  input: DeleteBackgroundCheckInput,
  condition?: ModelBackgroundCheckConditionInput | null,
};

export type DeleteBackgroundCheckMutation = {
  deleteBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBuildingMutationVariables = {
  input: CreateBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type CreateBuildingMutation = {
  createBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBuildingMutationVariables = {
  input: UpdateBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type UpdateBuildingMutation = {
  updateBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBuildingMutationVariables = {
  input: DeleteBuildingInput,
  condition?: ModelBuildingConditionInput | null,
};

export type DeleteBuildingMutation = {
  deleteBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateChargesMutationVariables = {
  input: CreateChargesInput,
  condition?: ModelChargesConditionInput | null,
};

export type CreateChargesMutation = {
  createCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateChargesMutationVariables = {
  input: UpdateChargesInput,
  condition?: ModelChargesConditionInput | null,
};

export type UpdateChargesMutation = {
  updateCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteChargesMutationVariables = {
  input: DeleteChargesInput,
  condition?: ModelChargesConditionInput | null,
};

export type DeleteChargesMutation = {
  deleteCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCommentsMutationVariables = {
  input: CreateCommentsInput,
  condition?: ModelCommentsConditionInput | null,
};

export type CreateCommentsMutation = {
  createComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCommentsMutationVariables = {
  input: UpdateCommentsInput,
  condition?: ModelCommentsConditionInput | null,
};

export type UpdateCommentsMutation = {
  updateComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCommentsMutationVariables = {
  input: DeleteCommentsInput,
  condition?: ModelCommentsConditionInput | null,
};

export type DeleteCommentsMutation = {
  deleteComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEntityFieldMutationVariables = {
  input: CreateEntityFieldInput,
  condition?: ModelEntityFieldConditionInput | null,
};

export type CreateEntityFieldMutation = {
  createEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEntityFieldMutationVariables = {
  input: UpdateEntityFieldInput,
  condition?: ModelEntityFieldConditionInput | null,
};

export type UpdateEntityFieldMutation = {
  updateEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEntityFieldMutationVariables = {
  input: DeleteEntityFieldInput,
  condition?: ModelEntityFieldConditionInput | null,
};

export type DeleteEntityFieldMutation = {
  deleteEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFavoriteMutationVariables = {
  input: CreateFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type CreateFavoriteMutation = {
  createFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFavoriteMutationVariables = {
  input: UpdateFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type UpdateFavoriteMutation = {
  updateFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFavoriteMutationVariables = {
  input: DeleteFavoriteInput,
  condition?: ModelFavoriteConditionInput | null,
};

export type DeleteFavoriteMutation = {
  deleteFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFinanceLockMutationVariables = {
  input: CreateFinanceLockInput,
  condition?: ModelFinanceLockConditionInput | null,
};

export type CreateFinanceLockMutation = {
  createFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFinanceLockMutationVariables = {
  input: UpdateFinanceLockInput,
  condition?: ModelFinanceLockConditionInput | null,
};

export type UpdateFinanceLockMutation = {
  updateFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFinanceLockMutationVariables = {
  input: DeleteFinanceLockInput,
  condition?: ModelFinanceLockConditionInput | null,
};

export type DeleteFinanceLockMutation = {
  deleteFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateJoinOrganizationRequestMutationVariables = {
  input: CreateJoinOrganizationRequestInput,
  condition?: ModelJoinOrganizationRequestConditionInput | null,
};

export type CreateJoinOrganizationRequestMutation = {
  createJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateJoinOrganizationRequestMutationVariables = {
  input: UpdateJoinOrganizationRequestInput,
  condition?: ModelJoinOrganizationRequestConditionInput | null,
};

export type UpdateJoinOrganizationRequestMutation = {
  updateJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteJoinOrganizationRequestMutationVariables = {
  input: DeleteJoinOrganizationRequestInput,
  condition?: ModelJoinOrganizationRequestConditionInput | null,
};

export type DeleteJoinOrganizationRequestMutation = {
  deleteJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLeaseMutationVariables = {
  input: CreateLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type CreateLeaseMutation = {
  createLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLeaseMutationVariables = {
  input: UpdateLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type UpdateLeaseMutation = {
  updateLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLeaseMutationVariables = {
  input: DeleteLeaseInput,
  condition?: ModelLeaseConditionInput | null,
};

export type DeleteLeaseMutation = {
  deleteLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMessageMutationVariables = {
  input: CreateMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type CreateMessageMutation = {
  createMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMessageMutationVariables = {
  input: UpdateMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type UpdateMessageMutation = {
  updateMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMessageMutationVariables = {
  input: DeleteMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type DeleteMessageMutation = {
  deleteMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMonthlyFinanceReportMutationVariables = {
  input: CreateMonthlyFinanceReportInput,
  condition?: ModelMonthlyFinanceReportConditionInput | null,
};

export type CreateMonthlyFinanceReportMutation = {
  createMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMonthlyFinanceReportMutationVariables = {
  input: UpdateMonthlyFinanceReportInput,
  condition?: ModelMonthlyFinanceReportConditionInput | null,
};

export type UpdateMonthlyFinanceReportMutation = {
  updateMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMonthlyFinanceReportMutationVariables = {
  input: DeleteMonthlyFinanceReportInput,
  condition?: ModelMonthlyFinanceReportConditionInput | null,
};

export type DeleteMonthlyFinanceReportMutation = {
  deleteMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMonthlyStatusReportMutationVariables = {
  input: CreateMonthlyStatusReportInput,
  condition?: ModelMonthlyStatusReportConditionInput | null,
};

export type CreateMonthlyStatusReportMutation = {
  createMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMonthlyStatusReportMutationVariables = {
  input: UpdateMonthlyStatusReportInput,
  condition?: ModelMonthlyStatusReportConditionInput | null,
};

export type UpdateMonthlyStatusReportMutation = {
  updateMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMonthlyStatusReportMutationVariables = {
  input: DeleteMonthlyStatusReportInput,
  condition?: ModelMonthlyStatusReportConditionInput | null,
};

export type DeleteMonthlyStatusReportMutation = {
  deleteMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMoveExamMutationVariables = {
  input: CreateMoveExamInput,
  condition?: ModelMoveExamConditionInput | null,
};

export type CreateMoveExamMutation = {
  createMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMoveExamMutationVariables = {
  input: UpdateMoveExamInput,
  condition?: ModelMoveExamConditionInput | null,
};

export type UpdateMoveExamMutation = {
  updateMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMoveExamMutationVariables = {
  input: DeleteMoveExamInput,
  condition?: ModelMoveExamConditionInput | null,
};

export type DeleteMoveExamMutation = {
  deleteMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateOfferMutationVariables = {
  input: CreateOfferInput,
  condition?: ModelOfferConditionInput | null,
};

export type CreateOfferMutation = {
  createOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateOfferMutationVariables = {
  input: UpdateOfferInput,
  condition?: ModelOfferConditionInput | null,
};

export type UpdateOfferMutation = {
  updateOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteOfferMutationVariables = {
  input: DeleteOfferInput,
  condition?: ModelOfferConditionInput | null,
};

export type DeleteOfferMutation = {
  deleteOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateOrganizationMutationVariables = {
  input: CreateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type CreateOrganizationMutation = {
  createOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateOrganizationMutationVariables = {
  input: UpdateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type UpdateOrganizationMutation = {
  updateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteOrganizationMutationVariables = {
  input: DeleteOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type DeleteOrganizationMutation = {
  deleteOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateParcelMutationVariables = {
  input: CreateParcelInput,
  condition?: ModelParcelConditionInput | null,
};

export type CreateParcelMutation = {
  createParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateParcelMutationVariables = {
  input: UpdateParcelInput,
  condition?: ModelParcelConditionInput | null,
};

export type UpdateParcelMutation = {
  updateParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteParcelMutationVariables = {
  input: DeleteParcelInput,
  condition?: ModelParcelConditionInput | null,
};

export type DeleteParcelMutation = {
  deleteParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePaymentReceiptMutationVariables = {
  input: CreatePaymentReceiptInput,
  condition?: ModelPaymentReceiptConditionInput | null,
};

export type CreatePaymentReceiptMutation = {
  createPaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePaymentReceiptMutationVariables = {
  input: UpdatePaymentReceiptInput,
  condition?: ModelPaymentReceiptConditionInput | null,
};

export type UpdatePaymentReceiptMutation = {
  updatePaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePaymentReceiptMutationVariables = {
  input: DeletePaymentReceiptInput,
  condition?: ModelPaymentReceiptConditionInput | null,
};

export type DeletePaymentReceiptMutation = {
  deletePaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePropertyMutationVariables = {
  input: CreatePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type CreatePropertyMutation = {
  createProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePropertyMutationVariables = {
  input: UpdatePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type UpdatePropertyMutation = {
  updateProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePropertyMutationVariables = {
  input: DeletePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type DeletePropertyMutation = {
  deleteProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateResourceLifeAccessRightMutationVariables = {
  input: CreateResourceLifeAccessRightInput,
  condition?: ModelResourceLifeAccessRightConditionInput | null,
};

export type CreateResourceLifeAccessRightMutation = {
  createResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateResourceLifeAccessRightMutationVariables = {
  input: UpdateResourceLifeAccessRightInput,
  condition?: ModelResourceLifeAccessRightConditionInput | null,
};

export type UpdateResourceLifeAccessRightMutation = {
  updateResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteResourceLifeAccessRightMutationVariables = {
  input: DeleteResourceLifeAccessRightInput,
  condition?: ModelResourceLifeAccessRightConditionInput | null,
};

export type DeleteResourceLifeAccessRightMutation = {
  deleteResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateResourceUpdateAccessRightMutationVariables = {
  input: CreateResourceUpdateAccessRightInput,
  condition?: ModelResourceUpdateAccessRightConditionInput | null,
};

export type CreateResourceUpdateAccessRightMutation = {
  createResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateResourceUpdateAccessRightMutationVariables = {
  input: UpdateResourceUpdateAccessRightInput,
  condition?: ModelResourceUpdateAccessRightConditionInput | null,
};

export type UpdateResourceUpdateAccessRightMutation = {
  updateResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteResourceUpdateAccessRightMutationVariables = {
  input: DeleteResourceUpdateAccessRightInput,
  condition?: ModelResourceUpdateAccessRightConditionInput | null,
};

export type DeleteResourceUpdateAccessRightMutation = {
  deleteResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateServiceRequestMutationVariables = {
  input: CreateServiceRequestInput,
  condition?: ModelServiceRequestConditionInput | null,
};

export type CreateServiceRequestMutation = {
  createServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateServiceRequestMutationVariables = {
  input: UpdateServiceRequestInput,
  condition?: ModelServiceRequestConditionInput | null,
};

export type UpdateServiceRequestMutation = {
  updateServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteServiceRequestMutationVariables = {
  input: DeleteServiceRequestInput,
  condition?: ModelServiceRequestConditionInput | null,
};

export type DeleteServiceRequestMutation = {
  deleteServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStayMutationVariables = {
  input: CreateStayInput,
  condition?: ModelStayConditionInput | null,
};

export type CreateStayMutation = {
  createStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateStayMutationVariables = {
  input: UpdateStayInput,
  condition?: ModelStayConditionInput | null,
};

export type UpdateStayMutation = {
  updateStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteStayMutationVariables = {
  input: DeleteStayInput,
  condition?: ModelStayConditionInput | null,
};

export type DeleteStayMutation = {
  deleteStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStayRateMutationVariables = {
  input: CreateStayRateInput,
  condition?: ModelStayRateConditionInput | null,
};

export type CreateStayRateMutation = {
  createStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateStayRateMutationVariables = {
  input: UpdateStayRateInput,
  condition?: ModelStayRateConditionInput | null,
};

export type UpdateStayRateMutation = {
  updateStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteStayRateMutationVariables = {
  input: DeleteStayRateInput,
  condition?: ModelStayRateConditionInput | null,
};

export type DeleteStayRateMutation = {
  deleteStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStayAvailabilityMutationVariables = {
  input: CreateStayAvailabilityInput,
  condition?: ModelStayAvailabilityConditionInput | null,
};

export type CreateStayAvailabilityMutation = {
  createStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateStayAvailabilityMutationVariables = {
  input: UpdateStayAvailabilityInput,
  condition?: ModelStayAvailabilityConditionInput | null,
};

export type UpdateStayAvailabilityMutation = {
  updateStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteStayAvailabilityMutationVariables = {
  input: DeleteStayAvailabilityInput,
  condition?: ModelStayAvailabilityConditionInput | null,
};

export type DeleteStayAvailabilityMutation = {
  deleteStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSubscriptionDiscountMutationVariables = {
  input: CreateSubscriptionDiscountInput,
  condition?: ModelSubscriptionDiscountConditionInput | null,
};

export type CreateSubscriptionDiscountMutation = {
  createSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSubscriptionDiscountMutationVariables = {
  input: UpdateSubscriptionDiscountInput,
  condition?: ModelSubscriptionDiscountConditionInput | null,
};

export type UpdateSubscriptionDiscountMutation = {
  updateSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSubscriptionDiscountMutationVariables = {
  input: DeleteSubscriptionDiscountInput,
  condition?: ModelSubscriptionDiscountConditionInput | null,
};

export type DeleteSubscriptionDiscountMutation = {
  deleteSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSubscriptionDiscountCodeMutationVariables = {
  input: CreateSubscriptionDiscountCodeInput,
  condition?: ModelSubscriptionDiscountCodeConditionInput | null,
};

export type CreateSubscriptionDiscountCodeMutation = {
  createSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSubscriptionDiscountCodeMutationVariables = {
  input: UpdateSubscriptionDiscountCodeInput,
  condition?: ModelSubscriptionDiscountCodeConditionInput | null,
};

export type UpdateSubscriptionDiscountCodeMutation = {
  updateSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSubscriptionDiscountCodeMutationVariables = {
  input: DeleteSubscriptionDiscountCodeInput,
  condition?: ModelSubscriptionDiscountCodeConditionInput | null,
};

export type DeleteSubscriptionDiscountCodeMutation = {
  deleteSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSubscriptionLinkMutationVariables = {
  input: CreateSubscriptionLinkInput,
  condition?: ModelSubscriptionLinkConditionInput | null,
};

export type CreateSubscriptionLinkMutation = {
  createSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSubscriptionLinkMutationVariables = {
  input: UpdateSubscriptionLinkInput,
  condition?: ModelSubscriptionLinkConditionInput | null,
};

export type UpdateSubscriptionLinkMutation = {
  updateSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSubscriptionLinkMutationVariables = {
  input: DeleteSubscriptionLinkInput,
  condition?: ModelSubscriptionLinkConditionInput | null,
};

export type DeleteSubscriptionLinkMutation = {
  deleteSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSubscriptionPlanMutationVariables = {
  input: CreateSubscriptionPlanInput,
  condition?: ModelSubscriptionPlanConditionInput | null,
};

export type CreateSubscriptionPlanMutation = {
  createSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSubscriptionPlanMutationVariables = {
  input: UpdateSubscriptionPlanInput,
  condition?: ModelSubscriptionPlanConditionInput | null,
};

export type UpdateSubscriptionPlanMutation = {
  updateSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSubscriptionPlanMutationVariables = {
  input: DeleteSubscriptionPlanInput,
  condition?: ModelSubscriptionPlanConditionInput | null,
};

export type DeleteSubscriptionPlanMutation = {
  deleteSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTenantMutationVariables = {
  input: CreateTenantInput,
  condition?: ModelTenantConditionInput | null,
};

export type CreateTenantMutation = {
  createTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTenantMutationVariables = {
  input: UpdateTenantInput,
  condition?: ModelTenantConditionInput | null,
};

export type UpdateTenantMutation = {
  updateTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTenantMutationVariables = {
  input: DeleteTenantInput,
  condition?: ModelTenantConditionInput | null,
};

export type DeleteTenantMutation = {
  deleteTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type CreateTransactionMutation = {
  createTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type DeleteTransactionMutation = {
  deleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitPlanMutationVariables = {
  input: CreateUnitPlanInput,
  condition?: ModelUnitPlanConditionInput | null,
};

export type CreateUnitPlanMutation = {
  createUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitPlanMutationVariables = {
  input: UpdateUnitPlanInput,
  condition?: ModelUnitPlanConditionInput | null,
};

export type UpdateUnitPlanMutation = {
  updateUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitPlanMutationVariables = {
  input: DeleteUnitPlanInput,
  condition?: ModelUnitPlanConditionInput | null,
};

export type DeleteUnitPlanMutation = {
  deleteUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUnitMutationVariables = {
  input: CreateUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type CreateUnitMutation = {
  createUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUnitMutationVariables = {
  input: UpdateUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type UpdateUnitMutation = {
  updateUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUnitMutationVariables = {
  input: DeleteUnitInput,
  condition?: ModelUnitConditionInput | null,
};

export type DeleteUnitMutation = {
  deleteUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserOrganizationConnectionMutationVariables = {
  input: CreateUserOrganizationConnectionInput,
  condition?: ModelUserOrganizationConnectionConditionInput | null,
};

export type CreateUserOrganizationConnectionMutation = {
  createUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserOrganizationConnectionMutationVariables = {
  input: UpdateUserOrganizationConnectionInput,
  condition?: ModelUserOrganizationConnectionConditionInput | null,
};

export type UpdateUserOrganizationConnectionMutation = {
  updateUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserOrganizationConnectionMutationVariables = {
  input: DeleteUserOrganizationConnectionInput,
  condition?: ModelUserOrganizationConnectionConditionInput | null,
};

export type DeleteUserOrganizationConnectionMutation = {
  deleteUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateYearlyReportSummaryMutationVariables = {
  input: CreateYearlyReportSummaryInput,
  condition?: ModelYearlyReportSummaryConditionInput | null,
};

export type CreateYearlyReportSummaryMutation = {
  createYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateYearlyReportSummaryMutationVariables = {
  input: UpdateYearlyReportSummaryInput,
  condition?: ModelYearlyReportSummaryConditionInput | null,
};

export type UpdateYearlyReportSummaryMutation = {
  updateYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteYearlyReportSummaryMutationVariables = {
  input: DeleteYearlyReportSummaryInput,
  condition?: ModelYearlyReportSummaryConditionInput | null,
};

export type DeleteYearlyReportSummaryMutation = {
  deleteYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateYearlyStatusSummaryMutationVariables = {
  input: CreateYearlyStatusSummaryInput,
  condition?: ModelYearlyStatusSummaryConditionInput | null,
};

export type CreateYearlyStatusSummaryMutation = {
  createYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateYearlyStatusSummaryMutationVariables = {
  input: UpdateYearlyStatusSummaryInput,
  condition?: ModelYearlyStatusSummaryConditionInput | null,
};

export type UpdateYearlyStatusSummaryMutation = {
  updateYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteYearlyStatusSummaryMutationVariables = {
  input: DeleteYearlyStatusSummaryInput,
  condition?: ModelYearlyStatusSummaryConditionInput | null,
};

export type DeleteYearlyStatusSummaryMutation = {
  deleteYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateYearRecordsMutationVariables = {
  input: CreateYearRecordsInput,
  condition?: ModelYearRecordsConditionInput | null,
};

export type CreateYearRecordsMutation = {
  createYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateYearRecordsMutationVariables = {
  input: UpdateYearRecordsInput,
  condition?: ModelYearRecordsConditionInput | null,
};

export type UpdateYearRecordsMutation = {
  updateYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteYearRecordsMutationVariables = {
  input: DeleteYearRecordsInput,
  condition?: ModelYearRecordsConditionInput | null,
};

export type DeleteYearRecordsMutation = {
  deleteYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetAdministratorQueryVariables = {
  id: string,
};

export type GetAdministratorQuery = {
  getAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdministratorsQueryVariables = {
  filter?: ModelAdministratorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdministratorsQuery = {
  listAdministrators?:  {
    __typename: "ModelAdministratorConnection",
    items:  Array< {
      __typename: "Administrator",
      id: string,
      username: string,
      status: AdministratorStatusType,
      role: AdministratorRoleType,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      address?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdministratorsQueryVariables = {
  filter?: ModelAdministratorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdministratorsQuery = {
  syncAdministrators?:  {
    __typename: "ModelAdministratorConnection",
    items:  Array< {
      __typename: "Administrator",
      id: string,
      username: string,
      status: AdministratorStatusType,
      role: AdministratorRoleType,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      address?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdministratorApproversQueryVariables = {
  id: string,
};

export type GetAdministratorApproversQuery = {
  getAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdministratorApproversQueryVariables = {
  filter?: ModelAdministratorApproversFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdministratorApproversQuery = {
  listAdministratorApprovers?:  {
    __typename: "ModelAdministratorApproversConnection",
    items:  Array< {
      __typename: "AdministratorApprovers",
      id: string,
      userID: string,
      editor: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdministratorApproversQueryVariables = {
  filter?: ModelAdministratorApproversFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdministratorApproversQuery = {
  syncAdministratorApprovers?:  {
    __typename: "ModelAdministratorApproversConnection",
    items:  Array< {
      __typename: "AdministratorApprovers",
      id: string,
      userID: string,
      editor: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliateQueryVariables = {
  id: string,
};

export type GetAffiliateQuery = {
  getAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliatesQueryVariables = {
  filter?: ModelAffiliateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliatesQuery = {
  listAffiliates?:  {
    __typename: "ModelAffiliateConnection",
    items:  Array< {
      __typename: "Affiliate",
      id: string,
      firstName: string,
      middleName?: string | null,
      lastName: string,
      email?: string | null,
      phone?: string | null,
      company?: string | null,
      address?: string | null,
      notes?: string | null,
      code?: string | null,
      status: AffiliateStatusType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliatesQueryVariables = {
  filter?: ModelAffiliateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliatesQuery = {
  syncAffiliates?:  {
    __typename: "ModelAffiliateConnection",
    items:  Array< {
      __typename: "Affiliate",
      id: string,
      firstName: string,
      middleName?: string | null,
      lastName: string,
      email?: string | null,
      phone?: string | null,
      company?: string | null,
      address?: string | null,
      notes?: string | null,
      code?: string | null,
      status: AffiliateStatusType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliateEarningQueryVariables = {
  id: string,
};

export type GetAffiliateEarningQuery = {
  getAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliateEarningsQueryVariables = {
  filter?: ModelAffiliateEarningFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliateEarningsQuery = {
  listAffiliateEarnings?:  {
    __typename: "ModelAffiliateEarningConnection",
    items:  Array< {
      __typename: "AffiliateEarning",
      id: string,
      affiliateID: string,
      linkID: string,
      milestoneKey: string,
      amountCents: number,
      status: AffiliateEarningStatus,
      payoutID?: string | null,
      idempotencyKey: string,
      occurredAt: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliateEarningsQueryVariables = {
  filter?: ModelAffiliateEarningFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliateEarningsQuery = {
  syncAffiliateEarnings?:  {
    __typename: "ModelAffiliateEarningConnection",
    items:  Array< {
      __typename: "AffiliateEarning",
      id: string,
      affiliateID: string,
      linkID: string,
      milestoneKey: string,
      amountCents: number,
      status: AffiliateEarningStatus,
      payoutID?: string | null,
      idempotencyKey: string,
      occurredAt: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliateLinkQueryVariables = {
  id: string,
};

export type GetAffiliateLinkQuery = {
  getAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliateLinksQueryVariables = {
  filter?: ModelAffiliateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliateLinksQuery = {
  listAffiliateLinks?:  {
    __typename: "ModelAffiliateLinkConnection",
    items:  Array< {
      __typename: "AffiliateLink",
      id: string,
      ownerID: string,
      ownerType: OwnerType,
      affiliateID: string,
      affiliateCode: string,
      attributedAt: string,
      migratedToOrganizationID?: string | null,
      createdByUserID?: string | null,
      milestones?: string | null,
      unitCount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliateLinksQueryVariables = {
  filter?: ModelAffiliateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliateLinksQuery = {
  syncAffiliateLinks?:  {
    __typename: "ModelAffiliateLinkConnection",
    items:  Array< {
      __typename: "AffiliateLink",
      id: string,
      ownerID: string,
      ownerType: OwnerType,
      affiliateID: string,
      affiliateCode: string,
      attributedAt: string,
      migratedToOrganizationID?: string | null,
      createdByUserID?: string | null,
      milestones?: string | null,
      unitCount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliateMilestoneRateQueryVariables = {
  id: string,
};

export type GetAffiliateMilestoneRateQuery = {
  getAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliateMilestoneRatesQueryVariables = {
  filter?: ModelAffiliateMilestoneRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliateMilestoneRatesQuery = {
  listAffiliateMilestoneRates?:  {
    __typename: "ModelAffiliateMilestoneRateConnection",
    items:  Array< {
      __typename: "AffiliateMilestoneRate",
      id: string,
      milestoneKey: string,
      amountCents: number,
      affiliateID?: string | null,
      currency?: string | null,
      effectiveFrom?: string | null,
      effectiveTo?: string | null,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliateMilestoneRatesQueryVariables = {
  filter?: ModelAffiliateMilestoneRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliateMilestoneRatesQuery = {
  syncAffiliateMilestoneRates?:  {
    __typename: "ModelAffiliateMilestoneRateConnection",
    items:  Array< {
      __typename: "AffiliateMilestoneRate",
      id: string,
      milestoneKey: string,
      amountCents: number,
      affiliateID?: string | null,
      currency?: string | null,
      effectiveFrom?: string | null,
      effectiveTo?: string | null,
      isActive: boolean,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliatePayoutQueryVariables = {
  id: string,
};

export type GetAffiliatePayoutQuery = {
  getAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliatePayoutsQueryVariables = {
  filter?: ModelAffiliatePayoutFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliatePayoutsQuery = {
  listAffiliatePayouts?:  {
    __typename: "ModelAffiliatePayoutConnection",
    items:  Array< {
      __typename: "AffiliatePayout",
      id: string,
      affiliateID: string,
      status: AffiliatePayoutStatus,
      grossCents: number,
      generatedAt: string,
      paidAt?: string | null,
      paymentRef?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliatePayoutsQueryVariables = {
  filter?: ModelAffiliatePayoutFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliatePayoutsQuery = {
  syncAffiliatePayouts?:  {
    __typename: "ModelAffiliatePayoutConnection",
    items:  Array< {
      __typename: "AffiliatePayout",
      id: string,
      affiliateID: string,
      status: AffiliatePayoutStatus,
      grossCents: number,
      generatedAt: string,
      paidAt?: string | null,
      paymentRef?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAffiliateVisitQueryVariables = {
  id: string,
};

export type GetAffiliateVisitQuery = {
  getAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAffiliateVisitsQueryVariables = {
  filter?: ModelAffiliateVisitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAffiliateVisitsQuery = {
  listAffiliateVisits?:  {
    __typename: "ModelAffiliateVisitConnection",
    items:  Array< {
      __typename: "AffiliateVisit",
      id: string,
      affiliateID: string,
      affiliateCode: string,
      visitedAt: string,
      path?: string | null,
      userAgent?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAffiliateVisitsQueryVariables = {
  filter?: ModelAffiliateVisitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAffiliateVisitsQuery = {
  syncAffiliateVisits?:  {
    __typename: "ModelAffiliateVisitConnection",
    items:  Array< {
      __typename: "AffiliateVisit",
      id: string,
      affiliateID: string,
      affiliateCode: string,
      visitedAt: string,
      path?: string | null,
      userAgent?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAmenityQueryVariables = {
  id: string,
};

export type GetAmenityQuery = {
  getAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAmenitiesQueryVariables = {
  filter?: ModelAmenityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAmenitiesQuery = {
  listAmenities?:  {
    __typename: "ModelAmenityConnection",
    items:  Array< {
      __typename: "Amenity",
      id: string,
      propertyID: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      reservationRule:  {
        __typename: "ReservationRule",
        policy: AmenityReservationPolicyOptions,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
        requiresApproval?: boolean | null,
        maxDuration?: string | null,
        minDuration?: string | null,
        furthestTime?: string | null,
        closestTime?: string | null,
        maxPartySize?: number | null,
        maxRequests?: number | null,
      },
      description?: string | null,
      rules?: string | null,
      availability?: Array< string | null > | null,
      geolocation?: string | null,
      locationDescription?: string | null,
      buildingID?: string | null,
      images?: Array< string | null > | null,
      lockUnixTTL?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAmenitiesQueryVariables = {
  filter?: ModelAmenityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAmenitiesQuery = {
  syncAmenities?:  {
    __typename: "ModelAmenityConnection",
    items:  Array< {
      __typename: "Amenity",
      id: string,
      propertyID: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      reservationRule:  {
        __typename: "ReservationRule",
        policy: AmenityReservationPolicyOptions,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
        requiresApproval?: boolean | null,
        maxDuration?: string | null,
        minDuration?: string | null,
        furthestTime?: string | null,
        closestTime?: string | null,
        maxPartySize?: number | null,
        maxRequests?: number | null,
      },
      description?: string | null,
      rules?: string | null,
      availability?: Array< string | null > | null,
      geolocation?: string | null,
      locationDescription?: string | null,
      buildingID?: string | null,
      images?: Array< string | null > | null,
      lockUnixTTL?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAmenityReservationQueryVariables = {
  id: string,
};

export type GetAmenityReservationQuery = {
  getAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAmenityReservationsQueryVariables = {
  filter?: ModelAmenityReservationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAmenityReservationsQuery = {
  listAmenityReservations?:  {
    __typename: "ModelAmenityReservationConnection",
    items:  Array< {
      __typename: "AmenityReservation",
      id: string,
      amenityID: string,
      tenantID: string,
      startDate: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      details?: string | null,
      status?: AmenityReservationStatus | null,
      statusReason?: string | null,
      endDate: string,
      reviewer?: string | null,
      partySize?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAmenityReservationsQueryVariables = {
  filter?: ModelAmenityReservationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAmenityReservationsQuery = {
  syncAmenityReservations?:  {
    __typename: "ModelAmenityReservationConnection",
    items:  Array< {
      __typename: "AmenityReservation",
      id: string,
      amenityID: string,
      tenantID: string,
      startDate: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      details?: string | null,
      status?: AmenityReservationStatus | null,
      statusReason?: string | null,
      endDate: string,
      reviewer?: string | null,
      partySize?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetApplicationQueryVariables = {
  id: string,
};

export type GetApplicationQuery = {
  getApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListApplicationsQueryVariables = {
  filter?: ModelApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListApplicationsQuery = {
  listApplications?:  {
    __typename: "ModelApplicationConnection",
    items:  Array< {
      __typename: "Application",
      id: string,
      status: ApplicationStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      moveInDatePreference?: string | null,
      rentPaymentPreference?: RentPaymentMethodType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncApplicationsQueryVariables = {
  filter?: ModelApplicationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncApplicationsQuery = {
  syncApplications?:  {
    __typename: "ModelApplicationConnection",
    items:  Array< {
      __typename: "Application",
      id: string,
      status: ApplicationStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      moveInDatePreference?: string | null,
      rentPaymentPreference?: RentPaymentMethodType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBackgroundCheckQueryVariables = {
  id: string,
};

export type GetBackgroundCheckQuery = {
  getBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBackgroundChecksQueryVariables = {
  filter?: ModelBackgroundCheckFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBackgroundChecksQuery = {
  listBackgroundChecks?:  {
    __typename: "ModelBackgroundCheckConnection",
    items:  Array< {
      __typename: "BackgroundCheck",
      id: string,
      status: BackgroundCheckStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBackgroundChecksQueryVariables = {
  filter?: ModelBackgroundCheckFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBackgroundChecksQuery = {
  syncBackgroundChecks?:  {
    __typename: "ModelBackgroundCheckConnection",
    items:  Array< {
      __typename: "BackgroundCheck",
      id: string,
      status: BackgroundCheckStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBuildingQueryVariables = {
  id: string,
};

export type GetBuildingQuery = {
  getBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBuildingsQueryVariables = {
  filter?: ModelBuildingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuildingsQuery = {
  listBuildings?:  {
    __typename: "ModelBuildingConnection",
    items:  Array< {
      __typename: "Building",
      id: string,
      status: BuildingStatusType,
      propertyID: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      rent?: number | null,
      price?: number | null,
      numBedroom?: string | null,
      numBathroom?: string | null,
      actualRentPaymentDate?: string | null,
      size?: string | null,
      street?: string | null,
      type?: BuildingType | null,
      contact?: string | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBuildingsQueryVariables = {
  filter?: ModelBuildingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBuildingsQuery = {
  syncBuildings?:  {
    __typename: "ModelBuildingConnection",
    items:  Array< {
      __typename: "Building",
      id: string,
      status: BuildingStatusType,
      propertyID: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      rent?: number | null,
      price?: number | null,
      numBedroom?: string | null,
      numBathroom?: string | null,
      actualRentPaymentDate?: string | null,
      size?: string | null,
      street?: string | null,
      type?: BuildingType | null,
      contact?: string | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetChargesQueryVariables = {
  id: string,
};

export type GetChargesQuery = {
  getCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListChargesQueryVariables = {
  filter?: ModelChargesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChargesQuery = {
  listCharges?:  {
    __typename: "ModelChargesConnection",
    items:  Array< {
      __typename: "Charges",
      id: string,
      type: ChargesTypes,
      isRevenue: boolean,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncChargesQueryVariables = {
  filter?: ModelChargesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncChargesQuery = {
  syncCharges?:  {
    __typename: "ModelChargesConnection",
    items:  Array< {
      __typename: "Charges",
      id: string,
      type: ChargesTypes,
      isRevenue: boolean,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCommentsQueryVariables = {
  id: string,
};

export type GetCommentsQuery = {
  getComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCommentsQueryVariables = {
  filter?: ModelCommentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCommentsQuery = {
  listComments?:  {
    __typename: "ModelCommentsConnection",
    items:  Array< {
      __typename: "Comments",
      id: string,
      commenter: string,
      text: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdDate?: string | null,
      parentID?: string | null,
      type?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCommentsQueryVariables = {
  filter?: ModelCommentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCommentsQuery = {
  syncComments?:  {
    __typename: "ModelCommentsConnection",
    items:  Array< {
      __typename: "Comments",
      id: string,
      commenter: string,
      text: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdDate?: string | null,
      parentID?: string | null,
      type?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEntityFieldQueryVariables = {
  id: string,
};

export type GetEntityFieldQuery = {
  getEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEntityFieldsQueryVariables = {
  filter?: ModelEntityFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityFieldsQuery = {
  listEntityFields?:  {
    __typename: "ModelEntityFieldConnection",
    items:  Array< {
      __typename: "EntityField",
      id: string,
      entityID: string,
      entityType: string,
      name: string,
      type: EntityFieldType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      value?: string | null,
      date?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEntityFieldsQueryVariables = {
  filter?: ModelEntityFieldFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEntityFieldsQuery = {
  syncEntityFields?:  {
    __typename: "ModelEntityFieldConnection",
    items:  Array< {
      __typename: "EntityField",
      id: string,
      entityID: string,
      entityType: string,
      name: string,
      type: EntityFieldType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      value?: string | null,
      date?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEventQueryVariables = {
  id: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      entityType: EntityType,
      entityID: string,
      ownerID: string,
      ownerType: OwnerType,
      name: string,
      date?: string | null,
      type?: string | null,
      comment?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEventsQuery = {
  syncEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      entityType: EntityType,
      entityID: string,
      ownerID: string,
      ownerType: OwnerType,
      name: string,
      date?: string | null,
      type?: string | null,
      comment?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFavoriteQueryVariables = {
  id: string,
};

export type GetFavoriteQuery = {
  getFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFavoritesQueryVariables = {
  filter?: ModelFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFavoritesQuery = {
  listFavorites?:  {
    __typename: "ModelFavoriteConnection",
    items:  Array< {
      __typename: "Favorite",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      favType?: string | null,
      favID?: string | null,
      image?: string | null,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFavoritesQueryVariables = {
  filter?: ModelFavoriteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFavoritesQuery = {
  syncFavorites?:  {
    __typename: "ModelFavoriteConnection",
    items:  Array< {
      __typename: "Favorite",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      favType?: string | null,
      favID?: string | null,
      image?: string | null,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFinanceLockQueryVariables = {
  id: string,
};

export type GetFinanceLockQuery = {
  getFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFinanceLocksQueryVariables = {
  filter?: ModelFinanceLockFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFinanceLocksQuery = {
  listFinanceLocks?:  {
    __typename: "ModelFinanceLockConnection",
    items:  Array< {
      __typename: "FinanceLock",
      id: string,
      scope: string,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: EntityType | null,
      year: number,
      month?: number | null,
      lockUnixTTL?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFinanceLocksQueryVariables = {
  filter?: ModelFinanceLockFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFinanceLocksQuery = {
  syncFinanceLocks?:  {
    __typename: "ModelFinanceLockConnection",
    items:  Array< {
      __typename: "FinanceLock",
      id: string,
      scope: string,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: EntityType | null,
      year: number,
      month?: number | null,
      lockUnixTTL?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetJoinOrganizationRequestQueryVariables = {
  id: string,
};

export type GetJoinOrganizationRequestQuery = {
  getJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListJoinOrganizationRequestsQueryVariables = {
  filter?: ModelJoinOrganizationRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJoinOrganizationRequestsQuery = {
  listJoinOrganizationRequests?:  {
    __typename: "ModelJoinOrganizationRequestConnection",
    items:  Array< {
      __typename: "JoinOrganizationRequest",
      id: string,
      userID: string,
      requestStatus: JoinOrganizationRequestStatus,
      organizationID?: string | null,
      requestPropertyTransfer?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncJoinOrganizationRequestsQueryVariables = {
  filter?: ModelJoinOrganizationRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncJoinOrganizationRequestsQuery = {
  syncJoinOrganizationRequests?:  {
    __typename: "ModelJoinOrganizationRequestConnection",
    items:  Array< {
      __typename: "JoinOrganizationRequest",
      id: string,
      userID: string,
      requestStatus: JoinOrganizationRequestStatus,
      organizationID?: string | null,
      requestPropertyTransfer?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLeaseQueryVariables = {
  id: string,
};

export type GetLeaseQuery = {
  getLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLeasesQueryVariables = {
  filter?: ModelLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLeasesQuery = {
  listLeases?:  {
    __typename: "ModelLeaseConnection",
    items:  Array< {
      __typename: "Lease",
      id: string,
      entityType: EntityType,
      entityID: string,
      type: LeaseTypeOptions,
      status: LeaseStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      tenantID?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      markedDate?: string | null,
      extraOccupants?: Array< string | null > | null,
      applicationID?: string | null,
      backgroundCheckID?: string | null,
      offerID?: string | null,
      moveInID?: string | null,
      moveOutID?: string | null,
      nextLeaseID?: string | null,
      prevLeaseID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLeasesQueryVariables = {
  filter?: ModelLeaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLeasesQuery = {
  syncLeases?:  {
    __typename: "ModelLeaseConnection",
    items:  Array< {
      __typename: "Lease",
      id: string,
      entityType: EntityType,
      entityID: string,
      type: LeaseTypeOptions,
      status: LeaseStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      tenantID?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      markedDate?: string | null,
      extraOccupants?: Array< string | null > | null,
      applicationID?: string | null,
      backgroundCheckID?: string | null,
      offerID?: string | null,
      moveInID?: string | null,
      moveOutID?: string | null,
      nextLeaseID?: string | null,
      prevLeaseID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMessageQueryVariables = {
  id: string,
};

export type GetMessageQuery = {
  getMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMessagesQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessagesQuery = {
  listMessages?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      id: string,
      title: string,
      content: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      senderID?: string | null,
      senderName?: string | null,
      receiverID?: string | null,
      receiverName?: string | null,
      messageTitle?: string | null,
      type?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMessagesQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMessagesQuery = {
  syncMessages?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      id: string,
      title: string,
      content: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      senderID?: string | null,
      senderName?: string | null,
      receiverID?: string | null,
      receiverName?: string | null,
      messageTitle?: string | null,
      type?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMonthlyFinanceReportQueryVariables = {
  id: string,
};

export type GetMonthlyFinanceReportQuery = {
  getMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMonthlyFinanceReportsQueryVariables = {
  filter?: ModelMonthlyFinanceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonthlyFinanceReportsQuery = {
  listMonthlyFinanceReports?:  {
    __typename: "ModelMonthlyFinanceReportConnection",
    items:  Array< {
      __typename: "MonthlyFinanceReport",
      id: string,
      yearlyReportId: string,
      month: number,
      year: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: string | null,
      income?:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMonthlyFinanceReportsQueryVariables = {
  filter?: ModelMonthlyFinanceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMonthlyFinanceReportsQuery = {
  syncMonthlyFinanceReports?:  {
    __typename: "ModelMonthlyFinanceReportConnection",
    items:  Array< {
      __typename: "MonthlyFinanceReport",
      id: string,
      yearlyReportId: string,
      month: number,
      year: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: string | null,
      income?:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMonthlyStatusReportQueryVariables = {
  id: string,
};

export type GetMonthlyStatusReportQuery = {
  getMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMonthlyStatusReportsQueryVariables = {
  filter?: ModelMonthlyStatusReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMonthlyStatusReportsQuery = {
  listMonthlyStatusReports?:  {
    __typename: "ModelMonthlyStatusReportConnection",
    items:  Array< {
      __typename: "MonthlyStatusReport",
      id: string,
      entityID?: string | null,
      entityType?: string | null,
      month: number,
      year: number,
      numOccupied: number,
      numVacant: number,
      numRenovation: number,
      numUnits: number,
      numBuildings: number,
      numProperties: number,
      numServiceRequests: number,
      numAmenities: number,
      numAmenityReservations: number,
      expectedRent: number,
      expectedStayRevenue?: number | null,
      aggregateIncome:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      },
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMonthlyStatusReportsQueryVariables = {
  filter?: ModelMonthlyStatusReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMonthlyStatusReportsQuery = {
  syncMonthlyStatusReports?:  {
    __typename: "ModelMonthlyStatusReportConnection",
    items:  Array< {
      __typename: "MonthlyStatusReport",
      id: string,
      entityID?: string | null,
      entityType?: string | null,
      month: number,
      year: number,
      numOccupied: number,
      numVacant: number,
      numRenovation: number,
      numUnits: number,
      numBuildings: number,
      numProperties: number,
      numServiceRequests: number,
      numAmenities: number,
      numAmenityReservations: number,
      expectedRent: number,
      expectedStayRevenue?: number | null,
      aggregateIncome:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      },
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMoveExamQueryVariables = {
  id: string,
};

export type GetMoveExamQuery = {
  getMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMoveExamsQueryVariables = {
  filter?: ModelMoveExamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMoveExamsQuery = {
  listMoveExams?:  {
    __typename: "ModelMoveExamConnection",
    items:  Array< {
      __typename: "MoveExam",
      id: string,
      type: MoveExamType,
      status: MoveExamStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMoveExamsQueryVariables = {
  filter?: ModelMoveExamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMoveExamsQuery = {
  syncMoveExams?:  {
    __typename: "ModelMoveExamConnection",
    items:  Array< {
      __typename: "MoveExam",
      id: string,
      type: MoveExamType,
      status: MoveExamStatusType,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      endDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetOfferQueryVariables = {
  id: string,
};

export type GetOfferQuery = {
  getOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListOffersQueryVariables = {
  filter?: ModelOfferFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOffersQuery = {
  listOffers?:  {
    __typename: "ModelOfferConnection",
    items:  Array< {
      __typename: "Offer",
      id: string,
      status: OfferStatusType,
      rent: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      tenantSignDate?: string | null,
      landlordSignDate?: string | null,
      endDate?: string | null,
      rentCycle?: RentCycle | null,
      normalizedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncOffersQueryVariables = {
  filter?: ModelOfferFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncOffersQuery = {
  syncOffers?:  {
    __typename: "ModelOfferConnection",
    items:  Array< {
      __typename: "Offer",
      id: string,
      status: OfferStatusType,
      rent: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      startDate?: string | null,
      tenantSignDate?: string | null,
      landlordSignDate?: string | null,
      endDate?: string | null,
      rentCycle?: RentCycle | null,
      normalizedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetOrganizationQueryVariables = {
  id: string,
};

export type GetOrganizationQuery = {
  getOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListOrganizationsQueryVariables = {
  filter?: ModelOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrganizationsQuery = {
  listOrganizations?:  {
    __typename: "ModelOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncOrganizationsQueryVariables = {
  filter?: ModelOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncOrganizationsQuery = {
  syncOrganizations?:  {
    __typename: "ModelOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetParcelQueryVariables = {
  id: string,
};

export type GetParcelQuery = {
  getParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListParcelsQueryVariables = {
  filter?: ModelParcelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListParcelsQuery = {
  listParcels?:  {
    __typename: "ModelParcelConnection",
    items:  Array< {
      __typename: "Parcel",
      id: string,
      propertyID: string,
      status: ParcelStatusType,
      name: string,
      description?: string | null,
      areaSize?: string | null,
      boundaryNote?: string | null,
      rent?: number | null,
      price?: number | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncParcelsQueryVariables = {
  filter?: ModelParcelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncParcelsQuery = {
  syncParcels?:  {
    __typename: "ModelParcelConnection",
    items:  Array< {
      __typename: "Parcel",
      id: string,
      propertyID: string,
      status: ParcelStatusType,
      name: string,
      description?: string | null,
      areaSize?: string | null,
      boundaryNote?: string | null,
      rent?: number | null,
      price?: number | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPaymentReceiptQueryVariables = {
  id: string,
};

export type GetPaymentReceiptQuery = {
  getPaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPaymentReceiptsQueryVariables = {
  filter?: ModelPaymentReceiptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentReceiptsQuery = {
  listPaymentReceipts?:  {
    __typename: "ModelPaymentReceiptConnection",
    items:  Array< {
      __typename: "PaymentReceipt",
      id: string,
      transactionID: string,
      status: PaymentReceiptStatus,
      failureReason?: string | null,
      s3Key?: string | null,
      s3Keys?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      signedByUserID?: string | null,
      signedByUserName?: string | null,
      generatedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPaymentReceiptsQueryVariables = {
  filter?: ModelPaymentReceiptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPaymentReceiptsQuery = {
  syncPaymentReceipts?:  {
    __typename: "ModelPaymentReceiptConnection",
    items:  Array< {
      __typename: "PaymentReceipt",
      id: string,
      transactionID: string,
      status: PaymentReceiptStatus,
      failureReason?: string | null,
      s3Key?: string | null,
      s3Keys?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      signedByUserID?: string | null,
      signedByUserName?: string | null,
      generatedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPropertyQueryVariables = {
  id: string,
};

export type GetPropertyQuery = {
  getProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPropertiesQueryVariables = {
  filter?: ModelPropertyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPropertiesQuery = {
  listProperties?:  {
    __typename: "ModelPropertyConnection",
    items:  Array< {
      __typename: "Property",
      id: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      areaSize?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      zipCode?: string | null,
      contact?: string | null,
      expectedRentPaymentDate?: string | null,
      poBox?: string | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPropertiesQueryVariables = {
  filter?: ModelPropertyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPropertiesQuery = {
  syncProperties?:  {
    __typename: "ModelPropertyConnection",
    items:  Array< {
      __typename: "Property",
      id: string,
      name: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      areaSize?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      country?: string | null,
      zipCode?: string | null,
      contact?: string | null,
      expectedRentPaymentDate?: string | null,
      poBox?: string | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetResourceLifeAccessRightQueryVariables = {
  id: string,
};

export type GetResourceLifeAccessRightQuery = {
  getResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListResourceLifeAccessRightsQueryVariables = {
  filter?: ModelResourceLifeAccessRightFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceLifeAccessRightsQuery = {
  listResourceLifeAccessRights?:  {
    __typename: "ModelResourceLifeAccessRightConnection",
    items:  Array< {
      __typename: "ResourceLifeAccessRight",
      id: string,
      resourceType: EntityType,
      createAccessStatus: ResourceAccessRightStatus,
      createAccessApproverID?: string | null,
      createAccessApprovalDate?: string | null,
      deleteAccessStatus: ResourceAccessRightStatus,
      deleteAccessApproverID?: string | null,
      deleteAccessApprovalDate?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncResourceLifeAccessRightsQueryVariables = {
  filter?: ModelResourceLifeAccessRightFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncResourceLifeAccessRightsQuery = {
  syncResourceLifeAccessRights?:  {
    __typename: "ModelResourceLifeAccessRightConnection",
    items:  Array< {
      __typename: "ResourceLifeAccessRight",
      id: string,
      resourceType: EntityType,
      createAccessStatus: ResourceAccessRightStatus,
      createAccessApproverID?: string | null,
      createAccessApprovalDate?: string | null,
      deleteAccessStatus: ResourceAccessRightStatus,
      deleteAccessApproverID?: string | null,
      deleteAccessApprovalDate?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetResourceUpdateAccessRightQueryVariables = {
  id: string,
};

export type GetResourceUpdateAccessRightQuery = {
  getResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListResourceUpdateAccessRightsQueryVariables = {
  filter?: ModelResourceUpdateAccessRightFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceUpdateAccessRightsQuery = {
  listResourceUpdateAccessRights?:  {
    __typename: "ModelResourceUpdateAccessRightConnection",
    items:  Array< {
      __typename: "ResourceUpdateAccessRight",
      id: string,
      resourceType: EntityType,
      resourceID: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      readAccessStatus: ResourceAccessRightStatus,
      readAccessApproverID?: string | null,
      readAccessApprovalDate?: string | null,
      writeAccessStatus: ResourceAccessRightStatus,
      writeAccessApproverID?: string | null,
      writeAccessApprovalDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncResourceUpdateAccessRightsQueryVariables = {
  filter?: ModelResourceUpdateAccessRightFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncResourceUpdateAccessRightsQuery = {
  syncResourceUpdateAccessRights?:  {
    __typename: "ModelResourceUpdateAccessRightConnection",
    items:  Array< {
      __typename: "ResourceUpdateAccessRight",
      id: string,
      resourceType: EntityType,
      resourceID: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      readAccessStatus: ResourceAccessRightStatus,
      readAccessApproverID?: string | null,
      readAccessApprovalDate?: string | null,
      writeAccessStatus: ResourceAccessRightStatus,
      writeAccessApproverID?: string | null,
      writeAccessApprovalDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetServiceRequestQueryVariables = {
  id: string,
};

export type GetServiceRequestQuery = {
  getServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListServiceRequestsQueryVariables = {
  filter?: ModelServiceRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListServiceRequestsQuery = {
  listServiceRequests?:  {
    __typename: "ModelServiceRequestConnection",
    items:  Array< {
      __typename: "ServiceRequest",
      id: string,
      entityID: string,
      entityType: string,
      creatorID: string,
      description: string,
      title: string,
      type: ServiceRequestType,
      isUpgrade: boolean,
      status: ServiceRequestStatusType,
      emergency: boolean,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      creatorName?: string | null,
      handlerID?: string | null,
      handlerName?: string | null,
      watcherID?: string | null,
      watcherName?: string | null,
      tenantID?: string | null,
      tenantName?: string | null,
      contractor?: string | null,
      dateCreated?: string | null,
      dateUpdated?: string | null,
      estimatedCost?: number | null,
      finalCost?: number | null,
      images?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncServiceRequestsQueryVariables = {
  filter?: ModelServiceRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncServiceRequestsQuery = {
  syncServiceRequests?:  {
    __typename: "ModelServiceRequestConnection",
    items:  Array< {
      __typename: "ServiceRequest",
      id: string,
      entityID: string,
      entityType: string,
      creatorID: string,
      description: string,
      title: string,
      type: ServiceRequestType,
      isUpgrade: boolean,
      status: ServiceRequestStatusType,
      emergency: boolean,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      creatorName?: string | null,
      handlerID?: string | null,
      handlerName?: string | null,
      watcherID?: string | null,
      watcherName?: string | null,
      tenantID?: string | null,
      tenantName?: string | null,
      contractor?: string | null,
      dateCreated?: string | null,
      dateUpdated?: string | null,
      estimatedCost?: number | null,
      finalCost?: number | null,
      images?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetStayQueryVariables = {
  id: string,
};

export type GetStayQuery = {
  getStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListStaysQueryVariables = {
  filter?: ModelStayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStaysQuery = {
  listStays?:  {
    __typename: "ModelStayConnection",
    items:  Array< {
      __typename: "Stay",
      id: string,
      entityType: EntityType,
      entityID: string,
      checkIn: string,
      checkOut: string,
      status: StayStatusType,
      tenantID: string,
      nightlyRate?: number | null,
      totalAmount?: number | null,
      currency?: string | null,
      notes?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncStaysQueryVariables = {
  filter?: ModelStayFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncStaysQuery = {
  syncStays?:  {
    __typename: "ModelStayConnection",
    items:  Array< {
      __typename: "Stay",
      id: string,
      entityType: EntityType,
      entityID: string,
      checkIn: string,
      checkOut: string,
      status: StayStatusType,
      tenantID: string,
      nightlyRate?: number | null,
      totalAmount?: number | null,
      currency?: string | null,
      notes?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetStayRateQueryVariables = {
  id: string,
};

export type GetStayRateQuery = {
  getStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListStayRatesQueryVariables = {
  filter?: ModelStayRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStayRatesQuery = {
  listStayRates?:  {
    __typename: "ModelStayRateConnection",
    items:  Array< {
      __typename: "StayRate",
      id: string,
      entityType: EntityType,
      entityID: string,
      nightlyRate: number,
      weeklyRate?: number | null,
      minNights?: number | null,
      maxNights?: number | null,
      cleaningFee?: number | null,
      currency?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncStayRatesQueryVariables = {
  filter?: ModelStayRateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncStayRatesQuery = {
  syncStayRates?:  {
    __typename: "ModelStayRateConnection",
    items:  Array< {
      __typename: "StayRate",
      id: string,
      entityType: EntityType,
      entityID: string,
      nightlyRate: number,
      weeklyRate?: number | null,
      minNights?: number | null,
      maxNights?: number | null,
      cleaningFee?: number | null,
      currency?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetStayAvailabilityQueryVariables = {
  id: string,
};

export type GetStayAvailabilityQuery = {
  getStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListStayAvailabilitiesQueryVariables = {
  filter?: ModelStayAvailabilityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStayAvailabilitiesQuery = {
  listStayAvailabilities?:  {
    __typename: "ModelStayAvailabilityConnection",
    items:  Array< {
      __typename: "StayAvailability",
      id: string,
      entityType: EntityType,
      entityID: string,
      start: string,
      end: string,
      reason?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncStayAvailabilitiesQueryVariables = {
  filter?: ModelStayAvailabilityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncStayAvailabilitiesQuery = {
  syncStayAvailabilities?:  {
    __typename: "ModelStayAvailabilityConnection",
    items:  Array< {
      __typename: "StayAvailability",
      id: string,
      entityType: EntityType,
      entityID: string,
      start: string,
      end: string,
      reason?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSubscriptionDiscountQueryVariables = {
  id: string,
};

export type GetSubscriptionDiscountQuery = {
  getSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSubscriptionDiscountsQueryVariables = {
  filter?: ModelSubscriptionDiscountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionDiscountsQuery = {
  listSubscriptionDiscounts?:  {
    __typename: "ModelSubscriptionDiscountConnection",
    items:  Array< {
      __typename: "SubscriptionDiscount",
      id: string,
      planID: string,
      startDate: string,
      endDate: string,
      percentage: number,
      isActive: boolean,
      codeID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSubscriptionDiscountsQueryVariables = {
  filter?: ModelSubscriptionDiscountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSubscriptionDiscountsQuery = {
  syncSubscriptionDiscounts?:  {
    __typename: "ModelSubscriptionDiscountConnection",
    items:  Array< {
      __typename: "SubscriptionDiscount",
      id: string,
      planID: string,
      startDate: string,
      endDate: string,
      percentage: number,
      isActive: boolean,
      codeID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSubscriptionDiscountCodeQueryVariables = {
  id: string,
};

export type GetSubscriptionDiscountCodeQuery = {
  getSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSubscriptionDiscountCodesQueryVariables = {
  filter?: ModelSubscriptionDiscountCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionDiscountCodesQuery = {
  listSubscriptionDiscountCodes?:  {
    __typename: "ModelSubscriptionDiscountCodeConnection",
    items:  Array< {
      __typename: "SubscriptionDiscountCode",
      id: string,
      code: string,
      userID?: string | null,
      usageCount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSubscriptionDiscountCodesQueryVariables = {
  filter?: ModelSubscriptionDiscountCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSubscriptionDiscountCodesQuery = {
  syncSubscriptionDiscountCodes?:  {
    __typename: "ModelSubscriptionDiscountCodeConnection",
    items:  Array< {
      __typename: "SubscriptionDiscountCode",
      id: string,
      code: string,
      userID?: string | null,
      usageCount?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSubscriptionLinkQueryVariables = {
  id: string,
};

export type GetSubscriptionLinkQuery = {
  getSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSubscriptionLinksQueryVariables = {
  filter?: ModelSubscriptionLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionLinksQuery = {
  listSubscriptionLinks?:  {
    __typename: "ModelSubscriptionLinkConnection",
    items:  Array< {
      __typename: "SubscriptionLink",
      id: string,
      userID: string,
      planID: string,
      startDate: string,
      endDate: string,
      renewalType: SubscriptionRenewalType,
      autoRenewal: boolean,
      nextPaymentAmount: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSubscriptionLinksQueryVariables = {
  filter?: ModelSubscriptionLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSubscriptionLinksQuery = {
  syncSubscriptionLinks?:  {
    __typename: "ModelSubscriptionLinkConnection",
    items:  Array< {
      __typename: "SubscriptionLink",
      id: string,
      userID: string,
      planID: string,
      startDate: string,
      endDate: string,
      renewalType: SubscriptionRenewalType,
      autoRenewal: boolean,
      nextPaymentAmount: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSubscriptionPlanQueryVariables = {
  id: string,
};

export type GetSubscriptionPlanQuery = {
  getSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSubscriptionPlansQueryVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubscriptionPlansQuery = {
  listSubscriptionPlans?:  {
    __typename: "ModelSubscriptionPlanConnection",
    items:  Array< {
      __typename: "SubscriptionPlan",
      id: string,
      name: string,
      description: string,
      price: number,
      isActive: boolean,
      features: Array< SubscriptionPlanFeature | null >,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSubscriptionPlansQueryVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSubscriptionPlansQuery = {
  syncSubscriptionPlans?:  {
    __typename: "ModelSubscriptionPlanConnection",
    items:  Array< {
      __typename: "SubscriptionPlan",
      id: string,
      name: string,
      description: string,
      price: number,
      isActive: boolean,
      features: Array< SubscriptionPlanFeature | null >,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTenantQueryVariables = {
  id: string,
};

export type GetTenantQuery = {
  getTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTenantsQueryVariables = {
  filter?: ModelTenantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTenantsQuery = {
  listTenants?:  {
    __typename: "ModelTenantConnection",
    items:  Array< {
      __typename: "Tenant",
      id: string,
      authUID?: string | null,
      username?: string | null,
      firstName: string,
      middleName?: string | null,
      lastName: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      status?: TenantStatusType | null,
      type?: TenantType | null,
      phoneNumber?: string | null,
      jobTitle?: string | null,
      jobPhone?: string | null,
      jobEmail?: string | null,
      jobContactName?: string | null,
      income?: string | null,
      cimesCommitted?: string | null,
      jailTime?: string | null,
      lastArrest?: string | null,
      lastUpdated?: string | null,
      totalCredit?: string | null,
      employer?: string | null,
      email?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTenantsQueryVariables = {
  filter?: ModelTenantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTenantsQuery = {
  syncTenants?:  {
    __typename: "ModelTenantConnection",
    items:  Array< {
      __typename: "Tenant",
      id: string,
      authUID?: string | null,
      username?: string | null,
      firstName: string,
      middleName?: string | null,
      lastName: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      status?: TenantStatusType | null,
      type?: TenantType | null,
      phoneNumber?: string | null,
      jobTitle?: string | null,
      jobPhone?: string | null,
      jobEmail?: string | null,
      jobContactName?: string | null,
      income?: string | null,
      cimesCommitted?: string | null,
      jailTime?: string | null,
      lastArrest?: string | null,
      lastUpdated?: string | null,
      totalCredit?: string | null,
      employer?: string | null,
      email?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsQuery = {
  listTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      amount: number,
      reason: TransactionReason,
      currency?: string | null,
      entityID: string,
      entityType: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      month: number,
      year: number,
      periodStart?: string | null,
      periodEnd?: string | null,
      tenantID: string,
      managerID: string,
      status: PaymentStatusType,
      dateSent?: string | null,
      dateReceived?: string | null,
      paymentMethod?: RentPaymentMethodType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTransactionsQuery = {
  syncTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      amount: number,
      reason: TransactionReason,
      currency?: string | null,
      entityID: string,
      entityType: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      month: number,
      year: number,
      periodStart?: string | null,
      periodEnd?: string | null,
      tenantID: string,
      managerID: string,
      status: PaymentStatusType,
      dateSent?: string | null,
      dateReceived?: string | null,
      paymentMethod?: RentPaymentMethodType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitPlanQueryVariables = {
  id: string,
};

export type GetUnitPlanQuery = {
  getUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitPlansQueryVariables = {
  filter?: ModelUnitPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitPlansQuery = {
  listUnitPlans?:  {
    __typename: "ModelUnitPlanConnection",
    items:  Array< {
      __typename: "UnitPlan",
      id: string,
      propertyID: string,
      name: string,
      description?: string | null,
      numBedroom?: string | null,
      numBathroom?: string | null,
      size?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      inUnitLaundry?: boolean | null,
      dishwasher?: boolean | null,
      airConditioning?: boolean | null,
      furnished?: boolean | null,
      balcony?: boolean | null,
      petFriendly?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitPlansQueryVariables = {
  filter?: ModelUnitPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitPlansQuery = {
  syncUnitPlans?:  {
    __typename: "ModelUnitPlanConnection",
    items:  Array< {
      __typename: "UnitPlan",
      id: string,
      propertyID: string,
      name: string,
      description?: string | null,
      numBedroom?: string | null,
      numBathroom?: string | null,
      size?: string | null,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      inUnitLaundry?: boolean | null,
      dishwasher?: boolean | null,
      airConditioning?: boolean | null,
      furnished?: boolean | null,
      balcony?: boolean | null,
      petFriendly?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUnitQueryVariables = {
  id: string,
};

export type GetUnitQuery = {
  getUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUnitsQueryVariables = {
  filter?: ModelUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUnitsQuery = {
  listUnits?:  {
    __typename: "ModelUnitConnection",
    items:  Array< {
      __typename: "Unit",
      id: string,
      status: UnitStatusType,
      name: string,
      rent: number,
      price?: number | null,
      numBedroom: string,
      numBathroom: string,
      buildingID: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      availabilityDate?: string | null,
      actualRentPaymentDate?: string | null,
      activeLeaseID?: string | null,
      type?: string | null,
      unitPlanID?: string | null,
      size?: string | null,
      street?: string | null,
      deposit?: number | null,
      additionalFees?: number | null,
      feesDescription?: string | null,
      tenantID?: string | null,
      contact?: string | null,
      inUnitLaundry?: boolean | null,
      dishwasher?: boolean | null,
      airConditioning?: boolean | null,
      furnished?: boolean | null,
      balcony?: boolean | null,
      petFriendly?: boolean | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUnitsQueryVariables = {
  filter?: ModelUnitFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUnitsQuery = {
  syncUnits?:  {
    __typename: "ModelUnitConnection",
    items:  Array< {
      __typename: "Unit",
      id: string,
      status: UnitStatusType,
      name: string,
      rent: number,
      price?: number | null,
      numBedroom: string,
      numBathroom: string,
      buildingID: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      description?: string | null,
      availabilityDate?: string | null,
      actualRentPaymentDate?: string | null,
      activeLeaseID?: string | null,
      type?: string | null,
      unitPlanID?: string | null,
      size?: string | null,
      street?: string | null,
      deposit?: number | null,
      additionalFees?: number | null,
      feesDescription?: string | null,
      tenantID?: string | null,
      contact?: string | null,
      inUnitLaundry?: boolean | null,
      dishwasher?: boolean | null,
      airConditioning?: boolean | null,
      furnished?: boolean | null,
      balcony?: boolean | null,
      petFriendly?: boolean | null,
      shortTermStayEnabled?: boolean | null,
      forSaleEnabled?: boolean | null,
      stayRequireApproval?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      authUID?: string | null,
      username?: string | null,
      title?: string | null,
      type?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      salary?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      email?: string | null,
      officeAddress?: string | null,
      workingHours?: Array< string | null > | null,
      roles?: ManagerRolesType | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUsersQuery = {
  syncUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      authUID?: string | null,
      username?: string | null,
      title?: string | null,
      type?: string | null,
      firstName?: string | null,
      middleName?: string | null,
      lastName?: string | null,
      salary?: string | null,
      companyName?: string | null,
      phoneNumber?: string | null,
      email?: string | null,
      officeAddress?: string | null,
      workingHours?: Array< string | null > | null,
      roles?: ManagerRolesType | null,
      organizationID?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserOrganizationConnectionQueryVariables = {
  id: string,
};

export type GetUserOrganizationConnectionQuery = {
  getUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserOrganizationConnectionsQueryVariables = {
  filter?: ModelUserOrganizationConnectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserOrganizationConnectionsQuery = {
  listUserOrganizationConnections?:  {
    __typename: "ModelUserOrganizationConnectionConnection",
    items:  Array< {
      __typename: "UserOrganizationConnection",
      id: string,
      userID?: string | null,
      username?: string | null,
      creatorID?: string | null,
      creatorName?: string | null,
      organizationID?: string | null,
      managerID?: string | null,
      managerName?: string | null,
      title?: string | null,
      salary?: string | null,
      ownershipType?: string | null,
      clearanceLevel?: string | null,
      joinedDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserOrganizationConnectionsQueryVariables = {
  filter?: ModelUserOrganizationConnectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserOrganizationConnectionsQuery = {
  syncUserOrganizationConnections?:  {
    __typename: "ModelUserOrganizationConnectionConnection",
    items:  Array< {
      __typename: "UserOrganizationConnection",
      id: string,
      userID?: string | null,
      username?: string | null,
      creatorID?: string | null,
      creatorName?: string | null,
      organizationID?: string | null,
      managerID?: string | null,
      managerName?: string | null,
      title?: string | null,
      salary?: string | null,
      ownershipType?: string | null,
      clearanceLevel?: string | null,
      joinedDate?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetYearlyReportSummaryQueryVariables = {
  id: string,
};

export type GetYearlyReportSummaryQuery = {
  getYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListYearlyReportSummariesQueryVariables = {
  filter?: ModelYearlyReportSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListYearlyReportSummariesQuery = {
  listYearlyReportSummaries?:  {
    __typename: "ModelYearlyReportSummaryConnection",
    items:  Array< {
      __typename: "YearlyReportSummary",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      year: number,
      entityID?: string | null,
      entityType?: string | null,
      income?:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncYearlyReportSummariesQueryVariables = {
  filter?: ModelYearlyReportSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncYearlyReportSummariesQuery = {
  syncYearlyReportSummaries?:  {
    __typename: "ModelYearlyReportSummaryConnection",
    items:  Array< {
      __typename: "YearlyReportSummary",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      year: number,
      entityID?: string | null,
      entityType?: string | null,
      income?:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetYearlyStatusSummaryQueryVariables = {
  id: string,
};

export type GetYearlyStatusSummaryQuery = {
  getYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListYearlyStatusSummariesQueryVariables = {
  filter?: ModelYearlyStatusSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListYearlyStatusSummariesQuery = {
  listYearlyStatusSummaries?:  {
    __typename: "ModelYearlyStatusSummaryConnection",
    items:  Array< {
      __typename: "YearlyStatusSummary",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: string | null,
      year: number,
      numOccupied: number,
      numVacant: number,
      numRenovation: number,
      numUnits: number,
      numBuildings: number,
      numProperties: number,
      numServiceRequests: number,
      numAmenities: number,
      numAmenityReservations: number,
      expectedRent: number,
      expectedStayRevenue?: number | null,
      aggregateIncome:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      },
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncYearlyStatusSummariesQueryVariables = {
  filter?: ModelYearlyStatusSummaryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncYearlyStatusSummariesQuery = {
  syncYearlyStatusSummaries?:  {
    __typename: "ModelYearlyStatusSummaryConnection",
    items:  Array< {
      __typename: "YearlyStatusSummary",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      entityID?: string | null,
      entityType?: string | null,
      year: number,
      numOccupied: number,
      numVacant: number,
      numRenovation: number,
      numUnits: number,
      numBuildings: number,
      numProperties: number,
      numServiceRequests: number,
      numAmenities: number,
      numAmenityReservations: number,
      expectedRent: number,
      expectedStayRevenue?: number | null,
      aggregateIncome:  {
        __typename: "IncomeStatement",
        rentRevenue: number,
        stayRevenue?: number | null,
        feeRevenue: number,
        otherRevenue: number,
        totalRevenue: number,
        repairExpenses: number,
        lostRentExpenses: number,
        renovationExpenses: number,
        totalExpenses: number,
        net: number,
        userID?: string | null,
        ownerID?: string | null,
        ownerType?: OwnerType | null,
      },
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetYearRecordsQueryVariables = {
  id: string,
};

export type GetYearRecordsQuery = {
  getYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListYearRecordsQueryVariables = {
  filter?: ModelYearRecordsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListYearRecordsQuery = {
  listYearRecords?:  {
    __typename: "ModelYearRecordsConnection",
    items:  Array< {
      __typename: "YearRecords",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      years?: Array< number | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncYearRecordsQueryVariables = {
  filter?: ModelYearRecordsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncYearRecordsQuery = {
  syncYearRecords?:  {
    __typename: "ModelYearRecordsConnection",
    items:  Array< {
      __typename: "YearRecords",
      id: string,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      years?: Array< number | null > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type PaymentReceiptByTransactionIDQueryVariables = {
  transactionID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentReceiptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaymentReceiptByTransactionIDQuery = {
  paymentReceiptByTransactionID?:  {
    __typename: "ModelPaymentReceiptConnection",
    items:  Array< {
      __typename: "PaymentReceipt",
      id: string,
      transactionID: string,
      status: PaymentReceiptStatus,
      failureReason?: string | null,
      s3Key?: string | null,
      s3Keys?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      signedByUserID?: string | null,
      signedByUserName?: string | null,
      generatedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateAdministratorSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorFilterInput | null,
};

export type OnCreateAdministratorSubscription = {
  onCreateAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdministratorSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorFilterInput | null,
};

export type OnUpdateAdministratorSubscription = {
  onUpdateAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdministratorSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorFilterInput | null,
};

export type OnDeleteAdministratorSubscription = {
  onDeleteAdministrator?:  {
    __typename: "Administrator",
    id: string,
    username: string,
    status: AdministratorStatusType,
    role: AdministratorRoleType,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    address?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAdministratorApproversSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorApproversFilterInput | null,
};

export type OnCreateAdministratorApproversSubscription = {
  onCreateAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdministratorApproversSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorApproversFilterInput | null,
};

export type OnUpdateAdministratorApproversSubscription = {
  onUpdateAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdministratorApproversSubscriptionVariables = {
  filter?: ModelSubscriptionAdministratorApproversFilterInput | null,
};

export type OnDeleteAdministratorApproversSubscription = {
  onDeleteAdministratorApprovers?:  {
    __typename: "AdministratorApprovers",
    id: string,
    userID: string,
    editor: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateFilterInput | null,
};

export type OnCreateAffiliateSubscription = {
  onCreateAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateFilterInput | null,
};

export type OnUpdateAffiliateSubscription = {
  onUpdateAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateFilterInput | null,
};

export type OnDeleteAffiliateSubscription = {
  onDeleteAffiliate?:  {
    __typename: "Affiliate",
    id: string,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    email?: string | null,
    phone?: string | null,
    company?: string | null,
    address?: string | null,
    notes?: string | null,
    code?: string | null,
    status: AffiliateStatusType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliateEarningSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateEarningFilterInput | null,
};

export type OnCreateAffiliateEarningSubscription = {
  onCreateAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliateEarningSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateEarningFilterInput | null,
};

export type OnUpdateAffiliateEarningSubscription = {
  onUpdateAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliateEarningSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateEarningFilterInput | null,
};

export type OnDeleteAffiliateEarningSubscription = {
  onDeleteAffiliateEarning?:  {
    __typename: "AffiliateEarning",
    id: string,
    affiliateID: string,
    linkID: string,
    milestoneKey: string,
    amountCents: number,
    status: AffiliateEarningStatus,
    payoutID?: string | null,
    idempotencyKey: string,
    occurredAt: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateLinkFilterInput | null,
};

export type OnCreateAffiliateLinkSubscription = {
  onCreateAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateLinkFilterInput | null,
};

export type OnUpdateAffiliateLinkSubscription = {
  onUpdateAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateLinkFilterInput | null,
};

export type OnDeleteAffiliateLinkSubscription = {
  onDeleteAffiliateLink?:  {
    __typename: "AffiliateLink",
    id: string,
    ownerID: string,
    ownerType: OwnerType,
    affiliateID: string,
    affiliateCode: string,
    attributedAt: string,
    migratedToOrganizationID?: string | null,
    createdByUserID?: string | null,
    milestones?: string | null,
    unitCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliateMilestoneRateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateMilestoneRateFilterInput | null,
};

export type OnCreateAffiliateMilestoneRateSubscription = {
  onCreateAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliateMilestoneRateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateMilestoneRateFilterInput | null,
};

export type OnUpdateAffiliateMilestoneRateSubscription = {
  onUpdateAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliateMilestoneRateSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateMilestoneRateFilterInput | null,
};

export type OnDeleteAffiliateMilestoneRateSubscription = {
  onDeleteAffiliateMilestoneRate?:  {
    __typename: "AffiliateMilestoneRate",
    id: string,
    milestoneKey: string,
    amountCents: number,
    affiliateID?: string | null,
    currency?: string | null,
    effectiveFrom?: string | null,
    effectiveTo?: string | null,
    isActive: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliatePayoutSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliatePayoutFilterInput | null,
};

export type OnCreateAffiliatePayoutSubscription = {
  onCreateAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliatePayoutSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliatePayoutFilterInput | null,
};

export type OnUpdateAffiliatePayoutSubscription = {
  onUpdateAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliatePayoutSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliatePayoutFilterInput | null,
};

export type OnDeleteAffiliatePayoutSubscription = {
  onDeleteAffiliatePayout?:  {
    __typename: "AffiliatePayout",
    id: string,
    affiliateID: string,
    status: AffiliatePayoutStatus,
    grossCents: number,
    generatedAt: string,
    paidAt?: string | null,
    paymentRef?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAffiliateVisitSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateVisitFilterInput | null,
};

export type OnCreateAffiliateVisitSubscription = {
  onCreateAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAffiliateVisitSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateVisitFilterInput | null,
};

export type OnUpdateAffiliateVisitSubscription = {
  onUpdateAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAffiliateVisitSubscriptionVariables = {
  filter?: ModelSubscriptionAffiliateVisitFilterInput | null,
};

export type OnDeleteAffiliateVisitSubscription = {
  onDeleteAffiliateVisit?:  {
    __typename: "AffiliateVisit",
    id: string,
    affiliateID: string,
    affiliateCode: string,
    visitedAt: string,
    path?: string | null,
    userAgent?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAmenitySubscriptionVariables = {
  filter?: ModelSubscriptionAmenityFilterInput | null,
};

export type OnCreateAmenitySubscription = {
  onCreateAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAmenitySubscriptionVariables = {
  filter?: ModelSubscriptionAmenityFilterInput | null,
};

export type OnUpdateAmenitySubscription = {
  onUpdateAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAmenitySubscriptionVariables = {
  filter?: ModelSubscriptionAmenityFilterInput | null,
};

export type OnDeleteAmenitySubscription = {
  onDeleteAmenity?:  {
    __typename: "Amenity",
    id: string,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    reservationRule:  {
      __typename: "ReservationRule",
      policy: AmenityReservationPolicyOptions,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
      requiresApproval?: boolean | null,
      maxDuration?: string | null,
      minDuration?: string | null,
      furthestTime?: string | null,
      closestTime?: string | null,
      maxPartySize?: number | null,
      maxRequests?: number | null,
    },
    description?: string | null,
    rules?: string | null,
    availability?: Array< string | null > | null,
    geolocation?: string | null,
    locationDescription?: string | null,
    buildingID?: string | null,
    images?: Array< string | null > | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAmenityReservationSubscriptionVariables = {
  filter?: ModelSubscriptionAmenityReservationFilterInput | null,
};

export type OnCreateAmenityReservationSubscription = {
  onCreateAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAmenityReservationSubscriptionVariables = {
  filter?: ModelSubscriptionAmenityReservationFilterInput | null,
};

export type OnUpdateAmenityReservationSubscription = {
  onUpdateAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAmenityReservationSubscriptionVariables = {
  filter?: ModelSubscriptionAmenityReservationFilterInput | null,
};

export type OnDeleteAmenityReservationSubscription = {
  onDeleteAmenityReservation?:  {
    __typename: "AmenityReservation",
    id: string,
    amenityID: string,
    tenantID: string,
    startDate: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    details?: string | null,
    status?: AmenityReservationStatus | null,
    statusReason?: string | null,
    endDate: string,
    reviewer?: string | null,
    partySize?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationFilterInput | null,
};

export type OnCreateApplicationSubscription = {
  onCreateApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationFilterInput | null,
};

export type OnUpdateApplicationSubscription = {
  onUpdateApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteApplicationSubscriptionVariables = {
  filter?: ModelSubscriptionApplicationFilterInput | null,
};

export type OnDeleteApplicationSubscription = {
  onDeleteApplication?:  {
    __typename: "Application",
    id: string,
    status: ApplicationStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    moveInDatePreference?: string | null,
    rentPaymentPreference?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBackgroundCheckSubscriptionVariables = {
  filter?: ModelSubscriptionBackgroundCheckFilterInput | null,
};

export type OnCreateBackgroundCheckSubscription = {
  onCreateBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBackgroundCheckSubscriptionVariables = {
  filter?: ModelSubscriptionBackgroundCheckFilterInput | null,
};

export type OnUpdateBackgroundCheckSubscription = {
  onUpdateBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBackgroundCheckSubscriptionVariables = {
  filter?: ModelSubscriptionBackgroundCheckFilterInput | null,
};

export type OnDeleteBackgroundCheckSubscription = {
  onDeleteBackgroundCheck?:  {
    __typename: "BackgroundCheck",
    id: string,
    status: BackgroundCheckStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnCreateBuildingSubscription = {
  onCreateBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnUpdateBuildingSubscription = {
  onUpdateBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBuildingSubscriptionVariables = {
  filter?: ModelSubscriptionBuildingFilterInput | null,
};

export type OnDeleteBuildingSubscription = {
  onDeleteBuilding?:  {
    __typename: "Building",
    id: string,
    status: BuildingStatusType,
    propertyID: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    rent?: number | null,
    price?: number | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    actualRentPaymentDate?: string | null,
    size?: string | null,
    street?: string | null,
    type?: BuildingType | null,
    contact?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateChargesSubscriptionVariables = {
  filter?: ModelSubscriptionChargesFilterInput | null,
};

export type OnCreateChargesSubscription = {
  onCreateCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateChargesSubscriptionVariables = {
  filter?: ModelSubscriptionChargesFilterInput | null,
};

export type OnUpdateChargesSubscription = {
  onUpdateCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteChargesSubscriptionVariables = {
  filter?: ModelSubscriptionChargesFilterInput | null,
};

export type OnDeleteChargesSubscription = {
  onDeleteCharges?:  {
    __typename: "Charges",
    id: string,
    type: ChargesTypes,
    isRevenue: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCommentsSubscriptionVariables = {
  filter?: ModelSubscriptionCommentsFilterInput | null,
};

export type OnCreateCommentsSubscription = {
  onCreateComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCommentsSubscriptionVariables = {
  filter?: ModelSubscriptionCommentsFilterInput | null,
};

export type OnUpdateCommentsSubscription = {
  onUpdateComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCommentsSubscriptionVariables = {
  filter?: ModelSubscriptionCommentsFilterInput | null,
};

export type OnDeleteCommentsSubscription = {
  onDeleteComments?:  {
    __typename: "Comments",
    id: string,
    commenter: string,
    text: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdDate?: string | null,
    parentID?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEntityFieldSubscriptionVariables = {
  filter?: ModelSubscriptionEntityFieldFilterInput | null,
};

export type OnCreateEntityFieldSubscription = {
  onCreateEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEntityFieldSubscriptionVariables = {
  filter?: ModelSubscriptionEntityFieldFilterInput | null,
};

export type OnUpdateEntityFieldSubscription = {
  onUpdateEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEntityFieldSubscriptionVariables = {
  filter?: ModelSubscriptionEntityFieldFilterInput | null,
};

export type OnDeleteEntityFieldSubscription = {
  onDeleteEntityField?:  {
    __typename: "EntityField",
    id: string,
    entityID: string,
    entityType: string,
    name: string,
    type: EntityFieldType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    value?: string | null,
    date?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    id: string,
    entityType: EntityType,
    entityID: string,
    ownerID: string,
    ownerType: OwnerType,
    name: string,
    date?: string | null,
    type?: string | null,
    comment?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionFavoriteFilterInput | null,
};

export type OnCreateFavoriteSubscription = {
  onCreateFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionFavoriteFilterInput | null,
};

export type OnUpdateFavoriteSubscription = {
  onUpdateFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFavoriteSubscriptionVariables = {
  filter?: ModelSubscriptionFavoriteFilterInput | null,
};

export type OnDeleteFavoriteSubscription = {
  onDeleteFavorite?:  {
    __typename: "Favorite",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    favType?: string | null,
    favID?: string | null,
    image?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFinanceLockSubscriptionVariables = {
  filter?: ModelSubscriptionFinanceLockFilterInput | null,
};

export type OnCreateFinanceLockSubscription = {
  onCreateFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFinanceLockSubscriptionVariables = {
  filter?: ModelSubscriptionFinanceLockFilterInput | null,
};

export type OnUpdateFinanceLockSubscription = {
  onUpdateFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFinanceLockSubscriptionVariables = {
  filter?: ModelSubscriptionFinanceLockFilterInput | null,
};

export type OnDeleteFinanceLockSubscription = {
  onDeleteFinanceLock?:  {
    __typename: "FinanceLock",
    id: string,
    scope: string,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: EntityType | null,
    year: number,
    month?: number | null,
    lockUnixTTL?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateJoinOrganizationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionJoinOrganizationRequestFilterInput | null,
};

export type OnCreateJoinOrganizationRequestSubscription = {
  onCreateJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateJoinOrganizationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionJoinOrganizationRequestFilterInput | null,
};

export type OnUpdateJoinOrganizationRequestSubscription = {
  onUpdateJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteJoinOrganizationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionJoinOrganizationRequestFilterInput | null,
};

export type OnDeleteJoinOrganizationRequestSubscription = {
  onDeleteJoinOrganizationRequest?:  {
    __typename: "JoinOrganizationRequest",
    id: string,
    userID: string,
    requestStatus: JoinOrganizationRequestStatus,
    organizationID?: string | null,
    requestPropertyTransfer?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnCreateLeaseSubscription = {
  onCreateLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnUpdateLeaseSubscription = {
  onUpdateLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLeaseSubscriptionVariables = {
  filter?: ModelSubscriptionLeaseFilterInput | null,
};

export type OnDeleteLeaseSubscription = {
  onDeleteLease?:  {
    __typename: "Lease",
    id: string,
    entityType: EntityType,
    entityID: string,
    type: LeaseTypeOptions,
    status: LeaseStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    tenantID?: string | null,
    startDate?: string | null,
    endDate?: string | null,
    markedDate?: string | null,
    extraOccupants?: Array< string | null > | null,
    applicationID?: string | null,
    backgroundCheckID?: string | null,
    offerID?: string | null,
    moveInID?: string | null,
    moveOutID?: string | null,
    nextLeaseID?: string | null,
    prevLeaseID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnCreateMessageSubscription = {
  onCreateMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnUpdateMessageSubscription = {
  onUpdateMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnDeleteMessageSubscription = {
  onDeleteMessage?:  {
    __typename: "Message",
    id: string,
    title: string,
    content: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    senderID?: string | null,
    senderName?: string | null,
    receiverID?: string | null,
    receiverName?: string | null,
    messageTitle?: string | null,
    type?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMonthlyFinanceReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyFinanceReportFilterInput | null,
};

export type OnCreateMonthlyFinanceReportSubscription = {
  onCreateMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMonthlyFinanceReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyFinanceReportFilterInput | null,
};

export type OnUpdateMonthlyFinanceReportSubscription = {
  onUpdateMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMonthlyFinanceReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyFinanceReportFilterInput | null,
};

export type OnDeleteMonthlyFinanceReportSubscription = {
  onDeleteMonthlyFinanceReport?:  {
    __typename: "MonthlyFinanceReport",
    id: string,
    yearlyReportId: string,
    month: number,
    year: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMonthlyStatusReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyStatusReportFilterInput | null,
};

export type OnCreateMonthlyStatusReportSubscription = {
  onCreateMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMonthlyStatusReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyStatusReportFilterInput | null,
};

export type OnUpdateMonthlyStatusReportSubscription = {
  onUpdateMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMonthlyStatusReportSubscriptionVariables = {
  filter?: ModelSubscriptionMonthlyStatusReportFilterInput | null,
};

export type OnDeleteMonthlyStatusReportSubscription = {
  onDeleteMonthlyStatusReport?:  {
    __typename: "MonthlyStatusReport",
    id: string,
    entityID?: string | null,
    entityType?: string | null,
    month: number,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMoveExamSubscriptionVariables = {
  filter?: ModelSubscriptionMoveExamFilterInput | null,
};

export type OnCreateMoveExamSubscription = {
  onCreateMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMoveExamSubscriptionVariables = {
  filter?: ModelSubscriptionMoveExamFilterInput | null,
};

export type OnUpdateMoveExamSubscription = {
  onUpdateMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMoveExamSubscriptionVariables = {
  filter?: ModelSubscriptionMoveExamFilterInput | null,
};

export type OnDeleteMoveExamSubscription = {
  onDeleteMoveExam?:  {
    __typename: "MoveExam",
    id: string,
    type: MoveExamType,
    status: MoveExamStatusType,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    endDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateOfferSubscriptionVariables = {
  filter?: ModelSubscriptionOfferFilterInput | null,
};

export type OnCreateOfferSubscription = {
  onCreateOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateOfferSubscriptionVariables = {
  filter?: ModelSubscriptionOfferFilterInput | null,
};

export type OnUpdateOfferSubscription = {
  onUpdateOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteOfferSubscriptionVariables = {
  filter?: ModelSubscriptionOfferFilterInput | null,
};

export type OnDeleteOfferSubscription = {
  onDeleteOffer?:  {
    __typename: "Offer",
    id: string,
    status: OfferStatusType,
    rent: number,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    startDate?: string | null,
    tenantSignDate?: string | null,
    landlordSignDate?: string | null,
    endDate?: string | null,
    rentCycle?: RentCycle | null,
    normalizedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnCreateOrganizationSubscription = {
  onCreateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnUpdateOrganizationSubscription = {
  onUpdateOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnDeleteOrganizationSubscription = {
  onDeleteOrganization?:  {
    __typename: "Organization",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateParcelSubscriptionVariables = {
  filter?: ModelSubscriptionParcelFilterInput | null,
};

export type OnCreateParcelSubscription = {
  onCreateParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateParcelSubscriptionVariables = {
  filter?: ModelSubscriptionParcelFilterInput | null,
};

export type OnUpdateParcelSubscription = {
  onUpdateParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteParcelSubscriptionVariables = {
  filter?: ModelSubscriptionParcelFilterInput | null,
};

export type OnDeleteParcelSubscription = {
  onDeleteParcel?:  {
    __typename: "Parcel",
    id: string,
    propertyID: string,
    status: ParcelStatusType,
    name: string,
    description?: string | null,
    areaSize?: string | null,
    boundaryNote?: string | null,
    rent?: number | null,
    price?: number | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePaymentReceiptSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentReceiptFilterInput | null,
};

export type OnCreatePaymentReceiptSubscription = {
  onCreatePaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePaymentReceiptSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentReceiptFilterInput | null,
};

export type OnUpdatePaymentReceiptSubscription = {
  onUpdatePaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePaymentReceiptSubscriptionVariables = {
  filter?: ModelSubscriptionPaymentReceiptFilterInput | null,
};

export type OnDeletePaymentReceiptSubscription = {
  onDeletePaymentReceipt?:  {
    __typename: "PaymentReceipt",
    id: string,
    transactionID: string,
    status: PaymentReceiptStatus,
    failureReason?: string | null,
    s3Key?: string | null,
    s3Keys?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    signedByUserID?: string | null,
    signedByUserName?: string | null,
    generatedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnCreatePropertySubscription = {
  onCreateProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnUpdatePropertySubscription = {
  onUpdateProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnDeletePropertySubscription = {
  onDeleteProperty?:  {
    __typename: "Property",
    id: string,
    name: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    areaSize?: string | null,
    street?: string | null,
    city?: string | null,
    state?: string | null,
    country?: string | null,
    zipCode?: string | null,
    contact?: string | null,
    expectedRentPaymentDate?: string | null,
    poBox?: string | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateResourceLifeAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceLifeAccessRightFilterInput | null,
};

export type OnCreateResourceLifeAccessRightSubscription = {
  onCreateResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateResourceLifeAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceLifeAccessRightFilterInput | null,
};

export type OnUpdateResourceLifeAccessRightSubscription = {
  onUpdateResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteResourceLifeAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceLifeAccessRightFilterInput | null,
};

export type OnDeleteResourceLifeAccessRightSubscription = {
  onDeleteResourceLifeAccessRight?:  {
    __typename: "ResourceLifeAccessRight",
    id: string,
    resourceType: EntityType,
    createAccessStatus: ResourceAccessRightStatus,
    createAccessApproverID?: string | null,
    createAccessApprovalDate?: string | null,
    deleteAccessStatus: ResourceAccessRightStatus,
    deleteAccessApproverID?: string | null,
    deleteAccessApprovalDate?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateResourceUpdateAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUpdateAccessRightFilterInput | null,
};

export type OnCreateResourceUpdateAccessRightSubscription = {
  onCreateResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateResourceUpdateAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUpdateAccessRightFilterInput | null,
};

export type OnUpdateResourceUpdateAccessRightSubscription = {
  onUpdateResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteResourceUpdateAccessRightSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUpdateAccessRightFilterInput | null,
};

export type OnDeleteResourceUpdateAccessRightSubscription = {
  onDeleteResourceUpdateAccessRight?:  {
    __typename: "ResourceUpdateAccessRight",
    id: string,
    resourceType: EntityType,
    resourceID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    readAccessStatus: ResourceAccessRightStatus,
    readAccessApproverID?: string | null,
    readAccessApprovalDate?: string | null,
    writeAccessStatus: ResourceAccessRightStatus,
    writeAccessApproverID?: string | null,
    writeAccessApprovalDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateServiceRequestSubscriptionVariables = {
  filter?: ModelSubscriptionServiceRequestFilterInput | null,
};

export type OnCreateServiceRequestSubscription = {
  onCreateServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateServiceRequestSubscriptionVariables = {
  filter?: ModelSubscriptionServiceRequestFilterInput | null,
};

export type OnUpdateServiceRequestSubscription = {
  onUpdateServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteServiceRequestSubscriptionVariables = {
  filter?: ModelSubscriptionServiceRequestFilterInput | null,
};

export type OnDeleteServiceRequestSubscription = {
  onDeleteServiceRequest?:  {
    __typename: "ServiceRequest",
    id: string,
    entityID: string,
    entityType: string,
    creatorID: string,
    description: string,
    title: string,
    type: ServiceRequestType,
    isUpgrade: boolean,
    status: ServiceRequestStatusType,
    emergency: boolean,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    creatorName?: string | null,
    handlerID?: string | null,
    handlerName?: string | null,
    watcherID?: string | null,
    watcherName?: string | null,
    tenantID?: string | null,
    tenantName?: string | null,
    contractor?: string | null,
    dateCreated?: string | null,
    dateUpdated?: string | null,
    estimatedCost?: number | null,
    finalCost?: number | null,
    images?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateStaySubscriptionVariables = {
  filter?: ModelSubscriptionStayFilterInput | null,
};

export type OnCreateStaySubscription = {
  onCreateStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateStaySubscriptionVariables = {
  filter?: ModelSubscriptionStayFilterInput | null,
};

export type OnUpdateStaySubscription = {
  onUpdateStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteStaySubscriptionVariables = {
  filter?: ModelSubscriptionStayFilterInput | null,
};

export type OnDeleteStaySubscription = {
  onDeleteStay?:  {
    __typename: "Stay",
    id: string,
    entityType: EntityType,
    entityID: string,
    checkIn: string,
    checkOut: string,
    status: StayStatusType,
    tenantID: string,
    nightlyRate?: number | null,
    totalAmount?: number | null,
    currency?: string | null,
    notes?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateStayRateSubscriptionVariables = {
  filter?: ModelSubscriptionStayRateFilterInput | null,
};

export type OnCreateStayRateSubscription = {
  onCreateStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateStayRateSubscriptionVariables = {
  filter?: ModelSubscriptionStayRateFilterInput | null,
};

export type OnUpdateStayRateSubscription = {
  onUpdateStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteStayRateSubscriptionVariables = {
  filter?: ModelSubscriptionStayRateFilterInput | null,
};

export type OnDeleteStayRateSubscription = {
  onDeleteStayRate?:  {
    __typename: "StayRate",
    id: string,
    entityType: EntityType,
    entityID: string,
    nightlyRate: number,
    weeklyRate?: number | null,
    minNights?: number | null,
    maxNights?: number | null,
    cleaningFee?: number | null,
    currency?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateStayAvailabilitySubscriptionVariables = {
  filter?: ModelSubscriptionStayAvailabilityFilterInput | null,
};

export type OnCreateStayAvailabilitySubscription = {
  onCreateStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateStayAvailabilitySubscriptionVariables = {
  filter?: ModelSubscriptionStayAvailabilityFilterInput | null,
};

export type OnUpdateStayAvailabilitySubscription = {
  onUpdateStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteStayAvailabilitySubscriptionVariables = {
  filter?: ModelSubscriptionStayAvailabilityFilterInput | null,
};

export type OnDeleteStayAvailabilitySubscription = {
  onDeleteStayAvailability?:  {
    __typename: "StayAvailability",
    id: string,
    entityType: EntityType,
    entityID: string,
    start: string,
    end: string,
    reason?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSubscriptionDiscountSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountFilterInput | null,
};

export type OnCreateSubscriptionDiscountSubscription = {
  onCreateSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSubscriptionDiscountSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountFilterInput | null,
};

export type OnUpdateSubscriptionDiscountSubscription = {
  onUpdateSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSubscriptionDiscountSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountFilterInput | null,
};

export type OnDeleteSubscriptionDiscountSubscription = {
  onDeleteSubscriptionDiscount?:  {
    __typename: "SubscriptionDiscount",
    id: string,
    planID: string,
    startDate: string,
    endDate: string,
    percentage: number,
    isActive: boolean,
    codeID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSubscriptionDiscountCodeSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountCodeFilterInput | null,
};

export type OnCreateSubscriptionDiscountCodeSubscription = {
  onCreateSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSubscriptionDiscountCodeSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountCodeFilterInput | null,
};

export type OnUpdateSubscriptionDiscountCodeSubscription = {
  onUpdateSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSubscriptionDiscountCodeSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionDiscountCodeFilterInput | null,
};

export type OnDeleteSubscriptionDiscountCodeSubscription = {
  onDeleteSubscriptionDiscountCode?:  {
    __typename: "SubscriptionDiscountCode",
    id: string,
    code: string,
    userID?: string | null,
    usageCount?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSubscriptionLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionLinkFilterInput | null,
};

export type OnCreateSubscriptionLinkSubscription = {
  onCreateSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSubscriptionLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionLinkFilterInput | null,
};

export type OnUpdateSubscriptionLinkSubscription = {
  onUpdateSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSubscriptionLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionLinkFilterInput | null,
};

export type OnDeleteSubscriptionLinkSubscription = {
  onDeleteSubscriptionLink?:  {
    __typename: "SubscriptionLink",
    id: string,
    userID: string,
    planID: string,
    startDate: string,
    endDate: string,
    renewalType: SubscriptionRenewalType,
    autoRenewal: boolean,
    nextPaymentAmount: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSubscriptionPlanSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionPlanFilterInput | null,
};

export type OnCreateSubscriptionPlanSubscription = {
  onCreateSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSubscriptionPlanSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionPlanFilterInput | null,
};

export type OnUpdateSubscriptionPlanSubscription = {
  onUpdateSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSubscriptionPlanSubscriptionVariables = {
  filter?: ModelSubscriptionSubscriptionPlanFilterInput | null,
};

export type OnDeleteSubscriptionPlanSubscription = {
  onDeleteSubscriptionPlan?:  {
    __typename: "SubscriptionPlan",
    id: string,
    name: string,
    description: string,
    price: number,
    isActive: boolean,
    features: Array< SubscriptionPlanFeature | null >,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTenantSubscriptionVariables = {
  filter?: ModelSubscriptionTenantFilterInput | null,
};

export type OnCreateTenantSubscription = {
  onCreateTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTenantSubscriptionVariables = {
  filter?: ModelSubscriptionTenantFilterInput | null,
};

export type OnUpdateTenantSubscription = {
  onUpdateTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTenantSubscriptionVariables = {
  filter?: ModelSubscriptionTenantFilterInput | null,
};

export type OnDeleteTenantSubscription = {
  onDeleteTenant?:  {
    __typename: "Tenant",
    id: string,
    authUID?: string | null,
    username?: string | null,
    firstName: string,
    middleName?: string | null,
    lastName: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    status?: TenantStatusType | null,
    type?: TenantType | null,
    phoneNumber?: string | null,
    jobTitle?: string | null,
    jobPhone?: string | null,
    jobEmail?: string | null,
    jobContactName?: string | null,
    income?: string | null,
    cimesCommitted?: string | null,
    jailTime?: string | null,
    lastArrest?: string | null,
    lastUpdated?: string | null,
    totalCredit?: string | null,
    employer?: string | null,
    email?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    amount: number,
    reason: TransactionReason,
    currency?: string | null,
    entityID: string,
    entityType: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    month: number,
    year: number,
    periodStart?: string | null,
    periodEnd?: string | null,
    tenantID: string,
    managerID: string,
    status: PaymentStatusType,
    dateSent?: string | null,
    dateReceived?: string | null,
    paymentMethod?: RentPaymentMethodType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUnitPlanFilterInput | null,
};

export type OnCreateUnitPlanSubscription = {
  onCreateUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUnitPlanFilterInput | null,
};

export type OnUpdateUnitPlanSubscription = {
  onUpdateUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitPlanSubscriptionVariables = {
  filter?: ModelSubscriptionUnitPlanFilterInput | null,
};

export type OnDeleteUnitPlanSubscription = {
  onDeleteUnitPlan?:  {
    __typename: "UnitPlan",
    id: string,
    propertyID: string,
    name: string,
    description?: string | null,
    numBedroom?: string | null,
    numBathroom?: string | null,
    size?: string | null,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnCreateUnitSubscription = {
  onCreateUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnUpdateUnitSubscription = {
  onUpdateUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUnitSubscriptionVariables = {
  filter?: ModelSubscriptionUnitFilterInput | null,
};

export type OnDeleteUnitSubscription = {
  onDeleteUnit?:  {
    __typename: "Unit",
    id: string,
    status: UnitStatusType,
    name: string,
    rent: number,
    price?: number | null,
    numBedroom: string,
    numBathroom: string,
    buildingID: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    description?: string | null,
    availabilityDate?: string | null,
    actualRentPaymentDate?: string | null,
    activeLeaseID?: string | null,
    type?: string | null,
    unitPlanID?: string | null,
    size?: string | null,
    street?: string | null,
    deposit?: number | null,
    additionalFees?: number | null,
    feesDescription?: string | null,
    tenantID?: string | null,
    contact?: string | null,
    inUnitLaundry?: boolean | null,
    dishwasher?: boolean | null,
    airConditioning?: boolean | null,
    furnished?: boolean | null,
    balcony?: boolean | null,
    petFriendly?: boolean | null,
    shortTermStayEnabled?: boolean | null,
    forSaleEnabled?: boolean | null,
    stayRequireApproval?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    authUID?: string | null,
    username?: string | null,
    title?: string | null,
    type?: string | null,
    firstName?: string | null,
    middleName?: string | null,
    lastName?: string | null,
    salary?: string | null,
    companyName?: string | null,
    phoneNumber?: string | null,
    email?: string | null,
    officeAddress?: string | null,
    workingHours?: Array< string | null > | null,
    roles?: ManagerRolesType | null,
    organizationID?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserOrganizationConnectionSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationConnectionFilterInput | null,
};

export type OnCreateUserOrganizationConnectionSubscription = {
  onCreateUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserOrganizationConnectionSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationConnectionFilterInput | null,
};

export type OnUpdateUserOrganizationConnectionSubscription = {
  onUpdateUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserOrganizationConnectionSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationConnectionFilterInput | null,
};

export type OnDeleteUserOrganizationConnectionSubscription = {
  onDeleteUserOrganizationConnection?:  {
    __typename: "UserOrganizationConnection",
    id: string,
    userID?: string | null,
    username?: string | null,
    creatorID?: string | null,
    creatorName?: string | null,
    organizationID?: string | null,
    managerID?: string | null,
    managerName?: string | null,
    title?: string | null,
    salary?: string | null,
    ownershipType?: string | null,
    clearanceLevel?: string | null,
    joinedDate?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateYearlyReportSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyReportSummaryFilterInput | null,
};

export type OnCreateYearlyReportSummarySubscription = {
  onCreateYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateYearlyReportSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyReportSummaryFilterInput | null,
};

export type OnUpdateYearlyReportSummarySubscription = {
  onUpdateYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteYearlyReportSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyReportSummaryFilterInput | null,
};

export type OnDeleteYearlyReportSummarySubscription = {
  onDeleteYearlyReportSummary?:  {
    __typename: "YearlyReportSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    year: number,
    entityID?: string | null,
    entityType?: string | null,
    income?:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateYearlyStatusSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyStatusSummaryFilterInput | null,
};

export type OnCreateYearlyStatusSummarySubscription = {
  onCreateYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateYearlyStatusSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyStatusSummaryFilterInput | null,
};

export type OnUpdateYearlyStatusSummarySubscription = {
  onUpdateYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteYearlyStatusSummarySubscriptionVariables = {
  filter?: ModelSubscriptionYearlyStatusSummaryFilterInput | null,
};

export type OnDeleteYearlyStatusSummarySubscription = {
  onDeleteYearlyStatusSummary?:  {
    __typename: "YearlyStatusSummary",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    entityID?: string | null,
    entityType?: string | null,
    year: number,
    numOccupied: number,
    numVacant: number,
    numRenovation: number,
    numUnits: number,
    numBuildings: number,
    numProperties: number,
    numServiceRequests: number,
    numAmenities: number,
    numAmenityReservations: number,
    expectedRent: number,
    expectedStayRevenue?: number | null,
    aggregateIncome:  {
      __typename: "IncomeStatement",
      rentRevenue: number,
      stayRevenue?: number | null,
      feeRevenue: number,
      otherRevenue: number,
      totalRevenue: number,
      repairExpenses: number,
      lostRentExpenses: number,
      renovationExpenses: number,
      totalExpenses: number,
      net: number,
      userID?: string | null,
      ownerID?: string | null,
      ownerType?: OwnerType | null,
    },
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateYearRecordsSubscriptionVariables = {
  filter?: ModelSubscriptionYearRecordsFilterInput | null,
};

export type OnCreateYearRecordsSubscription = {
  onCreateYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateYearRecordsSubscriptionVariables = {
  filter?: ModelSubscriptionYearRecordsFilterInput | null,
};

export type OnUpdateYearRecordsSubscription = {
  onUpdateYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteYearRecordsSubscriptionVariables = {
  filter?: ModelSubscriptionYearRecordsFilterInput | null,
};

export type OnDeleteYearRecordsSubscription = {
  onDeleteYearRecords?:  {
    __typename: "YearRecords",
    id: string,
    userID?: string | null,
    ownerID?: string | null,
    ownerType?: OwnerType | null,
    years?: Array< number | null > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
